import { Badge, Pane, Text } from "evergreen-ui";
import React, { useEffect, useState } from "react";
import { FaCheck, FaRegMoneyBillAlt } from "react-icons/fa";
import { dates } from "./datanurse";

function StatusDisplay({ data }) {
  const [DataRegister, setDataRegister] = useState();
  const [ListMajor, setListMajor] = useState([]);
  const GetListMajor = (DATAREGISTER) => {
    const List = [];
    DATAREGISTER.forEach((items) => {
      if (items.Major1_MAJOR_ID !== null) {
        List.push({
          Major_LEVEL_OPEN_ID: items.Major1_LEVEL_OPEN_ID,
          Major_LEVEL_OPEN_NAME: items.Major1_LEVEL_OPEN_NAME,
          Major_MAJOR_CLASSROOM: items.Major1_MAJOR_CLASSROOM,
          Major_MAJOR_CLASSROOM2: items.Major1_MAJOR_CLASSROOM2,
          Major_MAJOR_CLASSROOM3: items.Major1_MAJOR_CLASSROOM3,
          Major_MAJOR_ID: items.Major1_MAJOR_ID,
          Major_MAJOR_NAME: items.Major1_MAJOR_NAME,
          Major_course_year: items.Major1_course_year,
          Major_course_year_id: items.Major1_course_year_id,
          Major_course_year_name: items.Major1_course_year_name,
          Major_faculty_name: items.Major1_faculty_name,
          REGISTER_TYPE_ID: items.REGISTER_TYPE_ID,
          REGISTER_ID: items.REGISTER_ID,
          ROB_ID: items.ROB_ID,
          REGISTER_STATUS_BILL_ROBFULL_BOOK: items.REGISTER_STATUS_BILL_ROBFULL_BOOK,
          REGISTER_STATUS_BILL_ROB1_BOOK: items.REGISTER_STATUS_BILL_ROB1_BOOK,
          REGISTER_STATUS_BILL_ROB1_NO: items.REGISTER_STATUS_BILL_ROB1_NO,
          REGISTER_STATUS_BILL_ROB1_COUNT: items.REGISTER_STATUS_BILL_ROB1_COUNT,
          REGISTER_STATUS_BILL_ROB2_BOOK: items.REGISTER_STATUS_BILL_ROB2_BOOK,
          REGISTER_STATUS_BILL_ROB2_NO: items.REGISTER_STATUS_BILL_ROB2_NO,
          REGISTER_STATUS_BILL_ROB2_COUNT: items.REGISTER_STATUS_BILL_ROB2_COUNT,
          ROB_YEAR: items.ROB_YEAR,
          REGISTER_STATUS_BILL_ROBFULL_NO: items.REGISTER_STATUS_BILL_ROBFULL_NO,
          REGISTER_STATUS_BILL_ROBFULL_COUNT: items.REGISTER_STATUS_BILL_ROBFULL_COUNT,
          CITIZEN: items.CITIZENT_LOGIN,
          REGISTER_STATUS: items.REGISTER_STATUS,
        });
      }
      if (items.Major2_MAJOR_ID !== null) {
        List.push({
          Major_LEVEL_OPEN_ID: items.Major2_LEVEL_OPEN_ID,
          Major_LEVEL_OPEN_NAME: items.Major2_LEVEL_OPEN_NAME,
          Major_MAJOR_CLASSROOM: items.Major2_MAJOR_CLASSROOM,
          Major_MAJOR_CLASSROOM2: items.Major2_MAJOR_CLASSROOM2,
          Major_MAJOR_CLASSROOM3: items.Major2_MAJOR_CLASSROOM3,
          Major_MAJOR_ID: items.Major2_MAJOR_ID,
          Major_MAJOR_NAME: items.Major2_MAJOR_NAME,
          Major_course_year: items.Major2_course_year,
          Major_course_year_id: items.Major2_course_year_id,
          Major_course_year_name: items.Major2_course_year_name,
          Major_faculty_name: items.Major2_faculty_name,
          REGISTER_TYPE_ID: items.REGISTER_TYPE_ID,
          REGISTER_ID: items.REGISTER_ID,
          ROB_ID: items.ROB_ID,
          REGISTER_STATUS_BILL_ROBFULL_BOOK: items.REGISTER_STATUS_BILL_ROBFULL_BOOK,
          REGISTER_STATUS_BILL_ROB1_BOOK: items.REGISTER_STATUS_BILL_ROB1_BOOK,
          REGISTER_STATUS_BILL_ROB1_NO: items.REGISTER_STATUS_BILL_ROB1_NO,
          REGISTER_STATUS_BILL_ROB1_COUNT: items.REGISTER_STATUS_BILL_ROB1_COUNT,
          REGISTER_STATUS_BILL_ROB2_BOOK: items.REGISTER_STATUS_BILL_ROB2_BOOK,
          REGISTER_STATUS_BILL_ROB2_NO: items.REGISTER_STATUS_BILL_ROB2_NO,
          REGISTER_STATUS_BILL_ROB2_COUNT: items.REGISTER_STATUS_BILL_ROB2_COUNT,
          ROB_YEAR: items.ROB_YEAR,
          REGISTER_STATUS_BILL_ROBFULL_NO: items.REGISTER_STATUS_BILL_ROBFULL_NO,
          REGISTER_STATUS_BILL_ROBFULL_COUNT: items.REGISTER_STATUS_BILL_ROBFULL_COUNT,
          CITIZEN: items.CITIZENT_LOGIN,
          REGISTER_STATUS: items.REGISTER_STATUS,
        });
      }
      if (items.Major3_MAJOR_ID !== null) {
        List.push({
          Major_LEVEL_OPEN_ID: items.Major3_LEVEL_OPEN_ID,
          Major_LEVEL_OPEN_NAME: items.Major3_LEVEL_OPEN_NAME,
          Major_MAJOR_CLASSROOM: items.Major3_MAJOR_CLASSROOM,
          Major_MAJOR_CLASSROOM2: items.Major3_MAJOR_CLASSROOM2,
          Major_MAJOR_CLASSROOM3: items.Major3_MAJOR_CLASSROOM3,
          Major_MAJOR_ID: items.Major3_MAJOR_ID,
          Major_MAJOR_NAME: items.Major3_MAJOR_NAME,
          Major_course_year: items.Major3_course_year,
          Major_course_year_id: items.Major3_course_year_id,
          Major_course_year_name: items.Major3_course_year_name,
          Major_faculty_name: items.Major3_faculty_name,
          REGISTER_TYPE_ID: items.REGISTER_TYPE_ID,
          REGISTER_ID: items.REGISTER_ID,
          ROB_ID: items.ROB_ID,
          REGISTER_STATUS_BILL_ROBFULL_BOOK: items.REGISTER_STATUS_BILL_ROBFULL_BOOK,
          REGISTER_STATUS_BILL_ROB1_BOOK: items.REGISTER_STATUS_BILL_ROB1_BOOK,
          REGISTER_STATUS_BILL_ROB1_NO: items.REGISTER_STATUS_BILL_ROB1_NO,
          REGISTER_STATUS_BILL_ROB1_COUNT: items.REGISTER_STATUS_BILL_ROB1_COUNT,
          REGISTER_STATUS_BILL_ROB2_BOOK: items.REGISTER_STATUS_BILL_ROB2_BOOK,
          REGISTER_STATUS_BILL_ROB2_NO: items.REGISTER_STATUS_BILL_ROB2_NO,
          REGISTER_STATUS_BILL_ROB2_COUNT: items.REGISTER_STATUS_BILL_ROB2_COUNT,
          ROB_YEAR: items.ROB_YEAR,
          REGISTER_STATUS_BILL_ROBFULL_NO: items.REGISTER_STATUS_BILL_ROBFULL_NO,
          REGISTER_STATUS_BILL_ROBFULL_COUNT: items.REGISTER_STATUS_BILL_ROBFULL_COUNT,
          CITIZEN: items.CITIZENT_LOGIN,
          REGISTER_STATUS: items.REGISTER_STATUS,
        });
      }
    });
    setListMajor(List);
  };

  useEffect(() => {
    const DATAREGISTER = Array(data);
    setDataRegister(DATAREGISTER);
    GetListMajor(DATAREGISTER);
    AllowPayNurse("159");
  }, [data]);
  const AllowPayNurse = (ROB) => {
    let [day, month, year] = dates;
    if (parseInt(year) > 2400) {
      year = (parseInt(year) - 543).toString();
    }
    const textDate = `${month}/${day}/${year} 23:59`;
    const enddate = new Date(textDate);
    const datenow = new Date();
    if (datenow > enddate) {
      console.log("มากกว่า");
      return true;
    } else {
      console.log("น้อยกว่า");
      return false;
    }
  };
  const ShowListTo = () => {
    const textDate = `08/18/2025 18:00`;
    const start = new Date(textDate);
    const datenow = new Date();
    if (datenow > start) {
      return true;
    } else {
      return false;
    }
  };

  const validCodes = [
    "1101",
    "1102",
    "1103",
    "1106",
    "1110",
    "1207",
    "1208",
    "1301",
    "1302",
    "1304",
    "1310",
  ];

  return (
    Array.isArray(DataRegister) &&
    (DataRegister[0].REGISTER_STATUS === "12" ? (
      <>
        <Pane
          minWidth={320}
          maxWidth={650}
          flexDirection={"column"}
          justifyContent={"center"}
          gap={10}
        >
          <Pane>
            <Badge color="red" height="100%" paddingY={4} paddingX={5} fontSize={16} fontFamily="">
              ไม่ผ่านเกณฑ์การสมัคร
            </Badge>
          </Pane>
        </Pane>
        {ListMajor.map((item, key) => (
          <>
            <Pane marginBottom={10} padding={10} borderRadius={8} key={key}>
              <Pane fontWeight={600}>
                <Text fontWeight={700} style={{ color: "#fe7f2d" }}>
                  ลำดับที่ {key + 1}
                </Text>
                &nbsp; หลักสูตร
                {item.Major_LEVEL_OPEN_NAME +
                  " " +
                  item.Major_course_year +
                  " ปี  " +
                  item.Major_MAJOR_ID +
                  " : สาขาวิชา" +
                  item.Major_MAJOR_NAME}
              </Pane>
              {DataRegister[0].REGISTER_STATUS === "0" ? (
                <>
                  {key + 1 === 1 && (
                    <Text marginTop={10} marginLeft={15} className="text-warning">
                      รอการชำระเงินค่าสมัคร
                    </Text>
                  )}
                </>
              ) : DataRegister[0].REGISTER_STATUS === "1" ? (
                <>
                  {key + 1 === 1 ? (
                    <>
                      <Text marginTop={10} marginLeft={15} className="text-success">
                        {item.Major_MAJOR_ID === "8201"
                          ? " รอประกาศรายชื่อผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์ และพิมพ์ใบสมัคร ในวันที่ 31 มกราคม 2567 เวลา 18:00 น. เป็นต้นไป"
                          : " รอประกาศรายชื่อผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์ และพิมพ์ใบสมัคร ในวันที่ 18 มีนาคม 2568 เวลา 18:00 น. เป็นต้นไป"}
                      </Text>
                    </>
                  ) : (
                    <></>
                  )}
                </>
              ) : (
                <></>
              )}
            </Pane>
          </>
        ))}
        <Pane marginTop={20} display="flex" flexDirection="column">
          <Text color="red">หมายเหตุ*</Text>
          <Text hidden={DataRegister[0].REGISTER_ORDER_NUMBER === null} fontSize={"12px"}>
            1. ประกาศผลการคัดเลือก (ตัวสำรอง) ในวันที่ 7 มกราคม 2568 เวลา 10.00 น.
          </Text>
          <Text fontSize={"12px"}>
            {DataRegister[0].REGISTER_ORDER_NUMBER === null ? "1." : "2."} เปิดรับสมัครรอบ 2 ตั้งแต่วันที่ 11 กุมภาพันธ์ 2569 - 22 มีนาคม 2569
          </Text>
        </Pane>
      </>
    ) : DataRegister[0].REGISTER_STATUS === "11" ? (
      <>
        {DataRegister[0].REGISTER_ORDER_NUMBER === null ? (
          <>
            <Pane
              padding={10}
              backgroundColor="#bb3e0320"
              borderRadius={8}
              display="flex"
              flexDirection="column"
            >
              <Text color="#bb3e03">ไม่ผ่านการคัดเลือก &nbsp;{DataRegister[0].QUOTA_NAME} </Text>
              <Text color="#bb3e03">{DataRegister[0].Major1_faculty_name} </Text>
              <Text color="#bb3e03">{" หลักสูตร " + DataRegister[0].Major1_LEVEL_OPEN_NAME} </Text>
              <Text color="#bb3e03">
                {DataRegister[0].Major1_MAJOR_ID + " : " + DataRegister[0].Major1_MAJOR_NAME}
              </Text>
            </Pane>
            <Pane display="flex" flexDirection="column">
              <Text color="red">หมายเหตุ*</Text>
              <Text fontSize={"12px"}>1. ติดต่อสอบถามการสมัครเรียน โทร. 055-706547</Text>
              { }
              <Text fontSize={"12px"}>
                2. เปิดรับสมัครรอบ 4 ตั้งแต่วันที่ 19 พฤษภาคม 2568 - 8 มิถุนายน 2568
              </Text>
            </Pane>
          </>
        ) : (
          <>
            <Pane
              hidden={DataRegister[0].REGISTER_ORDER_NUMBER === null}
              color="#8a2846"
              backgroundColor="#ffe5ec"
              height="100%"
              paddingY={4}
              paddingX={5}
              fontSize={14}
              fontFamily=""
              margin={0}
              marginTop={0}
              fontWeight={700}
            >
              ผ่านการคัดเลือกเป็น {DataRegister[0].REGISTER_ORDER}
            </Pane>
            {DataRegister[0].ROB_ID === "159" ? (
              <>
                <Pane display="flex" flexDirection="column">
                  <Text color="red">หมายเหตุ*</Text>
                  <Text fontSize={"12px"}>
                    1. ประกาศผลการคัดเลือก (ตัวสำรอง) วันที่ 21 มีนาคม 2568 เวลา 10.00 น.
                  </Text>
                </Pane>
              </>
            ) : (
              <>
                {" "}
                <Pane display="flex" flexDirection="column">
                  <Text color="red">หมายเหตุ*</Text>
                  <Text fontSize={"12px"}>
                    1. ประกาศผลการคัดเลือก (ตัวสำรอง) วันที่ 21 มีนาคม 2568 เวลา 10.00 น.
                  </Text>
                </Pane>
              </>
            )}
          </>
        )}
        {DataRegister[0].Major1_MAJOR_ID === "8201" && (
          <>
            <Pane display="flex" flexDirection="column">
              <Text color="red">หมายเหตุ*</Text>
              <Text fontSize={"12px"}>1. ติดต่อสอบถามการสมัครเรียน โทร. 055-706547</Text>
            </Pane>
          </>
        )}
      </>
    ) : DataRegister[0].REGISTER_STATUS === "5" ? (
      <>
        <Pane
          padding={10}
          backgroundColor="#bb3e0320"
          borderRadius={8}
          display="flex"
          flexDirection="column"
        >
          <Text color="#bb3e03">สละสิทธิ์ &nbsp;{DataRegister[0].QUOTA_NAME} </Text>
          <Text color="#bb3e03">{DataRegister[0].Major1_faculty_name} </Text>
          <Text color="#bb3e03">{" หลักสูตร " + DataRegister[0].Major1_LEVEL_OPEN_NAME} </Text>
          <Text color="#bb3e03">
            {DataRegister[0].Major1_MAJOR_ID + " : " + DataRegister[0].Major1_MAJOR_NAME}
          </Text>
        </Pane>
        <Pane display="flex" flexDirection="column">
          <Text color="red">หมายเหตุ*</Text>
          <Text fontSize={"12px"}>1. ติดต่อสอบถามการสมัครเรียน โทร. 055-706547</Text>
          {/* <Text fontSize={"12px"}>
                2. เปิดรับสมัครรอบ 3 ตั้งแต่วันที่ 12 มีนาคม 2568 - 11 เมษายน 2568
              </Text> */}
        </Pane>
      </>
    ) : (
      <div>
        <Pane
          minWidth={320}
          maxWidth={650}
          flexDirection={"column"}
          justifyContent={"center"}
          gap={10}
        >
          <Pane>
            {DataRegister[0].ROB_ID === "187" ? (
              DataRegister[0].REGISTER_STATUS === "0" ? (
                <>
                  <Badge
                    color="yellow"
                    height="100%"
                    paddingY={4}
                    paddingX={5}
                    fontSize={16}
                    fontFamily=""
                  >
                    <FaRegMoneyBillAlt /> อยู่ระหว่างการชำระค่าสมัคร
                  </Badge>
                </>
              ) : DataRegister[0].REGISTER_STATUS === "1" ? (
                <>
                  <Badge
                    color="green"
                    height="100%"
                    paddingY={4}
                    paddingX={5}
                    fontSize={16}
                    fontFamily=""
                  >
                    {DataRegister[0].Major1_MAJOR_ID === "8201" ? (
                      <>
                        <FaCheck /> มีสิทธิ์เข้ารับการสอบสัมภาษณ์
                      </>
                    ) : (
                      <>
                        <FaCheck /> มีสิทธิ์เข้ารับการสอบสัมภาษณ์
                        {/* <FaCheck /> ชำระค่าสมัครแล้ว รอประกาศรายชื่อผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์ */}
                      </>
                    )}
                  </Badge>
                </>
              ) : DataRegister[0].REGISTER_STATUS === "2" ? (
                <>
                  <Badge
                    color="green"
                    height="100%"
                    paddingY={4}
                    paddingX={5}
                    fontSize={16}
                    fontFamily=""
                  >
                    <FaCheck /> เข้ารับการสอบสัมภาษณ์
                  </Badge>
                </>
              ) : DataRegister[0].REGISTER_STATUS === "4" ? (
                <>
                  <Pane
                    color="#1b4332"
                    backgroundColor="#d8f3dc"
                    height="100%"
                    paddingY={4}
                    paddingX={5}
                    fontSize={16}
                    fontFamily=""
                    fontWeight={700}
                    marginBottom={0}
                  >
                    &nbsp;
                    <Text color="#1b4332" fontWeight={700}>
                      ผ่านการคัดเลือก (ตัวจริง) {DataRegister[0].QUOTA_NAME}{" "}
                      {DataRegister[0].ROB_NAME !== null ? DataRegister[0].ROB_NAME : ""}
                    </Text>
                    <br />
                    <Text color="#1b4332" fontWeight={700}>
                      {DataRegister[0].Major1_faculty_name}{" "}
                      {" หลักสูตร " + DataRegister[0].Major1_LEVEL_OPEN_NAME}
                    </Text>
                    <br />
                    <Text color="#1b4332" fontWeight={700}>
                      {DataRegister[0].Major1_MAJOR_ID + " : " + DataRegister[0].Major1_MAJOR_NAME}
                    </Text>
                  </Pane>
                </>
              ) : DataRegister[0].REGISTER_STATUS === "41" ? (
                <>
                  <Pane
                    hidden={
                      DataRegister[0].REGISTER_ORDER_NUMBER === null ||
                      DataRegister[0].Major1_LEVEL_OPEN_NAME === "ครุศาสตรบัณฑิต"
                    }
                    color="#007200"
                    backgroundColor="#d8f3dc"
                    height="100%"
                    paddingY={4}
                    paddingX={5}
                    fontSize={14}
                    fontFamily=""
                    margin={0}
                    marginTop={0}
                    fontWeight={700}
                  >
                    ผ่านการคัดเลือกเป็น {DataRegister[0].REGISTER_ORDER}
                  </Pane>
                </>
              ) : DataRegister[0].REGISTER_STATUS === "6" ||
                DataRegister[0].REGISTER_STATUS === "9" ? (
                <>
                  { }
                  <Pane
                    color="#1b4332"
                    fontWeight={700}
                    backgroundColor="#d8f3dc"
                    height="100%"
                    paddingY={4}
                    paddingX={5}
                    fontSize={16}
                    fontFamily=""
                    justifyContent="flex-start"
                  >
                    <Text color="#1b4332" fontWeight={700}>
                      ยืนยันสิทธิ์ {DataRegister[0].QUOTA_NAME}{" "}
                      {DataRegister[0].ROB_NAME !== null ? DataRegister[0].ROB_NAME : ""}
                    </Text>
                    <Text color="#1b4332" fontWeight={700}>
                      {DataRegister[0].Major1_faculty_name}{" "}
                      {" หลักสูตร " + DataRegister[0].Major1_LEVEL_OPEN_NAME}
                    </Text>
                    <br />
                    <Text color="#1b4332" fontWeight={700}>
                      {DataRegister[0].Major1_MAJOR_ID + " : " + DataRegister[0].Major1_MAJOR_NAME}
                    </Text>
                  </Pane>
                </>
              ) : (
                <></>
              )
            ) : DataRegister[0].ROB_ID === "170" ? (
              DataRegister[0].REGISTER_STATUS === "0" ? (
                <>
                  <Badge
                    color="yellow"
                    height="100%"
                    paddingY={4}
                    paddingX={5}
                    fontSize={16}
                    fontFamily=""
                  >
                    <FaRegMoneyBillAlt /> อยู่ระหว่างการชำระค่าสมัคร
                  </Badge>
                </>
              ) : DataRegister[0].REGISTER_STATUS === "1" ? (
                <>
                  <Badge
                    color="green"
                    height="100%"
                    paddingY={4}
                    paddingX={5}
                    fontSize={16}
                    fontFamily=""
                  >
                    {DataRegister[0].Major1_MAJOR_ID === "8201ห" ? (
                      <>
                        <FaCheck /> ชำระค่าสมัครแล้ว รอประกาศรายชื่อผู้มีสิทธิ์สอบคัดเลือก
                      </>
                    ) : (
                      <>
                        {ShowListTo() ? (
                          <>
                            <FaCheck /> มีสิทธิ์เข้ารับการสอบคัดเลือก
                          </>
                        ) : (
                          <>
                            <FaCheck /> ชำระค่าสมัครแล้ว รอประกาศรายชื่อผู้มีสิทธิ์สอบคัดเลือก
                          </>
                        )}
                        {/* <FaCheck /> ชำระค่าสมัครแล้ว รอประกาศรายชื่อผู้มีสิทธิ์สอบคัดเลือก */}
                      </>
                    )}
                  </Badge>
                </>
              ) : DataRegister[0].REGISTER_STATUS === "2" ? (
                <>
                  <Badge
                    color="green"
                    height="100%"
                    paddingY={4}
                    paddingX={5}
                    fontSize={16}
                    fontFamily=""
                  >
                    <FaCheck /> เข้ารับการสอบสัมภาษณ์
                  </Badge>
                </>
              ) : DataRegister[0].REGISTER_STATUS === "4" ? (
                <>
                  <Pane
                    color="#1b4332"
                    backgroundColor="#d8f3dc"
                    height="100%"
                    paddingY={4}
                    paddingX={5}
                    fontSize={16}
                    fontFamily=""
                    fontWeight={700}
                    marginBottom={0}
                  >
                    &nbsp;
                    <Text color="#1b4332" fontWeight={700}>
                      ผ่านการคัดเลือก (ตัวจริง) {DataRegister[0].QUOTA_NAME}{" "}
                      {DataRegister[0].ROB_NAME !== null ? DataRegister[0].ROB_NAME : ""}
                    </Text>
                    <br />
                    <Text color="#1b4332" fontWeight={700}>
                      {DataRegister[0].Major1_faculty_name}{" "}
                      {" หลักสูตร " + DataRegister[0].Major1_LEVEL_OPEN_NAME}
                    </Text>
                    <br />
                    <Text color="#1b4332" fontWeight={700}>
                      {DataRegister[0].Major1_MAJOR_ID + " : " + DataRegister[0].Major1_MAJOR_NAME}
                    </Text>
                  </Pane>
                </>
              ) : DataRegister[0].REGISTER_STATUS === "6" ||
                DataRegister[0].REGISTER_STATUS === "9" ? (
                <>
                  { }
                  <Pane
                    color="#1b4332"
                    fontWeight={700}
                    backgroundColor="#d8f3dc"
                    height="100%"
                    paddingY={4}
                    paddingX={5}
                    fontSize={16}
                    fontFamily=""
                    justifyContent="flex-start"
                  >
                    <Text color="#1b4332" fontWeight={700}>
                      ยืนยันสิทธิ์ {DataRegister[0].QUOTA_NAME}{" "}
                      {DataRegister[0].ROB_NAME !== null ? DataRegister[0].ROB_NAME : ""}
                    </Text>
                    <Text color="#1b4332" fontWeight={700}>
                      {DataRegister[0].Major1_faculty_name}{" "}
                      {" หลักสูตร " + DataRegister[0].Major1_LEVEL_OPEN_NAME}
                    </Text>
                    <br />
                    <Text color="#1b4332" fontWeight={700}>
                      {DataRegister[0].Major1_MAJOR_ID + " : " + DataRegister[0].Major1_MAJOR_NAME}
                    </Text>
                  </Pane>
                </>
              ) : (
                <></>
              )
            ) : DataRegister[0].ROB_ID === "152" ? (
              DataRegister[0].REGISTER_STATUS === "0" ? (
                <>
                  <Badge
                    color="yellow"
                    height="100%"
                    paddingY={4}
                    paddingX={5}
                    fontSize={16}
                    fontFamily=""
                  >
                    <FaRegMoneyBillAlt /> อยู่ระหว่างการชำระค่าสมัคร
                  </Badge>
                </>
              ) : DataRegister[0].REGISTER_STATUS === "1" ? (
                <>
                  {/* <Badge
                    color="green"
                    height="100%"
                    paddingY={4}
                    paddingX={5}
                    fontSize={16}
                    fontFamily=""
                  >
                    <FaCheck /> มีสิทธิ์เข้ารับการสอบสัมภาษณ์
                  </Badge> */}
                  <Pane
                    color="#1b4332"
                    fontWeight={700}
                    backgroundColor="#ffccd5"
                    height="100%"
                    paddingY={4}
                    paddingX={5}
                    fontSize={16}
                    fontFamily=""
                    justifyContent="flex-start"
                  >
                    <Text color="#a51c30" fontWeight={700}>
                      ไม่เข้ารับการสอบสัมภาษณ์{DataRegister[0].QUOTA_NAME}{" "}
                      {DataRegister[0].ROB_NAME !== null ? DataRegister[0].ROB_NAME : ""}
                    </Text>
                    <br />
                    <Text color="#a51c30" fontWeight={700}>
                      {DataRegister[0].Major1_faculty_name}{" "}
                      {" หลักสูตร " + DataRegister[0].Major1_LEVEL_OPEN_NAME}
                    </Text>
                    <br />
                    <Text color="#a51c30" fontWeight={700}>
                      {DataRegister[0].Major1_MAJOR_ID + " : " + DataRegister[0].Major1_MAJOR_NAME}
                    </Text>
                  </Pane>
                </>
              ) : DataRegister[0].REGISTER_STATUS === "2" ? (
                <>
                  <Badge
                    color="green"
                    height="100%"
                    paddingY={4}
                    paddingX={5}
                    fontSize={16}
                    fontFamily=""
                  >
                    เข้ารับการสอบสัมภาษณ์
                  </Badge>
                </>
              ) : DataRegister[0].REGISTER_STATUS === "4" ? (
                <>
                  <Pane
                    color="#1b4332"
                    backgroundColor="#d8f3dc"
                    height="100%"
                    paddingY={4}
                    paddingX={5}
                    fontSize={16}
                    fontFamily=""
                    fontWeight={700}
                    marginBottom={0}
                  >
                    &nbsp;
                    <Text color="#1b4332" fontWeight={700}>
                      ผ่านการคัดเลือก (ตัวจริง) {DataRegister[0].QUOTA_NAME}{" "}
                      {DataRegister[0].ROB_NAME !== null ? DataRegister[0].ROB_NAME : ""}
                    </Text>
                    <br />
                    <Text color="#1b4332" fontWeight={700}>
                      {DataRegister[0].Major1_faculty_name}{" "}
                      {" หลักสูตร " + DataRegister[0].Major1_LEVEL_OPEN_NAME}
                    </Text>
                    <br />
                    <Text color="#1b4332" fontWeight={700}>
                      {DataRegister[0].Major1_MAJOR_ID + " : " + DataRegister[0].Major1_MAJOR_NAME}
                    </Text>
                  </Pane>

                  <Pane
                    hidden={
                      DataRegister[0].REGISTER_ORDER_NUMBER === null ||
                      DataRegister[0].Major1_LEVEL_OPEN_NAME === "ครุศาสตรบัณฑิต"
                    }
                    color="#8a2846"
                    backgroundColor="#ffe5ec"
                    height="100%"
                    paddingY={4}
                    paddingX={5}
                    fontSize={14}
                    fontFamily=""
                    margin={0}
                    marginTop={0}
                    fontWeight={700}
                  >
                    ผ่านการคัดเลือกเป็น {DataRegister[0].REGISTER_ORDER}
                  </Pane>
                </>
              ) : DataRegister[0].REGISTER_STATUS === "41" ? (
                <>
                  <Badge
                    color="green"
                    height="100%"
                    paddingY={4}
                    paddingX={5}
                    fontSize={16}
                    fontFamily=""
                    justifyContent="flex-start"
                  >
                    ผ่านการคัดเลือก{" "}
                    {DataRegister[0].QUOTA_NAME +
                      " " +
                      DataRegister[0].Major1_faculty_name +
                      " หลักสูตร " +
                      DataRegister[0].Major1_LEVEL_OPEN_NAME +
                      " " +
                      DataRegister[0].Major1_MAJOR_ID +
                      " : " +
                      DataRegister[0].Major1_MAJOR_NAME}
                  </Badge>
                  <Badge
                    color="orange"
                    height="100%"
                    paddingY={4}
                    paddingX={5}
                    fontSize={16}
                    fontFamily=""
                  >
                    และผ่านการคัดเลือก {DataRegister[0].REGISTER_ORDER}
                  </Badge>
                </>
              ) : DataRegister[0].REGISTER_STATUS === "11" ? (
                <>
                  <br />
                  {DataRegister[0].REGISTER_ORDER_NUMBER === null ? (
                    <Pane>
                      <Text
                        color="#bb3e03"
                        height="100%"
                        paddingY={4}
                        paddingX={5}
                        fontSize={16}
                        fontFamily=""
                      >
                        ไม่ผ่านการคัดเลือก
                        {DataRegister[0].QUOTA_NAME +
                          " " +
                          DataRegister[0].Major1_faculty_name +
                          " หลักสูตร " +
                          DataRegister[0].Major1_LEVEL_OPEN_NAME +
                          " " +
                          DataRegister[0].Major1_MAJOR_ID +
                          " : " +
                          DataRegister[0].Major1_MAJOR_NAME}
                      </Text>
                    </Pane>
                  ) : (
                    <>
                      <Pane
                        hidden={DataRegister[0].REGISTER_ORDER_NUMBER === null}
                        color="#8a2846"
                        backgroundColor="#ffe5ec"
                        height="100%"
                        paddingY={4}
                        paddingX={5}
                        fontSize={14}
                        fontFamily=""
                        margin={0}
                        marginTop={0}
                        fontWeight={700}
                      >
                        ผ่านการคัดเลือกเป็น {DataRegister[0].REGISTER_ORDER}
                      </Pane>
                    </>
                  )}
                </>
              ) : DataRegister[0].REGISTER_STATUS === "6" ||
                DataRegister[0].REGISTER_STATUS === "9" ? (
                <>
                  { }
                  <Pane
                    color="#1b4332"
                    fontWeight={700}
                    backgroundColor="#d8f3dc"
                    height="100%"
                    paddingY={4}
                    paddingX={5}
                    fontSize={16}
                    fontFamily=""
                    justifyContent="flex-start"
                  >
                    <Text color="#1b4332" fontWeight={700}>
                      ยืนยันสิทธิ์ {DataRegister[0].QUOTA_NAME}{" "}
                      {DataRegister[0].ROB_NAME !== null ? DataRegister[0].ROB_NAME : ""}
                    </Text>
                    <Text color="#1b4332" fontWeight={700}>
                      {DataRegister[0].Major1_faculty_name}{" "}
                      {" หลักสูตร " + DataRegister[0].Major1_LEVEL_OPEN_NAME}
                    </Text>
                    <br />
                    <Text color="#1b4332" fontWeight={700}>
                      {DataRegister[0].Major1_MAJOR_ID + " : " + DataRegister[0].Major1_MAJOR_NAME}
                    </Text>
                  </Pane>
                </>
              ) : DataRegister[0].REGISTER_STATUS === "5" ? (
                <>
                  {" "}
                  <Pane
                    color="#a51c30"
                    backgroundColor="#ffccd5"
                    height="100%"
                    paddingY={4}
                    paddingX={5}
                    fontSize={16}
                    fontFamily=""
                    fontWeight={700}
                    marginBottom={0}
                  >
                    สละสิทธิ์
                    {DataRegister[0].QUOTA_NAME +
                      " " +
                      (DataRegister[0].ROB_NAME !== null ? DataRegister[0].ROB_NAME : "") +
                      " " +
                      DataRegister[0].Major1_faculty_name +
                      " หลักสูตร " +
                      DataRegister[0].Major1_LEVEL_OPEN_NAME +
                      " " +
                      DataRegister[0].Major1_MAJOR_ID +
                      " : " +
                      DataRegister[0].Major1_MAJOR_NAME}
                  </Pane>
                </>
              ) : (
                <></>
              )
            ) : DataRegister[0].ROB_ID === "153" || DataRegister[0].ROB_ID === "155" ? (
              DataRegister[0].REGISTER_STATUS === "0" ? (
                <>
                  <Badge
                    color="yellow"
                    height="100%"
                    paddingY={4}
                    paddingX={5}
                    fontSize={16}
                    fontFamily=""
                  >
                    {/* <FaRegMoneyBillAlt /> อยู่ระหว่างการชำระค่าสมัคร */}
                    <FaRegMoneyBillAlt /> อยู่ระหว่างการตรวจสอบใบรายงานผลการเรียน
                  </Badge>
                </>
              ) : DataRegister[0].REGISTER_STATUS === "1" ? (
                <>
                  <Pane
                    color="#1b4332"
                    fontWeight={700}
                    backgroundColor="#ffccd5"
                    height="100%"
                    paddingY={4}
                    paddingX={5}
                    fontSize={16}
                    fontFamily=""
                    justifyContent="flex-start"
                  >
                    <Text color="#a51c30" fontWeight={700}>
                      ไม่เข้ารับการสอบสัมภาษณ์{DataRegister[0].QUOTA_NAME}{" "}
                      {DataRegister[0].ROB_NAME !== null ? DataRegister[0].ROB_NAME : ""}
                    </Text>
                    <br />
                    <Text color="#a51c30" fontWeight={700}>
                      {DataRegister[0].Major1_faculty_name}{" "}
                      {" หลักสูตร " + DataRegister[0].Major1_LEVEL_OPEN_NAME}
                    </Text>
                    <br />
                    <Text color="#a51c30" fontWeight={700}>
                      {DataRegister[0].Major1_MAJOR_ID + " : " + DataRegister[0].Major1_MAJOR_NAME}
                    </Text>
                  </Pane>
                </>
              ) : DataRegister[0].REGISTER_STATUS === "2" ? (
                <>
                  <Badge
                    color="green"
                    height="100%"
                    paddingY={4}
                    paddingX={5}
                    fontSize={16}
                    fontFamily=""
                  >
                    {ListMajor[0].Major_MAJOR_ID === "1202" ||
                      ListMajor[0].Major_MAJOR_ID === "1207" ||
                      ListMajor[0].Major_MAJOR_ID === "1208" ||
                      ListMajor[0].Major_MAJOR_ID === "1301" ||
                      ListMajor[0].Major_MAJOR_ID === "1110" ||
                      ListMajor[0].Major_MAJOR_ID === "1304" ||
                      ListMajor[0].Major_MAJOR_ID === "1310" ? (
                      <>
                        {" "}
                        <FaCheck /> เข้ารับการสอบสัมภาษณ์
                      </>
                    ) : (
                      <>
                        {" "}
                        <FaCheck /> เข้ารับการสอบสัมภาษณ์
                      </>
                    )}
                  </Badge>
                </>
              ) : DataRegister[0].REGISTER_STATUS === "4" ? (
                <>
                  { }
                  <Pane
                    color="#1b4332"
                    backgroundColor="#d8f3dc"
                    height="100%"
                    paddingY={4}
                    paddingX={5}
                    fontSize={16}
                    fontFamily=""
                    fontWeight={700}
                    marginBottom={0}
                  >
                    &nbsp;
                    <Text color="#1b4332" fontWeight={700}>
                      ผ่านการคัดเลือก (ตัวจริง) {DataRegister[0].QUOTA_NAME}{" "}
                      {DataRegister[0].ROB_NAME !== null ? DataRegister[0].ROB_NAME : ""}
                    </Text>
                    <br />
                    <Text color="#1b4332" fontWeight={700}>
                      {DataRegister[0].Major1_faculty_name}{" "}
                      {" หลักสูตร " + DataRegister[0].Major1_LEVEL_OPEN_NAME}
                    </Text>
                    <br />
                    <Text color="#1b4332" fontWeight={700}>
                      {DataRegister[0].Major1_MAJOR_ID + " : " + DataRegister[0].Major1_MAJOR_NAME}
                    </Text>
                  </Pane>
                </>
              ) : DataRegister[0].REGISTER_STATUS === "6" ||
                DataRegister[0].REGISTER_STATUS === "9" ? (
                <>
                  { }
                  <Pane
                    color="#1b4332"
                    backgroundColor="#d8f3dc"
                    height="100%"
                    paddingY={4}
                    paddingX={5}
                    fontSize={16}
                    fontFamily=""
                    fontWeight={700}
                    marginBottom={0}
                  >
                    ยืนยันสิทธิ์
                    {DataRegister[0].QUOTA_NAME +
                      " " +
                      (DataRegister[0].ROB_NAME !== null ? DataRegister[0].ROB_NAME : "") +
                      " " +
                      DataRegister[0].Major1_faculty_name +
                      " หลักสูตร " +
                      DataRegister[0].Major1_LEVEL_OPEN_NAME +
                      " " +
                      DataRegister[0].Major1_MAJOR_ID +
                      " : " +
                      DataRegister[0].Major1_MAJOR_NAME}
                  </Pane>
                </>
              ) : DataRegister[0].REGISTER_STATUS === "5" ? (
                <>
                  {" "}
                  <Pane
                    color="#a51c30"
                    backgroundColor="#ffccd5"
                    height="100%"
                    paddingY={4}
                    paddingX={5}
                    fontSize={16}
                    fontFamily=""
                    fontWeight={700}
                    marginBottom={0}
                  >
                    สละสิทธิ์
                    {DataRegister[0].QUOTA_NAME +
                      " " +
                      (DataRegister[0].ROB_NAME !== null ? DataRegister[0].ROB_NAME : "") +
                      " " +
                      DataRegister[0].Major1_faculty_name +
                      " หลักสูตร " +
                      DataRegister[0].Major1_LEVEL_OPEN_NAME +
                      " " +
                      DataRegister[0].Major1_MAJOR_ID +
                      " : " +
                      DataRegister[0].Major1_MAJOR_NAME}
                  </Pane>
                </>
              ) : (
                <></>
              )
            ) : DataRegister[0].ROB_ID === "154" ? (
              DataRegister[0].REGISTER_STATUS === "0" ? (
                <>
                  <Badge
                    color="yellow"
                    height="100%"
                    paddingY={4}
                    paddingX={5}
                    fontSize={16}
                    fontFamily=""
                  >
                    <FaRegMoneyBillAlt /> อยู่ระหว่างการชำระค่าสมัคร
                  </Badge>
                </>
              ) : DataRegister[0].REGISTER_STATUS === "1" ? (
                <>
                  <Badge
                    color="green"
                    height="100%"
                    paddingY={4}
                    paddingX={5}
                    fontSize={16}
                    fontFamily=""
                  >
                    <FaCheck /> มีสิทธิ์เข้ารับการสอบสัมภาษณ์
                  </Badge>
                  {/* <Badge
                    color="green"
                    height="100%"
                    paddingY={4}
                    paddingX={5}
                    fontSize={16}
                    fontFamily=""
                  >
                    <FaCheck /> ชำระค่าสมัครแล้ว รอประกาศรายชื่อผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์
                  </Badge> */}
                </>
              ) : DataRegister[0].REGISTER_STATUS === "4" ? (
                <>
                  <Pane
                    color="#1b4332"
                    backgroundColor="#d8f3dc"
                    height="100%"
                    paddingY={4}
                    paddingX={5}
                    fontSize={16}
                    fontFamily=""
                    fontWeight={700}
                    marginBottom={0}
                  >
                    &nbsp;
                    <Text color="#1b4332" fontWeight={700}>
                      ผ่านการคัดเลือก (ตัวจริง) {DataRegister[0].QUOTA_NAME}{" "}
                      {DataRegister[0].ROB_NAME !== null ? DataRegister[0].ROB_NAME : ""}
                    </Text>
                    <br />
                    <Text color="#1b4332" fontWeight={700}>
                      {DataRegister[0].Major1_faculty_name}{" "}
                      {" หลักสูตร " + DataRegister[0].Major1_LEVEL_OPEN_NAME}
                    </Text>
                    <br />
                    <Text color="#1b4332" fontWeight={700}>
                      {DataRegister[0].Major1_MAJOR_ID + " : " + DataRegister[0].Major1_MAJOR_NAME}
                    </Text>
                  </Pane>
                </>
              ) : DataRegister[0].REGISTER_STATUS === "6" ? (
                <>
                  <Pane
                    color="#1b4332"
                    backgroundColor="#d8f3dc"
                    height="100%"
                    paddingY={4}
                    paddingX={5}
                    fontSize={16}
                    fontFamily=""
                    fontWeight={700}
                    marginBottom={0}
                  >
                    &nbsp;
                    <Text color="#1b4332" fontWeight={700}>
                      ยืนยันสิทธิ์ {DataRegister[0].QUOTA_NAME}{" "}
                      {DataRegister[0].ROB_NAME !== null ? DataRegister[0].ROB_NAME : ""}
                    </Text>
                    <br />
                    <Text color="#1b4332" fontWeight={700}>
                      {DataRegister[0].Major1_faculty_name}{" "}
                      {" หลักสูตร " + DataRegister[0].Major1_LEVEL_OPEN_NAME}
                    </Text>
                    <br />
                    <Text color="#1b4332" fontWeight={700}>
                      {DataRegister[0].Major1_MAJOR_ID + " : " + DataRegister[0].Major1_MAJOR_NAME}
                    </Text>
                  </Pane>
                </>
              ) : (
                <></>
              )
            ) : DataRegister[0].ROB_ID === "156" ? (
              DataRegister[0].REGISTER_STATUS === "0" ? (
                <>
                  <Badge
                    color="yellow"
                    height="100%"
                    paddingY={4}
                    paddingX={5}
                    fontSize={16}
                    fontFamily=""
                  >
                    <FaRegMoneyBillAlt /> อยู่ระหว่างการชำระค่าสมัคร
                  </Badge>
                </>
              ) : DataRegister[0].REGISTER_STATUS === "1" ? (
                <>
                  {/* <Badge
                    color="green"
                    height="100%"
                    paddingY={4}
                    paddingX={5}
                    fontSize={16}
                    fontFamily=""
                  >
                    <FaCheck /> &nbsp;

                    มีสิทธิ์เข้ารับการสอบสัมภาษณ์
                  </Badge> */}
                  <Pane
                    color="#1b4332"
                    fontWeight={700}
                    backgroundColor="#ffccd5"
                    height="100%"
                    paddingY={4}
                    paddingX={5}
                    fontSize={16}
                    fontFamily=""
                    justifyContent="flex-start"
                  >
                    <Text color="#a51c30" fontWeight={700}>
                      ไม่เข้ารับการสอบสัมภาษณ์{DataRegister[0].QUOTA_NAME}{" "}
                      {DataRegister[0].ROB_NAME !== null ? DataRegister[0].ROB_NAME : ""}
                    </Text>
                    <br />
                    <Text color="#a51c30" fontWeight={700}>
                      {DataRegister[0].Major1_faculty_name}{" "}
                      {" หลักสูตร " + DataRegister[0].Major1_LEVEL_OPEN_NAME}
                    </Text>
                    <br />
                    <Text color="#a51c30" fontWeight={700}>
                      {DataRegister[0].Major1_MAJOR_ID + " : " + DataRegister[0].Major1_MAJOR_NAME}
                    </Text>
                  </Pane>
                </>
              ) : DataRegister[0].REGISTER_STATUS === "2" ? (
                <>
                  <Badge
                    color="green"
                    height="100%"
                    paddingY={4}
                    paddingX={5}
                    fontSize={16}
                    fontFamily=""
                  >
                    <FaCheck /> &nbsp; รอประกาศรายชื่อผู้ผ่านการคัดเลือก (ตัวจริงและตัวสำรอง)
                  </Badge>
                </>
              ) : DataRegister[0].REGISTER_STATUS === "4" ? (
                <>
                  { }
                  <Pane
                    color="#1b4332"
                    backgroundColor="#d8f3dc"
                    height="100%"
                    paddingY={4}
                    paddingX={5}
                    fontSize={16}
                    fontFamily=""
                    fontWeight={700}
                    marginBottom={0}
                  >
                    &nbsp;
                    <Text color="#1b4332" fontWeight={700}>
                      ผ่านการคัดเลือก (ตัวจริง) {DataRegister[0].QUOTA_NAME}{" "}
                      {DataRegister[0].ROB_NAME !== null ? DataRegister[0].ROB_NAME : ""}
                    </Text>
                    <br />
                    <Text color="#1b4332" fontWeight={700}>
                      {DataRegister[0].Major1_faculty_name}{" "}
                      {" หลักสูตร " + DataRegister[0].Major1_LEVEL_OPEN_NAME}
                    </Text>
                    <br />
                    <Text color="#1b4332" fontWeight={700}>
                      {DataRegister[0].Major1_MAJOR_ID + " : " + DataRegister[0].Major1_MAJOR_NAME}
                    </Text>
                  </Pane>
                  <Pane
                    hidden={
                      DataRegister[0].REGISTER_ORDER_NUMBER === null ||
                      DataRegister[0].Major1_LEVEL_OPEN_NAME === "ครุศาสตรบัณฑิต"
                    }
                    color="#8a2846"
                    backgroundColor="#ffe5ec"
                    height="100%"
                    paddingY={4}
                    paddingX={5}
                    fontSize={14}
                    fontFamily=""
                    margin={0}
                    marginTop={0}
                    fontWeight={700}
                  >
                    ผ่านการคัดเลือกเป็น {DataRegister[0].REGISTER_ORDER}
                  </Pane>
                </>
              ) : DataRegister[0].REGISTER_STATUS === "6" ||
                DataRegister[0].REGISTER_STATUS === "9" ? (
                <>
                  { }
                  <Pane
                    color="#1b4332"
                    backgroundColor="#d8f3dc"
                    height="100%"
                    paddingY={4}
                    paddingX={5}
                    fontSize={16}
                    fontFamily=""
                    fontWeight={700}
                    marginBottom={0}
                  >
                    ยืนยันสิทธิ์
                    {DataRegister[0].QUOTA_NAME +
                      " " +
                      (DataRegister[0].ROB_NAME !== null ? DataRegister[0].ROB_NAME : "") +
                      " " +
                      DataRegister[0].Major1_faculty_name +
                      " หลักสูตร " +
                      DataRegister[0].Major1_LEVEL_OPEN_NAME +
                      " " +
                      DataRegister[0].Major1_MAJOR_ID +
                      " : " +
                      DataRegister[0].Major1_MAJOR_NAME}
                  </Pane>
                </>
              ) : (
                <></>
              )
            ) : DataRegister[0].ROB_ID === "159" ? (
              DataRegister[0].REGISTER_STATUS === "0" ? (
                <>
                  <Badge
                    color="yellow"
                    height="100%"
                    paddingY={4}
                    paddingX={5}
                    fontSize={16}
                    fontFamily=""
                  >
                    <FaRegMoneyBillAlt /> อยู่ระหว่างการชำระค่าสมัคร
                  </Badge>
                </>
              ) : DataRegister[0].REGISTER_STATUS === "1" ? (
                <>
                  <Badge
                    color="green"
                    height="100%"
                    paddingY={4}
                    paddingX={5}
                    fontSize={16}
                    fontFamily=""
                  >
                    <FaCheck /> &nbsp;
                    {/* ชำระค่าสมัครแล้ว
                    รอประกาศรายชื่อผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์ */}
                    มีสิทธิ์เข้ารับการสอบวัดความรู้และสอบสัมภาษณ์
                  </Badge>
                </>
              ) : DataRegister[0].REGISTER_STATUS === "4" ? (
                <>
                  <Pane
                    color="#1b4332"
                    backgroundColor="#d8f3dc"
                    height="100%"
                    paddingY={4}
                    paddingX={5}
                    fontSize={16}
                    fontFamily=""
                    fontWeight={700}
                    marginBottom={0}
                  >
                    &nbsp;
                    <Text color="#1b4332" fontWeight={700}>
                      {AllowPayNurse() ? "ผู้มีสิทธิ์เข้าศึกษา" : "ผ่านการคัดเลือก (ตัวจริง)"}{" "}
                      {DataRegister[0].QUOTA_NAME}{" "}
                      {DataRegister[0].ROB_NAME !== null ? DataRegister[0].ROB_NAME : ""}
                    </Text>
                    <br />
                    <Text color="#1b4332" fontWeight={700}>
                      {DataRegister[0].Major1_faculty_name}{" "}
                      {" หลักสูตร " + DataRegister[0].Major1_LEVEL_OPEN_NAME}
                    </Text>
                    <br />
                    <Text color="#1b4332" fontWeight={700}>
                      {DataRegister[0].Major1_MAJOR_ID + " : " + DataRegister[0].Major1_MAJOR_NAME}
                    </Text>
                  </Pane>
                  <Pane
                    hidden={AllowPayNurse()}
                    backgroundColor={"#fffae5"}
                    color="#c36f09"
                    paddingY={4}
                    paddingX={5}
                    fontSize={14}
                    fontFamily=""
                    margin={0}
                    marginTop={0}
                    fontWeight={700}
                  >
                    ส่งผลการตรวจร่างกายฉบับจริง ตั้งแต่วันนี้ ถึงวันที่ 26 มีนาคม 2568 ณ
                    อาคารคณะพยาบาลศาสตร์ มหาวิทยาลัยราชภัฏกำแพงเพชร
                  </Pane>
                  {/* <Pane
                    hidden={
                      DataRegister[0].REGISTER_ORDER_NUMBER === null ||
                      DataRegister[0].Major1_LEVEL_OPEN_NAME === "ครุศาสตรบัณฑิต"
                    }
                    color="#8a2846"
                    backgroundColor="#ffe5ec"
                    height="100%"
                    paddingY={4}
                    paddingX={5}
                    fontSize={14}
                    fontFamily=""
                    margin={0}
                    marginTop={0}
                    fontWeight={700}
                  >
                    ผ่านการคัดเลือกเป็น {DataRegister[0].REGISTER_ORDER}
                  </Pane> */}
                </>
              ) : DataRegister[0].REGISTER_STATUS === "6" ||
                DataRegister[0].REGISTER_STATUS === "9" ? (
                <>
                  <Pane
                    color="#1b4332"
                    backgroundColor="#d8f3dc"
                    height="100%"
                    paddingY={4}
                    paddingX={5}
                    fontSize={16}
                    fontFamily=""
                    fontWeight={700}
                    marginBottom={0}
                  >
                    &nbsp;
                    <Text color="#1b4332" fontWeight={700}>
                      ยืนยันสิทธิ์ {DataRegister[0].QUOTA_NAME}{" "}
                      {DataRegister[0].ROB_NAME !== null ? DataRegister[0].ROB_NAME : ""}
                    </Text>
                    <br />
                    <Text color="#1b4332" fontWeight={700}>
                      {DataRegister[0].Major1_faculty_name}{" "}
                      {" หลักสูตร " + DataRegister[0].Major1_LEVEL_OPEN_NAME}
                    </Text>
                    <br />
                    <Text color="#1b4332" fontWeight={700}>
                      {DataRegister[0].Major1_MAJOR_ID + " : " + DataRegister[0].Major1_MAJOR_NAME}
                    </Text>
                  </Pane>
                </>
              ) : (
                <></>
              )
            ) : DataRegister[0].ROB_ID === "157" || DataRegister[0].ROB_ID === "158" ? (
              DataRegister[0].REGISTER_STATUS === "0" ? (
                <>
                  <Badge
                    color="yellow"
                    height="100%"
                    paddingY={4}
                    paddingX={5}
                    fontSize={16}
                    fontFamily=""
                  >
                    <FaRegMoneyBillAlt /> อยู่ระหว่างการชำระค่าสมัคร
                  </Badge>
                </>
              ) : DataRegister[0].REGISTER_STATUS === "1" ? (
                <>
                  <Pane
                    color="#1b4332"
                    fontWeight={700}
                    backgroundColor="#ffccd5"
                    height="100%"
                    paddingY={4}
                    paddingX={5}
                    fontSize={16}
                    fontFamily=""
                    justifyContent="flex-start"
                  >
                    <Text color="#a51c30" fontWeight={700}>
                      ไม่เข้ารับการสอบสัมภาษณ์{DataRegister[0].QUOTA_NAME}{" "}
                      {DataRegister[0].ROB_NAME !== null ? DataRegister[0].ROB_NAME : ""}
                    </Text>
                    <br />
                    <Text color="#a51c30" fontWeight={700}>
                      {DataRegister[0].Major1_faculty_name}{" "}
                      {" หลักสูตร " + DataRegister[0].Major1_LEVEL_OPEN_NAME}
                    </Text>
                    <br />
                    <Text color="#a51c30" fontWeight={700}>
                      {DataRegister[0].Major1_MAJOR_ID + " : " + DataRegister[0].Major1_MAJOR_NAME}
                    </Text>
                  </Pane>
                </>
              ) : DataRegister[0].REGISTER_STATUS === "4" ? (
                <>
                  { }
                  <Pane
                    color="#1b4332"
                    backgroundColor="#d8f3dc"
                    height="100%"
                    paddingY={4}
                    paddingX={5}
                    fontSize={16}
                    fontFamily=""
                    fontWeight={700}
                    marginBottom={0}
                  >
                    &nbsp;
                    <Text color="#1b4332" fontWeight={700}>
                      ผ่านการคัดเลือก (ตัวจริง) {DataRegister[0].QUOTA_NAME}{" "}
                      {DataRegister[0].ROB_NAME !== null ? DataRegister[0].ROB_NAME : ""}
                    </Text>
                    <br />
                    <Text color="#1b4332" fontWeight={700}>
                      {DataRegister[0].Major1_faculty_name}{" "}
                      {" หลักสูตร " + DataRegister[0].Major1_LEVEL_OPEN_NAME}
                    </Text>
                    <br />
                    <Text color="#1b4332" fontWeight={700}>
                      {DataRegister[0].Major1_MAJOR_ID + " : " + DataRegister[0].Major1_MAJOR_NAME}
                    </Text>
                  </Pane>
                </>
              ) : DataRegister[0].REGISTER_STATUS === "6" ||
                DataRegister[0].REGISTER_STATUS === "9" ? (
                <>
                  { }
                  <Pane
                    color="#1b4332"
                    backgroundColor="#d8f3dc"
                    height="100%"
                    paddingY={4}
                    paddingX={5}
                    fontSize={16}
                    fontFamily=""
                    fontWeight={700}
                    marginBottom={0}
                  >
                    ยืนยันสิทธิ์
                    {DataRegister[0].QUOTA_NAME +
                      " " +
                      (DataRegister[0].ROB_NAME !== null ? DataRegister[0].ROB_NAME : "") +
                      " " +
                      DataRegister[0].Major1_faculty_name +
                      " หลักสูตร " +
                      DataRegister[0].Major1_LEVEL_OPEN_NAME +
                      " " +
                      DataRegister[0].Major1_MAJOR_ID +
                      " : " +
                      DataRegister[0].Major1_MAJOR_NAME}
                  </Pane>
                </>
              ) : (
                <></>
              )
            ) : DataRegister[0].ROB_ID === "160" ? (
              DataRegister[0].REGISTER_STATUS === "0" ? (
                <>
                  <Badge
                    color="yellow"
                    height="100%"
                    paddingY={4}
                    paddingX={5}
                    fontSize={16}
                    fontFamily=""
                  >
                    <FaRegMoneyBillAlt /> อยู่ระหว่างการชำระค่าสมัคร
                  </Badge>
                </>
              ) : DataRegister[0].REGISTER_STATUS === "1" ? (
                <>
                  <Badge
                    color="green"
                    height="100%"
                    paddingY={4}
                    paddingX={5}
                    fontSize={16}
                    fontFamily=""
                  >
                    {/* <FaCheck /> &nbsp;ชำระค่าสมัครแล้ว รอประกาศรายชื่อผู้มีสิทธิ์สอบวัดความรู้ */}
                    <FaCheck /> &nbsp;มีสิทธิ์เข้ารับการสอบวัดความรู้
                  </Badge>
                </>
              ) : DataRegister[0].REGISTER_STATUS === "2" ? (
                <>
                  <Badge
                    color="green"
                    height="100%"
                    paddingY={4}
                    paddingX={5}
                    fontSize={16}
                    fontFamily=""
                  >
                    <FaCheck /> &nbsp; รอประกาศรายชื่อผู้ผ่านการคัดเลือก (ตัวจริงและตัวสำรอง)
                  </Badge>
                </>
              ) : DataRegister[0].REGISTER_STATUS === "4" ? (
                <>
                  <Pane
                    color="#1b4332"
                    backgroundColor="#d8f3dc"
                    height="100%"
                    paddingY={4}
                    paddingX={5}
                    fontSize={16}
                    fontFamily=""
                    fontWeight={700}
                    marginBottom={0}
                  >
                    &nbsp;
                    <Text color="#1b4332" fontWeight={700}>
                      ผ่านการคัดเลือก (ตัวจริง) {DataRegister[0].QUOTA_NAME}{" "}
                      {DataRegister[0].ROB_NAME !== null ? DataRegister[0].ROB_NAME : ""}
                    </Text>
                    <br />
                    <Text color="#1b4332" fontWeight={700}>
                      {DataRegister[0].Major1_faculty_name}{" "}
                      {" หลักสูตร " + DataRegister[0].Major1_LEVEL_OPEN_NAME}
                    </Text>
                    <br />
                    <Text color="#1b4332" fontWeight={700}>
                      {DataRegister[0].Major1_MAJOR_ID + " : " + DataRegister[0].Major1_MAJOR_NAME}
                    </Text>
                  </Pane>
                </>
              ) : DataRegister[0].REGISTER_STATUS === "6" ? (
                <>
                  <Pane
                    color="#1b4332"
                    backgroundColor="#d8f3dc"
                    height="100%"
                    paddingY={4}
                    paddingX={5}
                    fontSize={16}
                    fontFamily=""
                    fontWeight={700}
                    marginBottom={0}
                  >
                    &nbsp;
                    <Text color="#1b4332" fontWeight={700}>
                      ยืนยันสิทธิ์ รอบ {DataRegister[0].QUOTA_NAME}{" "}
                      {DataRegister[0].ROB_NAME !== null ? DataRegister[0].ROB_NAME : ""}
                    </Text>
                    <br />
                    <Text color="#1b4332" fontWeight={700}>
                      {DataRegister[0].Major1_faculty_name}{" "}
                      {" หลักสูตร " + DataRegister[0].Major1_LEVEL_OPEN_NAME}
                    </Text>
                    <br />
                    <Text color="#1b4332" fontWeight={700}>
                      {DataRegister[0].Major1_MAJOR_ID + " : " + DataRegister[0].Major1_MAJOR_NAME}
                    </Text>
                  </Pane>
                </>
              ) : (
                <></>
              )
            ) : DataRegister[0].ROB_ID === "161" ? (
              <>
                {DataRegister[0].REGISTER_STATUS === "0" && (
                  <>
                    <Badge
                      color="yellow"
                      height="100%"
                      paddingY={4}
                      paddingX={5}
                      fontSize={16}
                      fontFamily=""
                    >
                      <FaRegMoneyBillAlt /> อยู่ระหว่างการชำระค่าสมัคร
                    </Badge>
                  </>
                )}
                {DataRegister[0].REGISTER_STATUS === "1" && (
                  <>
                    {/* <Badge
                      color="green"
                      height="100%"
                      paddingY={4}
                      paddingX={5}
                      fontSize={16}
                      fontFamily=""
                    >
                      <FaCheck /> &nbsp;ชำระค่าสมัครแล้ว
                      รอประกาศรายชื่อผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์
                    </Badge> */}
                    <Badge
                      color="green"
                      height="100%"
                      paddingY={4}
                      paddingX={5}
                      fontSize={16}
                      fontFamily=""
                    >
                      <FaCheck /> มีสิทธิ์เข้ารับการสอบสัมภาษณ์
                    </Badge>
                  </>
                )}
                {DataRegister[0].REGISTER_STATUS === "2" ||
                  (DataRegister[0].REGISTER_STATUS === "ป4" && (
                    <>
                      {/* <Badge
                      color="green"
                      height="100%"
                      paddingY={4}
                      paddingX={5}
                      fontSize={16}
                      fontFamily=""
                    >
                      <FaCheck /> &nbsp;ชำระค่าสมัครแล้ว
                      รอประกาศรายชื่อผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์
                    </Badge> */}
                      <Badge
                        color="green"
                        height="100%"
                        paddingY={4}
                        paddingX={5}
                        fontSize={16}
                        fontFamily=""
                      >
                        <FaCheck /> รอประกาศรายชื่อผู้ผ่านการคัดเลือก (ตัวจริงและตัวสำรอง)
                      </Badge>
                    </>
                  ))}
                {DataRegister[0].REGISTER_STATUS === "ป2" ||
                  (DataRegister[0].REGISTER_STATUS === "4" && (
                    <>
                      <Pane
                        color="#1b4332"
                        backgroundColor="#d8f3dc"
                        height="100%"
                        paddingY={4}
                        paddingX={5}
                        fontSize={16}
                        fontFamily=""
                        fontWeight={700}
                        marginBottom={0}
                      >
                        &nbsp;
                        <Text color="#1b4332" fontWeight={700}>
                          ✤ ผู้มีสิทธิ์เข้าศึกษา {DataRegister[0].QUOTA_NAME}{" "}
                          {DataRegister[0].ROB_NAME !== null ? DataRegister[0].ROB_NAME : ""}
                        </Text>
                        <br />
                        <Text color="#1b4332" fontWeight={700}>
                          {DataRegister[0].Major1_faculty_name}{" "}
                          {" หลักสูตร " + DataRegister[0].Major1_LEVEL_OPEN_NAME}
                        </Text>
                        <br />
                        <Text color="#1b4332" fontWeight={700}>
                          {DataRegister[0].Major1_MAJOR_ID +
                            " : " +
                            DataRegister[0].Major1_MAJOR_NAME}
                        </Text>
                      </Pane>
                      {DataRegister[0].REGISTER_ORDER !== null &&
                        DataRegister[0].REGISTER_ORDER !== "NULL" && (
                          <Pane
                            color="#8a2846"
                            backgroundColor="#ffe5ec"
                            height="100%"
                            paddingY={4}
                            paddingX={5}
                            fontSize={14}
                            fontFamily=""
                            margin={0}
                            marginTop={0}
                            fontWeight={700}
                          >
                            ● ผ่านการคัดเลือก {DataRegister[0].QUOTA_NAME} เป็น{" "}
                            {DataRegister[0].REGISTER_ORDER}
                          </Pane>
                        )}
                      {DataRegister[0].REGISTER_ORDER !== null ||
                        DataRegister[0].REGISTER_ORDER !== "NULL" ? (
                        <>
                          <Pane display="flex" flexDirection="column">
                            <Text color="red">หมายเหตุ*</Text>

                            <Text fontSize={"12px"}>
                              1.ผู้มีสิทธิ์เข้าศึกษาสามารถยืนยันสิทธิ์
                              และชำระค่าธรรมเนียมการศึกษาได้ตั้งแต่วันที่ 2 - 7 พฤษภาคม 2568
                            </Text>
                            <Text fontSize={"12px"}>
                              2.ผู้ที่ได้รับการคัดเลือกเป็นตัวสำรอง มหาวิทยาลัยฯ
                              จะประกาศผลการคัดเลือก เข้าศึกษาต่อเพิ่มเติมสำหรับทะเบียนสำรอง
                              (ตัวสำรอง) ในวันพฤหัสบดีที่ 8 พฤษภาคม 2568
                            </Text>
                            <Text fontSize={"12px"} color="red">
                              หากไม่ชำระค่าธรรมเนียมการศึกษาภายในเวลาที่กำหนด จะถือว่าสละสิทธิ์
                            </Text>
                          </Pane>
                        </>
                      ) : (
                        <>
                          <Pane display="flex" flexDirection="column">
                            <Text color="red">หมายเหตุ*</Text>

                            <Text fontSize={"12px"}>
                              1.ผู้มีสิทธิ์เข้าศึกษาสามารถยืนยันสิทธิ์
                              และชำระค่าธรรมเนียมการศึกษาได้ตั้งแต่วันที่ 2 - 7 พฤษภาคม 2568
                            </Text>
                            {/* <Text fontSize={"12px"}>
                              2.ผู้ที่ได้รับการคัดเลือกเป็นตัวสำรอง มหาวิทยาลัยฯ
                              จะประกาศผลการคัดเลือก เข้าศึกษาต่อเพิ่มเติมสำหรับทะเบียนสำรอง
                              (ตัวสำรอง) ในวันพฤหัสบดีที่ 8 พฤษภาคม 2568
                            </Text> */}
                            <Text fontSize={"12px"} color="red">
                              หากไม่ชำระค่าธรรมเนียมการศึกษาภายในเวลาที่กำหนด จะถือว่าสละสิทธิ์
                            </Text>
                          </Pane>
                        </>
                      )}
                    </>
                  ))}
                {DataRegister[0].REGISTER_STATUS === "41" && (
                  <>
                    <Pane
                      color="#8a2846"
                      backgroundColor="#ffe5ec"
                      height="100%"
                      paddingY={4}
                      paddingX={5}
                      fontSize={14}
                      fontFamily=""
                      margin={0}
                      marginTop={0}
                      fontWeight={700}
                    >
                      ● ผ่านการคัดเลือก {DataRegister[0].QUOTA_NAME} เป็น{" "}
                      {DataRegister[0].REGISTER_ORDER}
                    </Pane>
                    <Pane display="flex" flexDirection="column">
                      <Text color="red">หมายเหตุ*</Text>

                      <Text fontSize={"12px"}>
                        1. ผู้ที่ได้รับการคัดเลือกเป็นตัวสำรอง มหาวิทยาลัยฯ จะประกาศผลการคัดเลือก
                        เข้าศึกษาต่อเพิ่มเติมสำหรับทะเบียนสำรอง (ตัวสำรอง) ในวันพฤหัสบดีที่ 8
                        พฤษภาคม 2568 เวลา 10.00 น.
                      </Text>
                    </Pane>
                  </>
                )}
              </>
            ) : DataRegister[0].ROB_ID === "162" || DataRegister[0].ROB_ID === "163" ? (
              <>
                {DataRegister[0].REGISTER_STATUS === "0" && (
                  <>
                    <Badge
                      color="yellow"
                      height="100%"
                      paddingY={4}
                      paddingX={5}
                      fontSize={16}
                      fontFamily=""
                    >
                      <FaRegMoneyBillAlt /> อยู่ระหว่างการชำระค่าสมัคร
                    </Badge>
                  </>
                )}
                {DataRegister[0].REGISTER_STATUS === "1" ||
                  (DataRegister[0].REGISTER_STATUS === "2" && (
                    <>
                      {/* <Badge
                      color="green"
                      height="100%"
                      paddingY={4}
                      paddingX={5}
                      fontSize={16}
                      fontFamily=""
                    >
                      <FaCheck /> &nbsp;ชำระค่าสมัครแล้ว
                      รอประกาศรายชื่อผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์
                    </Badge> */}
                      <Badge
                        color="green"
                        height="100%"
                        paddingY={4}
                        paddingX={5}
                        fontSize={16}
                        fontFamily=""
                      >
                        <FaCheck /> รอประกาศรายชื่อผู้ผ่านการคัดเลือก
                      </Badge>
                    </>
                  ))}
                {DataRegister[0].REGISTER_STATUS === "4" && (
                  <>
                    <Pane
                      color="#1b4332"
                      backgroundColor="#d8f3dc"
                      height="100%"
                      paddingY={4}
                      paddingX={5}
                      fontSize={16}
                      fontFamily=""
                      fontWeight={700}
                      marginBottom={0}
                    >
                      &nbsp;
                      <Text color="#1b4332" fontWeight={700}>
                        ✤ ผู้มีสิทธิ์เข้าศึกษา {DataRegister[0].QUOTA_NAME}{" "}
                        {DataRegister[0].ROB_NAME !== null ? DataRegister[0].ROB_NAME : ""}
                      </Text>
                      <br />
                      <Text color="#1b4332" fontWeight={700}>
                        {DataRegister[0].Major1_faculty_name}{" "}
                        {" หลักสูตร " + DataRegister[0].Major1_LEVEL_OPEN_NAME}
                      </Text>
                      <br />
                      <Text color="#1b4332" fontWeight={700}>
                        {DataRegister[0].Major1_MAJOR_ID +
                          " : " +
                          DataRegister[0].Major1_MAJOR_NAME}
                      </Text>
                    </Pane>
                  </>
                )}
                {(DataRegister[0].REGISTER_STATUS === "6" ||
                  DataRegister[0].REGISTER_STATUS === "9") && (
                    <>
                      { }
                      <Pane
                        color="#1b4332"
                        backgroundColor="#d8f3dc"
                        height="100%"
                        paddingY={4}
                        paddingX={5}
                        fontSize={16}
                        fontFamily=""
                        fontWeight={700}
                        marginBottom={0}
                      >
                        ยืนยันสิทธิ์
                        {DataRegister[0].QUOTA_NAME +
                          " " +
                          (DataRegister[0].ROB_NAME !== null ? DataRegister[0].ROB_NAME : "") +
                          " " +
                          DataRegister[0].Major1_faculty_name +
                          " หลักสูตร " +
                          DataRegister[0].Major1_LEVEL_OPEN_NAME +
                          " " +
                          DataRegister[0].Major1_MAJOR_ID +
                          " : " +
                          DataRegister[0].Major1_MAJOR_NAME}
                      </Pane>
                    </>
                  )}
              </>
            ) : DataRegister[0].ROB_ID === "164" ? (
              <>
                {DataRegister[0].REGISTER_STATUS === "0" && (
                  <>
                    <Badge
                      color="yellow"
                      height="100%"
                      paddingY={4}
                      paddingX={5}
                      fontSize={16}
                      fontFamily=""
                    >
                      <FaRegMoneyBillAlt /> อยู่ระหว่างการชำระค่าสมัคร
                    </Badge>
                  </>
                )}
                {DataRegister[0].REGISTER_STATUS === "1" && (
                  <>
                    {/* <Badge
                      color="green"
                      height="100%"
                      paddingY={4}
                      paddingX={5}
                      fontSize={16}
                      fontFamily=""
                    >
                      <FaCheck /> &nbsp;ชำระค่าสมัครแล้ว
                      รอประกาศรายชื่อผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์
                    </Badge> */}
                    <Badge
                      color="green"
                      height="100%"
                      paddingY={4}
                      paddingX={5}
                      fontSize={16}
                      fontFamily=""
                    >
                      <FaCheck /> มีสิทธิ์เข้ารับการสอบสัมภาษณ์
                    </Badge>
                  </>
                )}
                {DataRegister[0].REGISTER_STATUS === "4" && (
                  <>
                    <Pane
                      color="#1b4332"
                      backgroundColor="#d8f3dc"
                      height="100%"
                      paddingY={4}
                      paddingX={5}
                      fontSize={16}
                      fontFamily=""
                      fontWeight={700}
                      marginBottom={0}
                    >
                      &nbsp;
                      <Text color="#1b4332" fontWeight={700}>
                        ✤ ผู้มีสิทธิ์เข้าศึกษา {DataRegister[0].QUOTA_NAME}{" "}
                        {DataRegister[0].ROB_NAME !== null ? DataRegister[0].ROB_NAME : ""}
                      </Text>
                      <br />
                      <Text color="#1b4332" fontWeight={700}>
                        {DataRegister[0].Major1_faculty_name}{" "}
                        {" หลักสูตร " + DataRegister[0].Major1_LEVEL_OPEN_NAME}
                      </Text>
                      <br />
                      <Text color="#1b4332" fontWeight={700}>
                        {DataRegister[0].Major1_MAJOR_ID +
                          " : " +
                          DataRegister[0].Major1_MAJOR_NAME}
                      </Text>
                    </Pane>
                  </>
                )}
                {DataRegister[0].REGISTER_STATUS === "6" && (
                  <>
                    <Pane
                      color="#1b4332"
                      backgroundColor="#d8f3dc"
                      height="100%"
                      paddingY={4}
                      paddingX={5}
                      fontSize={16}
                      fontFamily=""
                      fontWeight={700}
                      marginBottom={0}
                    >
                      &nbsp;
                      <Text color="#1b4332" fontWeight={700}>
                        ยืนยันสิทธิ์ รอบ {DataRegister[0].QUOTA_NAME}{" "}
                        {DataRegister[0].ROB_NAME !== null ? DataRegister[0].ROB_NAME : ""}
                      </Text>
                      <br />
                      <Text color="#1b4332" fontWeight={700}>
                        {DataRegister[0].Major1_faculty_name}{" "}
                        {" หลักสูตร " + DataRegister[0].Major1_LEVEL_OPEN_NAME}
                      </Text>
                      <br />
                      <Text color="#1b4332" fontWeight={700}>
                        {DataRegister[0].Major1_MAJOR_ID +
                          " : " +
                          DataRegister[0].Major1_MAJOR_NAME}
                      </Text>
                    </Pane>
                  </>
                )}
              </>
            ) : DataRegister[0].ROB_ID === "165" ? (
              <>
                {DataRegister[0].REGISTER_STATUS === "0" && (
                  <>
                    <Badge
                      color="yellow"
                      height="100%"
                      paddingY={4}
                      paddingX={5}
                      fontSize={16}
                      fontFamily=""
                    >
                      <FaRegMoneyBillAlt /> อยู่ระหว่างการชำระค่าสมัคร
                    </Badge>
                  </>
                )}
                {DataRegister[0].REGISTER_STATUS === "1" && (
                  <>
                    <Badge
                      color="green"
                      height="100%"
                      paddingY={4}
                      paddingX={5}
                      fontSize={16}
                      fontFamily=""
                    >
                      <FaCheck /> &nbsp;ชำระค่าสมัครแล้ว
                      รอประกาศรายชื่อผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์
                    </Badge>
                  </>
                )}
                {DataRegister[0].REGISTER_STATUS === "4" && (
                  <>
                    <Pane
                      color="#1b4332"
                      backgroundColor="#d8f3dc"
                      height="100%"
                      paddingY={4}
                      paddingX={5}
                      fontSize={16}
                      fontFamily=""
                      fontWeight={700}
                      marginBottom={0}
                    >
                      &nbsp;
                      <Text color="#1b4332" fontWeight={700}>
                        ✤ ผู้มีสิทธิ์เข้าศึกษา {DataRegister[0].QUOTA_NAME}{" "}
                        {DataRegister[0].ROB_NAME !== null ? DataRegister[0].ROB_NAME : ""}
                      </Text>
                      <br />
                      <Text color="#1b4332" fontWeight={700}>
                        {DataRegister[0].Major1_faculty_name}{" "}
                        {" หลักสูตร " + DataRegister[0].Major1_LEVEL_OPEN_NAME}
                      </Text>
                      <br />
                      <Text color="#1b4332" fontWeight={700}>
                        {DataRegister[0].Major1_MAJOR_ID +
                          " : " +
                          DataRegister[0].Major1_MAJOR_NAME}
                      </Text>
                    </Pane>
                  </>
                )}
                {DataRegister[0].REGISTER_STATUS === "6" && (
                  <>
                    <Pane
                      color="#1b4332"
                      backgroundColor="#d8f3dc"
                      height="100%"
                      paddingY={4}
                      paddingX={5}
                      fontSize={16}
                      fontFamily=""
                      fontWeight={700}
                      marginBottom={0}
                    >
                      &nbsp;
                      <Text color="#1b4332" fontWeight={700}>
                        ยืนยันสิทธิ์ รอบ {DataRegister[0].QUOTA_NAME}{" "}
                        {DataRegister[0].ROB_NAME !== null ? DataRegister[0].ROB_NAME : ""}
                      </Text>
                      <br />
                      <Text color="#1b4332" fontWeight={700}>
                        {DataRegister[0].Major1_faculty_name}{" "}
                        {" หลักสูตร " + DataRegister[0].Major1_LEVEL_OPEN_NAME}
                      </Text>
                      <br />
                      <Text color="#1b4332" fontWeight={700}>
                        {DataRegister[0].Major1_MAJOR_ID +
                          " : " +
                          DataRegister[0].Major1_MAJOR_NAME}
                      </Text>
                    </Pane>
                  </>
                )}
              </>
            ) : DataRegister[0].ROB_ID === "168" ? (
              <>
                {DataRegister[0].REGISTER_STATUS === "0" && (
                  <>
                    <Badge
                      color="yellow"
                      height="100%"
                      paddingY={4}
                      paddingX={5}
                      fontSize={16}
                      fontFamily=""
                    >
                      <FaRegMoneyBillAlt /> อยู่ระหว่างการชำระค่าสมัคร
                    </Badge>
                  </>
                )}
                {DataRegister[0].REGISTER_STATUS === "1" && (
                  <>
                    <Badge
                      color="green"
                      height="100%"
                      paddingY={4}
                      paddingX={5}
                      fontSize={16}
                      fontFamily=""
                    >
                      <FaCheck /> &nbsp;ชำระค่าสมัครแล้ว
                      รอประกาศรายชื่อผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์
                    </Badge>
                  </>
                )}
                {/* {DataRegister[0].REGISTER_STATUS === "4" && (
                  <>
                    <Badge
                      color="green"
                      height="100%"
                      paddingY={4}
                      paddingX={5}
                      fontSize={16}
                      fontFamily=""
                    >
                      <FaCheck /> &nbsp;ชำระค่าสมัครแล้ว
                      รอประกาศรายชื่อผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์
                    </Badge>
                  </>
                )} */}
                {DataRegister[0].REGISTER_STATUS === "6" && (
                  <>
                    <Pane
                      color="#1b4332"
                      backgroundColor="#d8f3dc"
                      height="100%"
                      paddingY={4}
                      paddingX={5}
                      fontSize={16}
                      fontFamily=""
                      fontWeight={700}
                      marginBottom={0}
                    >
                      &nbsp;
                      <Text color="#1b4332" fontWeight={700}>
                        ยืนยันสิทธิ์ รอบ {DataRegister[0].QUOTA_NAME}{" "}
                        {DataRegister[0].ROB_NAME !== null ? DataRegister[0].ROB_NAME : ""}
                      </Text>
                      <br />
                      <Text color="#1b4332" fontWeight={700}>
                        {DataRegister[0].Major1_faculty_name}{" "}
                        {" หลักสูตร " + DataRegister[0].Major1_LEVEL_OPEN_NAME}
                      </Text>
                      <br />
                      <Text color="#1b4332" fontWeight={700}>
                        {DataRegister[0].Major1_MAJOR_ID +
                          " : " +
                          DataRegister[0].Major1_MAJOR_NAME}
                      </Text>
                    </Pane>
                  </>
                )}
              </>
            ) : DataRegister[0].ROB_ID === "166" ? (
              <>
                {DataRegister[0].REGISTER_STATUS === "0" && (
                  <>
                    <Badge
                      color="yellow"
                      height="100%"
                      paddingY={4}
                      paddingX={5}
                      fontSize={16}
                      fontFamily=""
                    >
                      <FaRegMoneyBillAlt /> อยู่ระหว่างการชำระค่าสมัคร
                    </Badge>
                  </>
                )}
                {DataRegister[0].REGISTER_STATUS === "1" && (
                  <>
                    <Badge
                      color="green"
                      height="100%"
                      paddingY={4}
                      paddingX={5}
                      fontSize={16}
                      fontFamily=""
                    >
                      <FaCheck /> &nbsp;ชำระค่าสมัครแล้ว
                      รอประกาศรายชื่อผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์
                    </Badge>
                  </>
                )}
                {DataRegister[0].REGISTER_STATUS === "4" && (
                  <>
                    <Pane
                      color="#1b4332"
                      backgroundColor="#d8f3dc"
                      height="100%"
                      paddingY={4}
                      paddingX={5}
                      fontSize={16}
                      fontFamily=""
                      fontWeight={700}
                      marginBottom={0}
                    >
                      &nbsp;
                      <Text color="#1b4332" fontWeight={700}>
                        ผ่านการคัดเลือก รอบ {DataRegister[0].QUOTA_NAME}{" "}
                        {DataRegister[0].ROB_NAME !== null ? DataRegister[0].ROB_NAME : ""}
                      </Text>
                      <br />
                      <Text color="#1b4332" fontWeight={700}>
                        {DataRegister[0].Major1_faculty_name}{" "}
                        {" หลักสูตร " + DataRegister[0].Major1_LEVEL_OPEN_NAME}
                      </Text>
                      <br />
                      <Text color="#1b4332" fontWeight={700}>
                        {DataRegister[0].Major1_MAJOR_ID +
                          " : " +
                          DataRegister[0].Major1_MAJOR_NAME}
                      </Text>
                    </Pane>
                  </>
                )}
                {DataRegister[0].REGISTER_STATUS === "6" && (
                  <>
                    <Pane
                      color="#1b4332"
                      backgroundColor="#d8f3dc"
                      height="100%"
                      paddingY={4}
                      paddingX={5}
                      fontSize={16}
                      fontFamily=""
                      fontWeight={700}
                      marginBottom={0}
                    >
                      &nbsp;
                      <Text color="#1b4332" fontWeight={700}>
                        ยืนยันสิทธิ์ รอบ {DataRegister[0].QUOTA_NAME}{" "}
                        {DataRegister[0].ROB_NAME !== null ? DataRegister[0].ROB_NAME : ""}
                      </Text>
                      <br />
                      <Text color="#1b4332" fontWeight={700}>
                        {DataRegister[0].Major1_faculty_name}{" "}
                        {" หลักสูตร " + DataRegister[0].Major1_LEVEL_OPEN_NAME}
                      </Text>
                      <br />
                      <Text color="#1b4332" fontWeight={700}>
                        {DataRegister[0].Major1_MAJOR_ID +
                          " : " +
                          DataRegister[0].Major1_MAJOR_NAME}
                      </Text>
                    </Pane>
                  </>
                )}
              </>
            ) : DataRegister[0].ROB_ID === "167" ? (
              <>
                {DataRegister[0].REGISTER_STATUS === "0" && (
                  <>
                    <Badge
                      color="yellow"
                      height="100%"
                      paddingY={4}
                      paddingX={5}
                      fontSize={16}
                      fontFamily=""
                    >
                      <FaRegMoneyBillAlt /> อยู่ระหว่างการชำระค่าสมัคร
                    </Badge>
                  </>
                )}
                {DataRegister[0].REGISTER_STATUS === "1" && (
                  <>
                    <Badge
                      color="green"
                      height="100%"
                      paddingY={4}
                      paddingX={5}
                      fontSize={16}
                      fontFamily=""
                    >
                      <FaCheck /> &nbsp;ชำระค่าสมัครแล้ว
                      รอประกาศรายชื่อผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์
                    </Badge>
                  </>
                )}
                {DataRegister[0].REGISTER_STATUS === "4" && (
                  <>
                    <Pane
                      color="#1b4332"
                      backgroundColor="#d8f3dc"
                      height="100%"
                      paddingY={4}
                      paddingX={5}
                      fontSize={16}
                      fontFamily=""
                      fontWeight={700}
                      marginBottom={0}
                    >
                      &nbsp;
                      <Text color="#1b4332" fontWeight={700}>
                        {!AllowPayNurse() ? "ผู้มีสิทธิ์เข้าศึกษา" : "ผ่านการคัดเลือก (ตัวจริง)"}{" "}
                        {DataRegister[0].QUOTA_NAME}{" "}
                        {DataRegister[0].ROB_NAME !== null ? DataRegister[0].ROB_NAME : ""}
                      </Text>
                      <br />
                      <Text color="#1b4332" fontWeight={700}>
                        {DataRegister[0].Major1_faculty_name}{" "}
                        {" หลักสูตร " + DataRegister[0].Major1_LEVEL_OPEN_NAME}
                      </Text>
                      <br />
                      <Text color="#1b4332" fontWeight={700}>
                        {DataRegister[0].Major1_MAJOR_ID +
                          " : " +
                          DataRegister[0].Major1_MAJOR_NAME}
                      </Text>
                    </Pane>
                    <Pane
                      hidden={AllowPayNurse()}
                      backgroundColor={"#fffae5"}
                      color="#c36f09"
                      paddingY={4}
                      paddingX={5}
                      fontSize={14}
                      fontFamily=""
                      margin={0}
                      marginTop={0}
                      fontWeight={700}
                    >
                      ส่งผลการตรวจร่างกายฉบับจริง ตั้งแต่วันที่ 29 - 31 พฤษภาคม 2568 ณ
                      อาคารคณะพยาบาลศาสตร์ มหาวิทยาลัยราชภัฏกำแพงเพชร
                    </Pane>
                    {/* <Pane
                    hidden={
                      DataRegister[0].REGISTER_ORDER_NUMBER === null ||
                      DataRegister[0].Major1_LEVEL_OPEN_NAME === "ครุศาสตรบัณฑิต"
                    }
                    color="#8a2846"
                    backgroundColor="#ffe5ec"
                    height="100%"
                    paddingY={4}
                    paddingX={5}
                    fontSize={14}
                    fontFamily=""
                    margin={0}
                    marginTop={0}
                    fontWeight={700}
                  >
                    ผ่านการคัดเลือกเป็น {DataRegister[0].REGISTER_ORDER}
                  </Pane> */}
                  </>
                )}
                {DataRegister[0].REGISTER_STATUS === "4ป" && (
                  <>
                    <Pane
                      color="#1b4332"
                      backgroundColor="#d8f3dc"
                      height="100%"
                      paddingY={4}
                      paddingX={5}
                      fontSize={16}
                      fontFamily=""
                      fontWeight={700}
                      marginBottom={0}
                    >
                      &nbsp;
                      <Text color="#1b4332" fontWeight={700}>
                        ผ่านการคัดเลือก รอบ {DataRegister[0].QUOTA_NAME}{" "}
                        {DataRegister[0].ROB_NAME !== null ? DataRegister[0].ROB_NAME : ""}
                      </Text>
                      <br />
                      <Text color="#1b4332" fontWeight={700}>
                        {DataRegister[0].Major1_faculty_name}{" "}
                        {" หลักสูตร " + DataRegister[0].Major1_LEVEL_OPEN_NAME}
                      </Text>
                      <br />
                      <Text color="#1b4332" fontWeight={700}>
                        {DataRegister[0].Major1_MAJOR_ID +
                          " : " +
                          DataRegister[0].Major1_MAJOR_NAME}
                      </Text>
                    </Pane>
                  </>
                )}
                {DataRegister[0].REGISTER_STATUS === "6" && (
                  <>
                    <Pane
                      color="#1b4332"
                      backgroundColor="#d8f3dc"
                      height="100%"
                      paddingY={4}
                      paddingX={5}
                      fontSize={16}
                      fontFamily=""
                      fontWeight={700}
                      marginBottom={0}
                    >
                      &nbsp;
                      <Text color="#1b4332" fontWeight={700}>
                        ยืนยันสิทธิ์ รอบ {DataRegister[0].QUOTA_NAME}{" "}
                        {DataRegister[0].ROB_NAME !== null ? DataRegister[0].ROB_NAME : ""}
                      </Text>
                      <br />
                      <Text color="#1b4332" fontWeight={700}>
                        {DataRegister[0].Major1_faculty_name}{" "}
                        {" หลักสูตร " + DataRegister[0].Major1_LEVEL_OPEN_NAME}
                      </Text>
                      <br />
                      <Text color="#1b4332" fontWeight={700}>
                        {DataRegister[0].Major1_MAJOR_ID +
                          " : " +
                          DataRegister[0].Major1_MAJOR_NAME}
                      </Text>
                    </Pane>
                  </>
                )}
              </>
            ) : DataRegister[0].ROB_ID === "169" ? (
              <>
                <div className="d-flex flex-column">
                  {DataRegister[0].REGISTER_STATUS === "0" && (
                    <>
                      <div>
                        <Badge
                          color="yellow"
                          width="300px"
                          height="100%"
                          paddingY={4}
                          paddingX={5}
                          fontSize={16}
                          fontFamily=""
                        >
                          <FaRegMoneyBillAlt /> อยู่ระหว่างการชำระค่าสมัคร
                        </Badge>
                      </div>
                    </>
                  )}
                  {DataRegister[0].REGISTER_STATUS === "1" && (
                    <>
                      <div>
                        <Badge
                          color="green"
                          height="100%"
                          paddingY={4}
                          paddingX={5}
                          fontSize={16}
                          fontFamily=""
                        >
                          {/* <FaCheck /> &nbsp;ชำระค่าสมัครแล้ว
                          รอประกาศรายชื่อผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์ */}
                          <FaCheck /> &nbsp;มีสิทธิ์เข้ารับการสอบวัดความรู้พื้นฐานทางวิชาชีพครู
                        </Badge>
                      </div>
                    </>
                  )}
                  {DataRegister[0].REGISTER_STATUS === "2" && (
                    <>
                      <div>
                        <Badge
                          color="green"
                          height="100%"
                          paddingY={4}
                          paddingX={5}
                          fontSize={16}
                          fontFamily=""
                        >
                          <FaCheck /> &nbsp; รอประกาศรายชื่อผู้ผ่านการคัดเลือก
                        </Badge>
                      </div>
                    </>
                  )}
                  {(DataRegister[0].REGISTER_STATUS === "6" ||
                    DataRegister[0].REGISTER_STATUS === "9") && (
                      <>
                        <Pane
                          color="#1b4332"
                          backgroundColor="#d8f3dc"
                          height="100%"
                          paddingY={4}
                          paddingX={5}
                          fontSize={16}
                          fontFamily=""
                          fontWeight={700}
                          marginBottom={0}
                        >
                          &nbsp;
                          <Text color="#1b4332" fontWeight={700}>
                            ยืนยันสิทธิ์ รอบ {DataRegister[0].QUOTA_NAME}{" "}
                            {DataRegister[0].ROB_NAME !== null ? DataRegister[0].ROB_NAME : ""}
                          </Text>
                          <br />
                          <Text color="#1b4332" fontWeight={700}>
                            {DataRegister[0].Major1_faculty_name}{" "}
                            {" หลักสูตร " + DataRegister[0].Major1_LEVEL_OPEN_NAME}
                          </Text>
                          <br />
                          <Text color="#1b4332" fontWeight={700}>
                            {DataRegister[0].Major1_MAJOR_ID +
                              " : " +
                              DataRegister[0].Major1_MAJOR_NAME}
                          </Text>
                        </Pane>
                      </>
                    )}
                  {DataRegister[0].REGISTER_STATUS === "4" && (
                    <>
                      <div>
                        <Pane
                          color="#1b4332"
                          backgroundColor="#d8f3dc"
                          height="100%"
                          paddingY={4}
                          paddingX={5}
                          fontSize={16}
                          fontFamily=""
                          fontWeight={700}
                          marginBottom={0}
                        >
                          &nbsp;
                          <Text color="#1b4332" fontWeight={700}>
                            ผ่านการคัดเลือก รอบ {DataRegister[0].QUOTA_NAME}{" "}
                            {DataRegister[0].ROB_NAME !== null ? DataRegister[0].ROB_NAME : ""}
                          </Text>
                          <br />
                          <Text color="#1b4332" fontWeight={700}>
                            {DataRegister[0].Major1_faculty_name}{" "}
                            {" หลักสูตร " + DataRegister[0].Major1_LEVEL_OPEN_NAME}
                          </Text>
                          <br />
                          <Text color="#1b4332" fontWeight={700}>
                            {DataRegister[0].Major1_MAJOR_ID +
                              " : " +
                              DataRegister[0].Major1_MAJOR_NAME}
                          </Text>
                        </Pane>
                      </div>
                    </>
                  )}
                  <Pane backgroundColor="white" padding={10}>
                    <Text
                      fontWeight={600}
                      fontFamily=""
                      fontSize={14}
                      paddingTop={5}
                      marginBottom={10}
                    >
                      รายละเอียดที่สมัคร
                    </Text>
                    <Pane gap={10} flexDirection={"column"}>
                      {ListMajor.map((item, key) => (
                        <>
                          <Pane marginBottom={10} padding={10} borderRadius={8} key={key}>
                            <Pane fontWeight={600}>
                              <Text fontWeight={700} style={{ color: "#fe7f2d" }}>
                                ลำดับที่ {key + 1}
                              </Text>
                              &nbsp; หลักสูตร
                              {item.Major_LEVEL_OPEN_NAME +
                                " " +
                                item.Major_course_year +
                                " ปี  " +
                                item.Major_MAJOR_ID +
                                " : สาขาวิชา" +
                                item.Major_MAJOR_NAME}
                            </Pane>
                            {DataRegister[0].REGISTER_STATUS === "0" ? (
                              <>
                                {key + 1 === 1 && (
                                  <Text marginTop={10} marginLeft={15} className="text-warning">
                                    รอการชำระเงินค่าสมัคร
                                  </Text>
                                )}
                              </>
                            ) : DataRegister[0].REGISTER_STATUS === "1" ? (
                              <>
                                {key + 1 === 1 ? (
                                  <>
                                    <Text fontWeight={700} className="text-info">
                                      * รายละเอียดวันเวลาและสถานที่สอบสัมภาษณ์
                                    </Text>
                                    <Pane display="flex" flexDirection={"column"}>
                                      <div className="d-flex">
                                        <Text fontWeight={600}>วันเวลา :&nbsp; &nbsp;</Text>
                                        <div> {item.Major_MAJOR_CLASSROOM}</div>
                                      </div>
                                      <div className="d-flex">
                                        <Text fontWeight={600}>สถานที่ :&nbsp; &nbsp;</Text>
                                        <div> {item.Major_MAJOR_CLASSROOM2} </div>
                                      </div>
                                      <div className="d-flex">
                                        <Text fontWeight={600}>
                                          &nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp;
                                          &nbsp;&nbsp; &nbsp;
                                        </Text>
                                        <div> {item.Major_MAJOR_CLASSROOM3} </div>
                                      </div>
                                    </Pane>
                                    <Text
                                      hidden={ListMajor.length !== key + 1}
                                      fontWeight={600}
                                      className="text-danger"
                                    >
                                      {" "}
                                      <br />
                                      หมายเหตุ : ให้ผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์
                                      ศึกษารายละเอียดในประกาศรายชื่อผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์ฯ
                                    </Text>
                                  </>
                                ) : (
                                  <></>
                                )}
                              </>
                            ) : DataRegister[0].REGISTER_STATUS === "4" ? (
                              <Pane display="flex" flexDirection="column">
                                <Text color="red">หมายเหตุ*</Text>

                                <Text fontSize={"12px"}>
                                  1. กรอกข้อมูลทะเบียนประวัติ และอัปโหลดเอกสารรายงานตัว
                                </Text>
                                <Text fontSize={"12px"}>2. ศึกษารายละเอียดในประกาศ</Text>
                              </Pane>
                            ) : DataRegister[0].REGISTER_STATUS === "6" ||
                              DataRegister[0].REGISTER_STATUS === "9" ? (
                              <Pane display="flex" flexDirection="column">
                                <Text color="red">หมายเหตุ*</Text>
                                <Text fontSize={"12px"}>
                                  1. กรอกข้อมูลทะเบียนประวัติ และอัปโหลดเอกสารรายงานตัว
                                </Text>
                                <Text fontSize={"12px"}>2. ศึกษารายละเอียดในประกาศ</Text>
                              </Pane>
                            ) : (
                              <></>
                            )}
                          </Pane>
                        </>
                      ))}
                    </Pane>
                  </Pane>
                </div>
              </>
            ) : DataRegister[0].ROB_ID === "171" ? (
              <>
                <Pane
                  backgroundColor="#f8f9fa"
                  height="100%"
                  paddingY={4}
                  paddingX={5}
                  fontSize={16}
                  fontFamily=""
                  fontWeight={700}
                  marginBottom={0}
                  borderRadius={4}
                >
                  {DataRegister[0].REGISTER_STATUS === "41" ? (
                    <Text className="text-warning" fontWeight={700}>
                      ผ่านการคัดเลือกเป็นตัวสำรอง
                    </Text>
                  ) : DataRegister[0].REGISTER_STATUS === "0" ? (
                    <Text className="text-warning" fontWeight={700}>
                      <FaRegMoneyBillAlt /> อยู่ระหว่างการชำระค่าสมัคร
                    </Text>
                  ) : DataRegister[0].REGISTER_STATUS === "1" ? (
                    <Text className="text-success" fontWeight={700}>
                      <FaCheck /> &nbsp;
                      {/* ชำระค่าสมัครแล้ว */}
                      {/* รอประกาศรายชื่อผู้ */}
                      มีสิทธิ์เข้ารับการสอบสัมภาษณ์
                    </Text>
                  ) : DataRegister[0].REGISTER_STATUS === "4" ? (
                    <>
                      <Text color="#38b000" fontWeight={700}>
                        ผ่านการคัดเลือก รอบ {DataRegister[0].QUOTA_NAME}{" "}
                        {DataRegister[0].ROB_NAME !== null ? DataRegister[0].ROB_NAME : ""}
                      </Text>
                      <br />
                      <Text color="#38b000" fontWeight={700}>
                        {DataRegister[0].Major1_faculty_name}
                        {" หลักสูตร " + DataRegister[0].Major1_LEVEL_OPEN_NAME}
                      </Text>
                      <br />
                      <Text color="#38b000" fontWeight={700}>
                        {DataRegister[0].Major1_MAJOR_ID +
                          " : " +
                          DataRegister[0].Major1_MAJOR_NAME}
                      </Text>
                    </>
                  ) : DataRegister[0].REGISTER_STATUS === "6" ||
                    DataRegister[0].REGISTER_STATUS === "9" ? (
                    <>
                      <Text className="text-info" fontWeight={700}>
                        ยืนยันสิทธิ์ รอบ {DataRegister[0].QUOTA_NAME}
                        {DataRegister[0].ROB_NAME !== null ? DataRegister[0].ROB_NAME : ""}
                      </Text>
                      <br />
                      <Text className="text-info" fontWeight={700}>
                        {DataRegister[0].Major1_faculty_name}
                        {" หลักสูตร " + DataRegister[0].Major1_LEVEL_OPEN_NAME}
                      </Text>
                      <br />
                      <Text className="text-info" fontWeight={700}>
                        {DataRegister[0].Major1_MAJOR_ID +
                          " : " +
                          DataRegister[0].Major1_MAJOR_NAME}
                      </Text>
                    </>
                  ) : (
                    <></>
                  )}
                </Pane>
                <Pane marginTop={10} padding={5} borderRadius={6} backgroundColor="white">
                  <Text
                    fontWeight={600}
                    fontFamily=""
                    fontSize={14}
                    paddingTop={5}
                    marginBottom={0}
                  >
                    รายละเอียดที่สมัคร
                  </Text>
                  <Pane gap={10} flexDirection={"column"}>
                    {ListMajor.map((item, key) => (
                      <>
                        <Pane marginBottom={10} padding={10} borderRadius={8} key={key}>
                          <>
                            <Text fontWeight={700} style={{ color: "#fe7f2d" }}>
                              ลำดับที่ {key + 1}
                            </Text>
                            &nbsp; หลักสูตร
                            {item.Major_LEVEL_OPEN_NAME +
                              " " +
                              item.Major_course_year +
                              " ปี  " +
                              item.Major_MAJOR_ID +
                              " : สาขาวิชา" +
                              item.Major_MAJOR_NAME}
                          </>
                          {/* <Pane>
                            <Text fontWeight={700} className="text-info">
                              * รายละเอียดวันเวลาและสถานที่สอบสัมภาษณ์
                            </Text>
                            <Pane display="flex" flexDirection={"column"}>
                              <div className="d-flex">
                                <Text fontWeight={600}>วันเวลา :&nbsp; &nbsp;</Text>
                                <div> {item.Major_MAJOR_CLASSROOM}</div>
                              </div>
                              <div className="d-flex">
                                <Text fontWeight={600}>สถานที่ :&nbsp; &nbsp;</Text>
                                <div> {item.Major_MAJOR_CLASSROOM2} </div>
                              </div>
                              <div className="d-flex">
                                <Text fontWeight={600}>
                                  &nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp;
                                  &nbsp;&nbsp; &nbsp;
                                </Text>
                                <div> {item.Major_MAJOR_CLASSROOM3} </div>
                              </div>
                            </Pane>
                            <Text
                              hidden={ListMajor.length !== key + 1}
                              fontWeight={600}
                              className="text-danger"
                            >
                              {" "}
                              <br />
                              หมายเหตุ : ให้ผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์
                              ศึกษารายละเอียดในประกาศรายชื่อผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์ฯ
                            </Text>
                          </Pane> */}
                        </Pane>
                      </>
                    ))}
                  </Pane>
                  <>{ }</>
                  <Pane paddingX={10} margin={0} borderRadius={6} backgroundColor="white">
                    <Pane display="flex" flexDirection="column">
                      {DataRegister[0].REGISTER_STATUS === "0" ||
                        DataRegister[0].REGISTER_STATUS === "1" ? (
                        <>
                          <Text color="red">หมายเหตุ*</Text>
                          <Text fontSize={"12px"}>
                            1. ชำระเงินค่าสมัครตั้งแต่วันที่ 28 สิงหาคม 2568 - 9 กันยายน 2568
                          </Text>
                          <Text fontSize={"12px"}>
                            2. ประกาศรายชื่อผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์ วันที่ 10 กันยายน 2568
                          </Text>
                        </>
                      ) : DataRegister[0].REGISTER_STATUS === "4" ? (
                        <Pane display="flex" flexDirection="column">
                          <Text color="red">หมายเหตุ*</Text>

                          <Text fontSize={"12px"}>
                            1. ผู้มีสิทธิ์เข้าศึกษา (ตัวจริง) สามารถยืนสิทธิ์
                            และชำระค่าธรรมเนียมการศึกษาได้ตั้งแต่วันที่ 15-18 กันยายน 2568
                          </Text>
                        </Pane>
                      ) : DataRegister[0].REGISTER_STATUS === "41" ? (
                        <Pane display="flex" flexDirection="column">
                          <Text color="red">หมายเหตุ*</Text>

                          <Text fontSize={"12px"}>
                            1. ผู้ผ่านการคัดเลือกเป็นตัวสำรอง ตรวจสอบรายละเอียดในประกาศ
                          </Text>
                        </Pane>
                      ) : DataRegister[0].REGISTER_STATUS === "6" ||
                        DataRegister[0].REGISTER_STATUS === "9" ? (
                        <Pane display="flex" flexDirection="column">
                          <Text color="red">หมายเหตุ*</Text>
                          <Text fontSize={"12px"}>
                            1. กรอกข้อมูลทะเบียนประวัติ และอัปโหลดเอกสารรายงานตัว ตั้งแต่ วันที่ 15
                            - 19 กันยายน 2568
                          </Text>
                        </Pane>
                      ) : (
                        <></>
                      )}
                    </Pane>
                  </Pane>
                </Pane>
              </>
            ) : // 202.12.117.137
              DataRegister[0].ROB_ID === "172" ? (
                <>
                  <Pane
                    backgroundColor="#f8f9fa"
                    height="100%"
                    paddingY={4}
                    paddingX={5}
                    fontSize={16}
                    fontFamily=""
                    fontWeight={700}
                    marginBottom={0}
                    borderRadius={4}
                  >
                    {DataRegister[0].REGISTER_STATUS === "0" ? (
                      <Text className="text-warning" fontWeight={700}>
                        <FaRegMoneyBillAlt /> อยู่ระหว่างการชำระค่าสมัคร
                      </Text>
                    ) : DataRegister[0].REGISTER_STATUS === "1" ? (
                      <Text className="text-success" fontWeight={700}>
                        <FaCheck /> &nbsp;ชำระค่าสมัครแล้ว
                        ประกาศรายชื่อผู้มีสิทธิ์เข้ารับการสอบคัดเลือก
                      </Text>
                    ) : DataRegister[0].REGISTER_STATUS === "4" ? (
                      <>
                        {/* <Text color="#38b000" fontWeight={700}>
                        ผ่านการคัดเลือก {DataRegister[0].QUOTA_NAME}{" "}
                        {DataRegister[0].ROB_NAME !== null ? DataRegister[0].ROB_NAME : ""}
                      </Text>
                      <br />
                      <Text color="#38b000" fontWeight={700}>
                        {DataRegister[0].Major1_faculty_name}
                        {" หลักสูตร " + DataRegister[0].Major1_LEVEL_OPEN_NAME}
                      </Text>
                      <br />
                      <Text color="#38b000" fontWeight={700}>
                        {DataRegister[0].Major1_MAJOR_ID +
                          " : " +
                          DataRegister[0].Major1_MAJOR_NAME}
                      </Text> */}
                      </>
                    ) : DataRegister[0].REGISTER_STATUS === "6" ||
                      DataRegister[0].REGISTER_STATUS === "9" ? (
                      <>
                        <Text className="text-info" fontWeight={700}>
                          ยืนยันสิทธิ์ รอบ {DataRegister[0].QUOTA_NAME}
                          {DataRegister[0].ROB_NAME !== null ? DataRegister[0].ROB_NAME : ""}
                        </Text>
                        <br />
                        <Text className="text-info" fontWeight={700}>
                          {DataRegister[0].Major1_faculty_name}
                          {" หลักสูตร " + DataRegister[0].Major1_LEVEL_OPEN_NAME}
                        </Text>
                        <br />
                        <Text className="text-info" fontWeight={700}>
                          {DataRegister[0].Major1_MAJOR_ID +
                            " : " +
                            DataRegister[0].Major1_MAJOR_NAME}
                        </Text>
                      </>
                    ) : (
                      <></>
                    )}
                  </Pane>
                  <Pane marginTop={10} padding={5} borderRadius={6} backgroundColor="white">
                    <Text
                      fontWeight={600}
                      fontFamily=""
                      fontSize={14}
                      paddingTop={5}
                      marginBottom={0}
                    >
                      รายละเอียดที่สมัคร
                    </Text>
                    <Pane gap={10} flexDirection={"column"}>
                      {ListMajor.map((item, key) => (
                        <>
                          <Pane marginBottom={10} padding={10} borderRadius={8} key={key}>
                            <>
                              <Text fontWeight={700} style={{ color: "#fe7f2d" }}>
                                ลำดับที่ {key + 1}
                              </Text>
                              &nbsp; หลักสูตร
                              {item.Major_LEVEL_OPEN_NAME +
                                " " +
                                item.Major_course_year +
                                " ปี  " +
                                item.Major_MAJOR_ID +
                                " : สาขาวิชา" +
                                item.Major_MAJOR_NAME}
                            </>
                          </Pane>
                        </>
                      ))}
                    </Pane>
                    <Pane paddingX={10} margin={0} borderRadius={6} backgroundColor="white">
                      <Pane display="flex" flexDirection="column">
                        <Text color="red">หมายเหตุ*</Text>
                        {DataRegister[0].REGISTER_STATUS === "0" ||
                          DataRegister[0].REGISTER_STATUS === "1" ? (
                          <>
                            <Text fontSize={"12px"}>
                              1. ชำระเงินค่าสมัครตั้งแต่วันที่ 29 สิงหาคม 2568 - 9 กันยายน 2568
                            </Text>
                            <Text fontSize={"12px"}>
                              2. ประกาศรายชื่อผู้มีสิทธิ์เข้ารับการสอบคัดเลือก วันที่ 10 กันยายน 2568
                              ที่เว็บไซต์ : https://edu.kpru.ac.th
                            </Text>
                          </>
                        ) : (
                          <></>
                        )}
                      </Pane>
                    </Pane>
                  </Pane>
                </>
              ) : (
                <></>
              )}
          </Pane>

          {DataRegister[0].ROB_ID === "151" ? (
            <>
              <Pane
                hidden={
                  DataRegister[0].REGISTER_STATUS === "41" ||
                  DataRegister[0].REGISTER_STATUS === "9" ||
                  DataRegister[0].REGISTER_STATUS === "6"
                }
                marginTop={10}
                padding={5}
                borderRadius={6}
                backgroundColor="white"
              >
                <Text fontWeight={600} fontFamily="" fontSize={14} paddingTop={5} marginBottom={10}>
                  รายละเอียดที่สมัคร
                </Text>

                <Pane gap={10} flexDirection={"column"}>
                  {ListMajor.map((item, key) => (
                    <>
                      <Pane marginBottom={10} padding={10} borderRadius={8} key={key}>
                        <Pane fontWeight={600}>
                          <Text fontWeight={700} style={{ color: "#fe7f2d" }}>
                            ลำดับที่ {key + 1}
                          </Text>
                          &nbsp; หลักสูตร
                          {item.Major_LEVEL_OPEN_NAME +
                            " " +
                            item.Major_course_year +
                            " ปี  " +
                            item.Major_MAJOR_ID +
                            " : สาขาวิชา" +
                            item.Major_MAJOR_NAME}
                        </Pane>
                        {DataRegister[0].REGISTER_STATUS === "0" ? (
                          <>
                            {key + 1 === 1 && (
                              <Text marginTop={10} marginLeft={15} className="text-warning">
                                รอการชำระเงินค่าสมัคร
                              </Text>
                            )}
                          </>
                        ) : DataRegister[0].REGISTER_STATUS === "1" ? (
                          <>
                            {key + 1 === 1 ? (
                              <>
                                <Text marginTop={10} marginLeft={15} className="text-success">
                                  {item.Major_MAJOR_ID === "8201" ? (
                                    <>
                                      <Text fontWeight={700} className="text-info">
                                        * รายละเอียดวันเวลาและสถานที่สอบสัมภาษณ์
                                      </Text>
                                      <Pane display="flex" flexDirection={"column"}>
                                        <div className="d-flex">
                                          <Text fontWeight={600}>วันเวลา :&nbsp; &nbsp;</Text>
                                          <div> {item.Major_MAJOR_CLASSROOM}</div>
                                        </div>
                                        <div className="d-flex">
                                          <Text fontWeight={600}>สถานที่ :&nbsp; &nbsp;</Text>
                                          <div> {item.Major_MAJOR_CLASSROOM2} </div>
                                        </div>
                                        <div className="d-flex">
                                          <Text fontWeight={600}>
                                            &nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp;
                                            &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;
                                          </Text>
                                          <div> {item.Major_MAJOR_CLASSROOM3} </div>
                                        </div>
                                      </Pane>
                                      <Text
                                        hidden={ListMajor.length !== key + 1}
                                        fontWeight={600}
                                        className="text-danger"
                                      >
                                        {" "}
                                        <br />
                                        หมายเหตุ : ให้ผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์
                                        ศึกษารายละเอียดในประกาศรายชื่อผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์ฯ
                                      </Text>
                                    </>
                                  ) : (
                                    // " รอประกาศรายชื่อผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์ และพิมพ์ใบสมัคร ในวันที่ 18 มีนาคม 2568 เวลา 18:00 น. เป็นต้นไป"
                                    <>
                                      <Text fontWeight={700} className="text-info">
                                        * รายละเอียดวันเวลาและสถานที่สอบสัมภาษณ์
                                      </Text>
                                      <Pane display="flex" flexDirection={"column"}>
                                        <div className="d-flex">
                                          <Text fontWeight={600}>วันเวลา :&nbsp; &nbsp;</Text>
                                          <div> {item.Major_MAJOR_CLASSROOM}</div>
                                        </div>
                                        <div className="d-flex">
                                          <Text fontWeight={600}>สถานที่ :&nbsp; &nbsp;</Text>
                                          <div> {item.Major_MAJOR_CLASSROOM2} </div>
                                        </div>
                                        <div className="d-flex">
                                          <Text fontWeight={600}>
                                            &nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp;
                                            &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;
                                          </Text>
                                          <div> {item.Major_MAJOR_CLASSROOM3} </div>
                                        </div>
                                      </Pane>
                                      <Text
                                        hidden={ListMajor.length !== key + 1}
                                        fontWeight={600}
                                        className="text-danger"
                                      >
                                        {" "}
                                        <br />
                                        หมายเหตุ : ให้ผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์
                                        ศึกษารายละเอียดในประกาศรายชื่อผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์ฯ
                                      </Text>
                                    </>
                                  )}
                                </Text>
                              </>
                            ) : (
                              <></>
                            )}
                          </>
                        ) : DataRegister[0].REGISTER_STATUS === "4" ? (
                          <></>
                          // <Pane display="flex" flexDirection="column">
                          //   <Text color="red">หมายเหตุ*</Text>

                          //   <Text fontSize={"12px"}>
                          //     1. กรอกข้อมูลทะเบียนประวัติ และอัปโหลดเอกสารรายงานตัว ตั้งแต่วันที่ 1
                          //     - 30 เมษายน 2568
                          //   </Text>
                          // </Pane>
                        ) : DataRegister[0].REGISTER_STATUS === "6" ||
                          DataRegister[0].REGISTER_STATUS === "9" ? (
                          <Pane display="flex" flexDirection="column">
                            <Text color="red">หมายเหตุ*</Text>
                            <Text fontSize={"12px"}>
                              1. กรอกข้อมูลทะเบียนประวัติ และอัปโหลดเอกสารรายงานตัว ตั้งแต่วันที่ 1
                              - 30 เมษายน 2568
                            </Text>
                          </Pane>
                        ) : (
                          <></>
                        )}
                      </Pane>
                    </>
                  ))}
                </Pane>
              </Pane>
              <Pane>
                {DataRegister[0].REGISTER_STATUS === "4" ? (
                  <></>
                  // <Pane display="flex" flexDirection="column">
                  //   <Text color="red">หมายเหตุ*</Text>
                  //   <Text fontSize={"12px"}>
                  //     1. ผู้มีสิทธิ์เข้าศึกษา (ตัวจริง) สามารถยืนยันสิทธิ์
                  //     และชำระค่าธรรมเนียมการศึกษาได้ตั้งแต่วันที่ 1 - 11 เมษายน 2568
                  //   </Text>
                  //   <Text fontSize={"12px"}>
                  //     2. กรอกข้อมูลทะเบียนประวัติ และอัปโหลดเอกสารรายงานตัว ตั้งแต่ 1 - 30 เมษายน
                  //     2568
                  //   </Text>
                  //   <Text fontSize={"12px"} color="red">
                  //     หากไม่ชำระค่าธรรมเนียมการศึกษาภายในเวลาที่กำหนด จะถือว่าสละสิทธิ์
                  //   </Text>
                  // </Pane>
                ) : DataRegister[0].REGISTER_STATUS === "41" ? (
                  <Pane display="flex" flexDirection="column">
                    <Text color="red">หมายเหตุ*</Text>
                    <Text fontSize={"12px"}>
                      1. ผู้ผ่านการคัดเลือก (ตัวจริง) สามารถยืนยันสิทธิ์
                      และชำระค่าธรรมเนียมการศึกษาได้ตั้งแต่วันที่ 21 กุมภาพันธ์ 2568 - 2 มีนาคม 2568
                    </Text>
                    <Text fontSize={"12px"}>
                      2. ประกาศผลการคัดเลือก (ตัวสำรอง) ในวันที่ 4 มีนาคม 2568
                    </Text>
                  </Pane>
                ) : DataRegister[0].REGISTER_STATUS === "11" ? (
                  <Pane display="flex" flexDirection="column">
                    <Text color="red">หมายเหตุ*</Text>
                    <Text fontSize={"12px"}>1. ติดต่อสอบถามการสมัครเรียน โทร. 055-706547</Text>
                  </Pane>
                ) : (
                  <></>
                )}
              </Pane>
            </>
          ) : DataRegister[0].ROB_ID === "170" ? (
            <>
              <Pane
                hidden={
                  DataRegister[0].REGISTER_STATUS === "41" ||
                  DataRegister[0].REGISTER_STATUS === "9" ||
                  DataRegister[0].REGISTER_STATUS === "6"
                }
                marginTop={10}
                padding={5}
                borderRadius={6}
                backgroundColor="white"
              >
                <Text fontWeight={600} fontFamily="" fontSize={14} paddingTop={5} marginBottom={10}>
                  รายละเอียดที่สมัคร
                </Text>

                <Pane gap={10} flexDirection={"column"}>
                  {ListMajor.map((item, key) => (
                    <>
                      <Pane marginBottom={10} padding={10} borderRadius={8} key={key}>
                        <Pane fontWeight={600}>
                          <Text fontWeight={700} style={{ color: "#fe7f2d" }}>
                            ลำดับที่ {key + 1}
                          </Text>
                          &nbsp; หลักสูตร
                          {item.Major_LEVEL_OPEN_NAME +
                            " " +
                            item.Major_course_year +
                            " ปี  " +
                            item.Major_MAJOR_ID +
                            " : สาขาวิชา" +
                            item.Major_MAJOR_NAME}
                        </Pane>
                        {DataRegister[0].REGISTER_STATUS === "0" ? (
                          <>
                            {key + 1 === 1 && (
                              <Text marginTop={10} marginLeft={15} className="text-warning">
                                รอการชำระเงินค่าสมัคร
                              </Text>
                            )}
                          </>
                        ) : DataRegister[0].REGISTER_STATUS === "1" ? (
                          <>
                            {key + 1 === 1 ? (
                              <>
                                <Text marginTop={10} marginLeft={15} className="text-success">
                                  {ShowListTo() ? (
                                    <>
                                      <Text fontWeight={700} className="text-info">
                                        * รายละเอียดวันเวลาและสถานที่สอบสัมภาษณ์
                                      </Text>
                                      <Pane display="flex" flexDirection={"column"}>
                                        <div className="d-flex">
                                          <Text fontWeight={600}>วันเวลา :&nbsp; &nbsp;</Text>
                                          <div> {item.Major_MAJOR_CLASSROOM}</div>
                                        </div>
                                        <div className="d-flex">
                                          <Text fontWeight={600}>สถานที่ :&nbsp; &nbsp;</Text>
                                          <div> {item.Major_MAJOR_CLASSROOM2} </div>
                                        </div>
                                        <div className="d-flex">
                                          <Text fontWeight={600}>
                                            &nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp;
                                            &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;
                                          </Text>
                                          <div> {item.Major_MAJOR_CLASSROOM3} </div>
                                        </div>
                                      </Pane>
                                      <Text
                                        hidden={ListMajor.length !== key + 1}
                                        fontWeight={600}
                                        className="text-danger"
                                      >
                                        {" "}
                                        <br />
                                        หมายเหตุ : ให้ผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์
                                        ศึกษารายละเอียดในประกาศรายชื่อผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์ฯ
                                      </Text>
                                    </>
                                  ) : (
                                    " รอประกาศรายชื่อผู้มีสิทธิ์สอบคัดเลือก และพิมพ์ใบสมัคร ในวันที่ 18 สิงหาคม 2568 เวลา 18:00 น. เป็นต้นไป"
                                    // <>
                                    //   <Text fontWeight={700} className="text-info">
                                    //     * รายละเอียดวันเวลาและสถานที่สอบสัมภาษณ์
                                    //   </Text>
                                    //   <Pane display="flex" flexDirection={"column"}>
                                    //     <div className="d-flex">
                                    //       <Text fontWeight={600}>วันเวลา :&nbsp; &nbsp;</Text>
                                    //       <div> {item.Major_MAJOR_CLASSROOM}</div>
                                    //     </div>
                                    //     <div className="d-flex">
                                    //       <Text fontWeight={600}>สถานที่ :&nbsp; &nbsp;</Text>
                                    //       <div> {item.Major_MAJOR_CLASSROOM2} </div>
                                    //     </div>
                                    //     <div className="d-flex">
                                    //       <Text fontWeight={600}>
                                    //         &nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp;
                                    //         &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;
                                    //       </Text>
                                    //       <div> {item.Major_MAJOR_CLASSROOM3} </div>
                                    //     </div>
                                    //   </Pane>
                                    //   <Text
                                    //     hidden={ListMajor.length !== key + 1}
                                    //     fontWeight={600}
                                    //     className="text-danger"
                                    //   >
                                    //     {" "}
                                    //     <br />
                                    //     หมายเหตุ : ให้ผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์
                                    //     ศึกษารายละเอียดในประกาศรายชื่อผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์ฯ
                                    //   </Text>
                                    // </>
                                  )}
                                </Text>
                              </>
                            ) : (
                              <></>
                            )}
                          </>
                        ) : DataRegister[0].REGISTER_STATUS === "4" ? (
                          <></>
                          // <Pane display="flex" flexDirection="column">
                          //   <Text color="red">หมายเหตุ*</Text>

                          //   <Text fontSize={"12px"}>
                          //     1. ผู้มีสิทธิ์เข้าศึกษา (ตัวจริง) สามารถยืนสิทธิ์
                          //     และชำระค่าธรรมเนียมการศึกษาได้ตั้งแต่วันที่ 28 สิงหาคม - 3 กันยายน
                          //     2568
                          //   </Text>
                          // </Pane>
                        ) : DataRegister[0].REGISTER_STATUS === "6" ||
                          DataRegister[0].REGISTER_STATUS === "9" ? (
                          <Pane display="flex" flexDirection="column">
                            <Text color="red">หมายเหตุ*</Text>
                            <Text fontSize={"12px"}>
                              1. กรอกข้อมูลทะเบียนประวัติ และอัปโหลดเอกสารรายงานตัว ตั้งแต่ วันที่ 3
                              - 19 กันยายน 2568
                            </Text>
                          </Pane>
                        ) : (
                          <></>
                        )}
                      </Pane>
                    </>
                  ))}
                </Pane>
              </Pane>
              <Pane>
                {DataRegister[0].REGISTER_STATUS === "4" ? (
                  <></>
                  // <Pane display="flex" flexDirection="column">
                  //   <Text color="red">หมายเหตุ*</Text>
                  //   <Text fontSize={"12px"}>
                  //     1. ผู้มีสิทธิ์เข้าศึกษา (ตัวจริง) สามารถยืนสิทธิ์
                  //     และชำระค่าธรรมเนียมการศึกษาได้ตั้งแต่วันที่ 28 สิงหาคม - 3 กันยายน 2568
                  //   </Text>
                  //   <Text fontSize={"12px"}>
                  //     2. กรอกข้อมูลทะเบียนประวัติ และอัปโหลดเอกสารรายงานตัว ตั้งแต่ วันที่ 3 - 19
                  //     กันยายน 2568
                  //   </Text>
                  //   <Text fontSize={"12px"} color="red">
                  //     หากไม่ชำระค่าธรรมเนียมการศึกษาภายในเวลาที่กำหนด จะถือว่าสละสิทธิ์
                  //   </Text>
                  // </Pane>
                ) : DataRegister[0].REGISTER_STATUS === "41" ? (
                  <></>
                  // <Pane display="flex" flexDirection="column">
                  //   <Text color="red">หมายเหตุ*</Text>
                  //   <Text fontSize={"12px"}>
                  //     1. ผู้ผ่านการคัดเลือก (ตัวจริง) สามารถยืนยันสิทธิ์
                  //     และชำระค่าธรรมเนียมการศึกษาได้ตั้งแต่วันที่ 21 กุมภาพันธ์ 2568 - 2 มีนาคม 2568
                  //   </Text>
                  //   <Text fontSize={"12px"}>
                  //     2. ประกาศผลการคัดเลือก (ตัวสำรอง) ในวันที่ 4 มีนาคม 2568
                  //   </Text>
                  // </Pane>
                ) : DataRegister[0].REGISTER_STATUS === "11" ? (
                  <Pane display="flex" flexDirection="column">
                    <Text color="red">หมายเหตุ*</Text>
                    <Text fontSize={"12px"}>1. ติดต่อสอบถามการสมัครเรียน โทร. 055-706547</Text>
                  </Pane>
                ) : DataRegister[0].REGISTER_STATUS === "6" ? (
                  <Pane display="flex" flexDirection="column">
                    <Text color="red">หมายเหตุ*</Text>
                    <Text fontSize={"12px"}>
                      1. กรอกข้อมูลทะเบียนประวัติ และอัปโหลดเอกสารรายงานตัว ตั้งแต่ วันที่ 3 - 19
                      กันยายน 2568
                    </Text>
                  </Pane>
                ) : (
                  <></>
                )}
              </Pane>
            </>
          ) : DataRegister[0].ROB_ID === "173" ||
            DataRegister[0].ROB_ID === "185" ||
            DataRegister[0].ROB_ID === "174" ||
            DataRegister[0].ROB_ID === "175" ? (
            <>
              <div className="d-flex flex-column">
                {DataRegister[0].REGISTER_STATUS === "0" && (
                  <>
                    <div>
                      <Badge
                        color="yellow"
                        width="300px"
                        height="100%"
                        paddingY={4}
                        paddingX={5}
                        fontSize={16}
                        fontFamily=""
                      >
                        <FaRegMoneyBillAlt /> อยู่ระหว่างการชำระค่าสมัคร
                      </Badge>
                    </div>
                  </>
                )}
                {DataRegister[0].REGISTER_STATUS === "1" && (
                  <>
                    {DataRegister[0].ROB_ID === "173" || DataRegister[0].ROB_ID === "185" ? (
                      <div>
                        <Badge
                          color="green"
                          height="100%"
                          paddingY={4}
                          paddingX={5}
                          fontSize={16}
                          fontFamily=""
                        >
                          {/* <FaCheck /> &nbsp;ชำระค่าสมัครแล้ว
                        รอประกาศรายชื่อผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์ */}
                          <FaCheck /> &nbsp;มีสิทธิ์เข้ารับการสอบสัมภาษณ์
                        </Badge>
                      </div>
                    ) : DataRegister[0].ROB_ID === "174" || DataRegister[0].ROB_ID === "175" ? (
                      validCodes.includes(DataRegister[0].Major1_MAJOR_ID) ? (
                        <div>
                          <Badge
                            color="green"
                            height="100%"
                            paddingY={4}
                            paddingX={5}
                            fontSize={16}
                            fontFamily=""
                          >
                            {/* <FaCheck /> &nbsp;ชำระค่าสมัครแล้ว
                        รอประกาศรายชื่อผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์ */}
                            <FaCheck /> &nbsp;มีสิทธิ์เข้ารับการสอบสัมภาษณ์
                          </Badge>
                        </div>
                      ) : (
                        <div>
                          <Badge
                            color="green"
                            height="100%"
                            paddingY={4}
                            paddingX={5}
                            fontSize={16}
                            fontFamily=""
                          >
                            <FaCheck /> &nbsp;ชำระค่าสมัครแล้ว รอประกาศรายชื่อผู้ผ่านการคัดเลือก
                            {/* <FaCheck /> &nbsp;มีสิทธิ์เข้ารับการสอบวัดความรู้พื้นฐานทางวิชาชีพครู */}
                          </Badge>
                        </div>
                      )
                    ) : (
                      <></>
                    )}
                  </>
                )}
                {DataRegister[0].REGISTER_STATUS === "2" && (
                  <>
                    <div>
                      <Badge
                        color="green"
                        height="100%"
                        paddingY={4}
                        paddingX={5}
                        fontSize={16}
                        fontFamily=""
                      >
                        <FaCheck /> &nbsp; รอประกาศรายชื่อผู้ผ่านการคัดเลือก
                      </Badge>
                    </div>
                  </>
                )}
                {(DataRegister[0].REGISTER_STATUS === "6" ||
                  DataRegister[0].REGISTER_STATUS === "9") && (
                    <>
                      <Pane
                        color="#1b4332"
                        backgroundColor="#d8f3dc"
                        height="100%"
                        paddingY={4}
                        paddingX={5}
                        fontSize={16}
                        fontFamily=""
                        fontWeight={700}
                        marginBottom={0}
                      >
                        &nbsp;
                        <Text color="#1b4332" fontWeight={700}>
                          ยืนยันสิทธิ์ รอบ {DataRegister[0].QUOTA_NAME}{" "}
                          {DataRegister[0].ROB_NAME !== null ? DataRegister[0].ROB_NAME : ""}
                        </Text>
                        <br />
                        <Text color="#1b4332" fontWeight={700}>
                          {DataRegister[0].Major1_faculty_name}{" "}
                          {" หลักสูตร " + DataRegister[0].Major1_LEVEL_OPEN_NAME}
                        </Text>
                        <br />
                        <Text color="#1b4332" fontWeight={700}>
                          {DataRegister[0].Major1_MAJOR_ID +
                            " : " +
                            DataRegister[0].Major1_MAJOR_NAME}
                        </Text>
                      </Pane>
                    </>
                  )}
                {DataRegister[0].REGISTER_STATUS === "4" && (
                  <>
                    {/* <div>
                      <Pane
                        color="#1b4332"
                        backgroundColor="#d8f3dc"
                        height="100%"
                        paddingY={4}
                        paddingX={5}
                        fontSize={16}
                        fontFamily=""
                        fontWeight={700}
                        marginBottom={0}
                      >
                        &nbsp;
                        <Text color="#1b4332" fontWeight={700}>
                          ผ่านการคัดเลือก รอบ {DataRegister[0].QUOTA_NAME}{" "}
                          {DataRegister[0].ROB_NAME !== null ? DataRegister[0].ROB_NAME : ""}
                        </Text>
                        <br />
                        <Text color="#1b4332" fontWeight={700}>
                          {DataRegister[0].Major1_faculty_name}{" "}
                          {" หลักสูตร " + DataRegister[0].Major1_LEVEL_OPEN_NAME}
                        </Text>
                        <br />
                        <Text color="#1b4332" fontWeight={700}>
                          {DataRegister[0].Major1_MAJOR_ID +
                            " : " +
                            DataRegister[0].Major1_MAJOR_NAME}
                        </Text>
                      </Pane>
                    </div> */}
                  </>
                )}
                <Pane backgroundColor="white" padding={10}>
                  <Text
                    fontWeight={600}
                    fontFamily=""
                    fontSize={14}
                    paddingTop={5}
                    marginBottom={10}
                  >
                    รายละเอียดที่สมัคร
                  </Text>
                  <Pane gap={10} flexDirection={"column"}>
                    {ListMajor.map((item, key) => (
                      <>
                        <Pane marginBottom={10} padding={10} borderRadius={8} key={key}>
                          <Pane fontWeight={600}>
                            <Text fontWeight={700} style={{ color: "#fe7f2d" }}>
                              ลำดับที่ {key + 1}
                            </Text>
                            &nbsp; หลักสูตร
                            {item.Major_LEVEL_OPEN_NAME +
                              " " +
                              item.Major_course_year +
                              " ปี  " +
                              item.Major_MAJOR_ID +
                              " : สาขาวิชา" +
                              item.Major_MAJOR_NAME}
                          </Pane>
                          {DataRegister[0].REGISTER_STATUS === "0" ? (
                            <>
                              {key + 1 === 1 && (
                                <Text marginTop={10} marginLeft={15} className="text-warning">
                                  รอการชำระเงินค่าสมัคร
                                </Text>
                              )}
                            </>
                          ) : DataRegister[0].REGISTER_STATUS === "1" ? (
                            <>
                              {key + 1 === 1 ? (
                                <>
                                  {DataRegister[0].ROB_ID === "173" ||
                                    DataRegister[0].ROB_ID === "185" ? (
                                    <>
                                      {/* <Text>
                                      ประกาศรายชื่อผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์ วันที่ 21 พฤศจิกายน 2568 เวลา 18:00 น.
                                    </Text> */}
                                      <Text fontWeight={700} className="text-info">
                                        * รายละเอียดวันเวลาและสถานที่สอบสัมภาษณ์
                                      </Text>
                                      <Pane display="flex" flexDirection={"column"}>
                                        <div className="d-flex">
                                          <Text fontWeight={600}>วันเวลา :&nbsp; &nbsp;</Text>
                                          <div> {item.Major_MAJOR_CLASSROOM}</div>
                                        </div>
                                        <div className="d-flex">
                                          <Text fontWeight={600}>สถานที่ :&nbsp; &nbsp;</Text>
                                          <div> {item.Major_MAJOR_CLASSROOM2} </div>
                                        </div>
                                        {DataRegister[0].Major1_MAJOR_ID === "9902" ? (
                                          <div className="d-flex">
                                            <Text fontWeight={600}>
                                              &nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp;
                                              &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;
                                            </Text>
                                            <div> {item.Major_MAJOR_CLASSROOM3} </div>
                                          </div>
                                        ) : (
                                          <></>
                                        )}
                                      </Pane>
                                      <Text
                                        hidden={ListMajor.length !== key + 1}
                                        fontWeight={600}
                                        className="text-danger"
                                      >
                                        {" "}
                                        <br />
                                        หมายเหตุ : ให้ผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์
                                        ศึกษารายละเอียดในประกาศรายชื่อผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์ฯ
                                      </Text>
                                    </>
                                  ) : (DataRegister[0].ROB_ID === "174" ||
                                    DataRegister[0].ROB_ID === "175" ||
                                    DataRegister[0].ROB_ID === "177" ||
                                    DataRegister[0].ROB_ID === "178") ? (
                                    validCodes.includes(item.Major_MAJOR_ID) ? (
                                      <>
                                        {/* <Text>
                                      ประกาศรายชื่อผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์ วันที่ 21 พฤศจิกายน 2568 เวลา 18:00 น.
                                    </Text> */}
                                        <Text fontWeight={700} className="text-info">
                                          * รายละเอียดวันเวลาและสถานที่สอบสัมภาษณ์
                                        </Text>
                                        <Pane display="flex" flexDirection={"column"}>
                                          <div className="d-flex">
                                            <Text fontWeight={600}>วันเวลา :&nbsp; &nbsp;</Text>
                                            <div> {item.Major_MAJOR_CLASSROOM}</div>
                                          </div>
                                          <div className="d-flex">
                                            <Text fontWeight={600}>สถานที่ :&nbsp; &nbsp;</Text>
                                            <div> {item.Major_MAJOR_CLASSROOM2} </div>
                                          </div>
                                          {/* <div className="d-flex">
                                            <Text fontWeight={600}>
                                              &nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp;
                                              &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;
                                            </Text>
                                            <div> {item.Major_MAJOR_CLASSROOM3} </div>
                                          </div> */}
                                        </Pane>
                                        <Text
                                          hidden={ListMajor.length !== key + 1}
                                          fontWeight={600}
                                          className="text-danger"
                                        >
                                          {" "}
                                          <br />
                                          หมายเหตุ : ให้ผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์
                                          ศึกษารายละเอียดในประกาศรายชื่อผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์ฯ
                                        </Text>
                                      </>
                                    ) : (
                                      <Text>
                                        ประกาศรายชื่อผู้ผ่านการคัดเลือก วันที่ 4 ธันวาคม 2568 เวลา
                                        18:00 น.
                                      </Text>
                                    )
                                  ) : (
                                    <></>
                                  )}
                                </>
                              ) : (
                                <>
                                  {validCodes.includes(item.Major_MAJOR_ID) ? (
                                    <>
                                      <Text fontWeight={700} className="text-info">
                                        * รายละเอียดวันเวลาและสถานที่สอบสัมภาษณ์
                                      </Text>
                                      <Pane display="flex" flexDirection={"column"}>
                                        <div className="d-flex">
                                          <Text fontWeight={600}>วันเวลา :&nbsp; &nbsp;</Text>
                                          <div> {item.Major_MAJOR_CLASSROOM3}</div>
                                        </div>
                                        <div className="d-flex">
                                          <Text fontWeight={600}>สถานที่ :&nbsp; &nbsp;</Text>
                                          <div> {item.Major_MAJOR_CLASSROOM2} </div>
                                        </div>
                                      </Pane>
                                      <Text
                                        hidden={ListMajor.length !== key + 1}
                                        fontWeight={600}
                                        className="text-danger"
                                      >
                                        {" "}
                                        <br />
                                        หมายเหตุ : ให้ผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์
                                        ศึกษารายละเอียดในประกาศรายชื่อผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์ฯ
                                      </Text>
                                    </>
                                  ) : (
                                    <>
                                      <Text
                                        hidden={ListMajor.length !== key + 1}
                                        fontWeight={700}
                                        className="text-danger"
                                      >
                                        สาขาที่ {key + 1} ไม่ต้องเข้ารับการสอบสัมภาษณ์
                                      </Text>{" "}
                                      <br />
                                      <Text
                                        hidden={ListMajor.length !== key + 1}
                                        fontWeight={600}
                                        className="text-danger"
                                      >
                                        {" "}
                                        <br />
                                        หมายเหตุ : ให้ผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์
                                        ศึกษารายละเอียดในประกาศรายชื่อผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์ฯ
                                      </Text>
                                    </>
                                  )}
                                </>
                              )}
                            </>
                          ) : DataRegister[0].REGISTER_STATUS === "4" ? (
                            <></>
                            // <Pane display="flex" flexDirection="column">
                            //   <Text color="red">หมายเหตุ*</Text>

                            //   <Text fontSize={"12px"}>
                            //     1. กรอกข้อมูลทะเบียนประวัติ และอัปโหลดเอกสารรายงานตัว
                            //   </Text>
                            //   <Text fontSize={"12px"}>2. ศึกษารายละเอียดในประกาศ</Text>
                            // </Pane>
                          ) : DataRegister[0].REGISTER_STATUS === "6" ||
                            DataRegister[0].REGISTER_STATUS === "9" ? (
                            <Pane display="flex" flexDirection="column">
                              <Text color="red">หมายเหตุ*</Text>
                              <Text fontSize={"12px"}>
                                1. กรอกข้อมูลทะเบียนประวัติ และอัปโหลดเอกสารรายงานตัว
                              </Text>
                              <Text fontSize={"12px"}>2. ศึกษารายละเอียดในประกาศ</Text>
                            </Pane>
                          ) : (
                            <></>
                          )}
                        </Pane>
                      </>
                    ))}
                  </Pane>
                </Pane>
              </div>
            </>
          ) : DataRegister[0].ROB_ID === "152" ? (
            <>
              {DataRegister[0].REGISTER_STATUS === "0" ||
                DataRegister[0].REGISTER_STATUS === "1" ||
                DataRegister[0].REGISTER_STATUS === "2" ? (
                <Pane marginTop={10} padding={5} borderRadius={6} backgroundColor="white">
                  <Text
                    fontWeight={600}
                    fontFamily=""
                    fontSize={14}
                    paddingTop={5}
                    marginBottom={10}
                  >
                    รายละเอียดที่สมัคร
                  </Text>
                  <br />
                  <Text fontWeight={700} className="text-info">
                    * รายละเอียดวันเวลาและสถานที่สอบสัมภาษณ์
                  </Text>
                  <Pane gap={10} flexDirection={"column"}>
                    {ListMajor.map((item, key) => (
                      <>
                        <Pane marginBottom={10} padding={10} borderRadius={8} key={key}>
                          <Pane fontWeight={600}>
                            <Text fontWeight={700} style={{ color: "#fe7f2d" }}>
                              ลำดับที่ {key + 1}
                            </Text>
                            &nbsp; หลักสูตร
                            {item.Major_LEVEL_OPEN_NAME +
                              " " +
                              item.Major_course_year +
                              " ปี " +
                              item.Major_MAJOR_ID +
                              " : สาขาวิชา" +
                              item.Major_MAJOR_NAME}
                            &nbsp;
                          </Pane>
                          {DataRegister[0].REGISTER_STATUS === "0" ? (
                            <>
                              {key + 1 === 1 && (
                                <Text marginTop={10} marginLeft={15} className="text-warning">
                                  รอการชำระเงินค่าสมัคร
                                </Text>
                              )}
                            </>
                          ) : DataRegister[0].REGISTER_STATUS === "1" ? (
                            <>
                              {key + 1 === 1 ? (
                                <>
                                  <Pane display="flex" hidden={key === 1} flexDirection={"column"}>
                                    <div className="d-flex">
                                      <Text fontWeight={600}>วันเวลา :&nbsp; &nbsp;</Text>
                                      <div> {item.Major_MAJOR_CLASSROOM}</div>
                                    </div>
                                    <div className="d-flex">
                                      <Text fontWeight={600}>สถานที่ :&nbsp; &nbsp;</Text>
                                      <div> {item.Major_MAJOR_CLASSROOM2} </div>
                                    </div>
                                  </Pane>
                                </>
                              ) : (
                                <>
                                  {item.Major_MAJOR_ID === "1304" ||
                                    item.Major_MAJOR_ID === "1310" ? (
                                    <>
                                      <Pane display="flex" flexDirection={"column"}>
                                        <div className="d-flex">
                                          <Text fontWeight={600}>วันเวลา :&nbsp; &nbsp;</Text>
                                          <div> {item.Major_MAJOR_CLASSROOM3}</div>
                                        </div>
                                        <div className="d-flex">
                                          <Text fontWeight={600}>สถานที่ :&nbsp; &nbsp;</Text>
                                          <div> {item.Major_MAJOR_CLASSROOM2} </div>
                                        </div>
                                      </Pane>
                                    </>
                                  ) : (
                                    <>ไม่ต้องเข้ารับการสอบสัมภาษณ์</>
                                  )}
                                </>
                              )}

                              <Text
                                hidden={ListMajor.length !== key + 1}
                                fontWeight={600}
                                className="text-danger"
                              >
                                {" "}
                                <br />
                                หมายเหตุ : ให้ผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์
                                ศึกษารายละเอียดในประกาศรายชื่อผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์ฯ
                              </Text>
                            </>
                          ) : DataRegister[0].REGISTER_STATUS === "2" ? (
                            <>
                              <Text
                                marginTop={15}
                                hidden={ListMajor.length !== key + 1}
                                fontWeight={600}
                                className="text-danger"
                              >
                                หมายเหตุ : รอประกาศรายชื่อผู้ผ่านการคัดเลือก ภายในวันที่ 27 ธันวาคม
                                2567 เวลา 18:00 น. เป็นต้นไป
                              </Text>
                            </>
                          ) : (
                            <></>
                          )}
                        </Pane>
                      </>
                    ))}
                  </Pane>
                </Pane>
              ) : DataRegister[0].REGISTER_STATUS === "11" ||
                DataRegister[0].REGISTER_STATUS === "5" ? (
                <Pane marginTop={20} display="flex" flexDirection="column">
                  <Text color="red">หมายเหตุ*</Text>
                  <Text hidden={DataRegister[0].REGISTER_ORDER_NUMBER === null} fontSize={"12px"}>
                    1. ประกาศผลการคัดเลือก (ตัวสำรอง) ในวันที่ 7 มกราคม 2568 เวลา 10.00 น.
                  </Text>
                  <Text fontSize={"12px"}>
                    {DataRegister[0].REGISTER_ORDER_NUMBER === null ? "1." : "2."}{" "}
                    เปิดรับสมัครเรียนภาคปกติ รอบ 2 วันที่ 15 มกราคม 2568 - 7 กุมภาพันธ์ 2568
                  </Text>
                </Pane>
              ) : DataRegister[0].REGISTER_STATUS === "4" ? (
                <></>
                // <Pane display="flex" flexDirection="column">
                //   <Text color="red">หมายเหตุ*</Text>
                //   <Text fontSize={"12px"}>
                //     1. ผู้ผ่านการคัดเลือก (ตัวจริง) สามารถยืนยันสิทธิ์
                //     และชำระค่าธรรมเนียมการศึกษาได้ตั้งแต่วันที่ 7-9 มกราคม 2568
                //   </Text>
                //   {/* <Text fontSize={"12px"}>
                //     1. ผู้ผ่านการคัดเลือก (ตัวจริง) สามารถยืนยันสิทธิ์
                //     และชำระค่าธรรมเนียมการศึกษาได้ตั้งแต่วันที่ 27 ธันวาคม 2567 - 5 มกราคม 2568{" "}
                //   </Text> */}
                //   {/* <Text fontSize={"12px"} hidden={DataRegister[0].REGISTER_ORDER_NUMBER === null}>
                //     2. ประกาศผลการคัดเลือก (ตัวสำรอง) ในวันที่ 7 มกราคม 2568 เวลา 10.00 น.
                //   </Text> */}
                // </Pane>
              ) : DataRegister[0].REGISTER_STATUS === "6" ||
                DataRegister[0].REGISTER_STATUS === "9" ? (
                <Pane display="flex" flexDirection="column">
                  <Text color="red">หมายเหตุ*</Text>
                  <Text fontSize={"12px"}>
                    1. ชำระเงินค่าธรรมเนียมการศึกษา ครั้งที่ 2 ตั้งแต่วันที่ 27-31 มกราคม 2568
                    (สำหรับผู้ที่ชำระเงินแบบแบ่งจ่าย 2 ครั้ง)
                  </Text>
                  <Text fontSize={"12px"}>
                    2. กรอกข้อมูลทะเบียนประวัติ และอัปโหลดเอกสารรายงานตัว ตั้งแต่วันที่ 1 - 30
                    เมษายน 2568
                  </Text>
                </Pane>
              ) : (
                <></>
              )}
            </>
          ) : DataRegister[0].ROB_ID === "153" || DataRegister[0].ROB_ID === "155" ? (
            <>
              {DataRegister[0].REGISTER_STATUS === "0" ||
                DataRegister[0].REGISTER_STATUS === "1x" ||
                DataRegister[0].REGISTER_STATUS === "2" ||
                DataRegister[0].REGISTER_STATUS === "6" ||
                DataRegister[0].REGISTER_STATUS === "9" ? (
                <>
                  {" "}
                  <Pane marginTop={10} padding={5} borderRadius={6} backgroundColor="white">
                    <Text
                      fontWeight={600}
                      fontFamily=""
                      fontSize={14}
                      paddingTop={5}
                      marginBottom={10}
                    >
                      รายละเอียดที่สมัคร
                    </Text>
                    <Pane gap={10} flexDirection={"column"}>
                      {ListMajor.map((item, key) => (
                        <>
                          <Pane marginBottom={10} padding={10} borderRadius={8} key={key}>
                            <Pane fontWeight={600}>
                              <Text fontWeight={700} style={{ color: "#fe7f2d" }}>
                                ลำดับที่ {key + 1}
                              </Text>
                              &nbsp; หลักสูตร
                              {item.Major_LEVEL_OPEN_NAME +
                                " " +
                                item.Major_course_year +
                                " ปี " +
                                item.Major_MAJOR_ID +
                                " : สาขาวิชา" +
                                item.Major_MAJOR_NAME}
                              &nbsp;
                            </Pane>
                            {DataRegister[0].REGISTER_STATUS === "0" ? (
                              <>
                                {key + 1 === 1 && (
                                  <Text marginTop={10} marginLeft={15} className="text-danger">
                                    ติดต่อเบอร์ 055-706547 เนื่องจากไม่ได้ส่งเอกสารใบแสดงผลการเรียน
                                    5 ภาคเรียน
                                  </Text>
                                )}
                              </>
                            ) : DataRegister[0].REGISTER_STATUS === "1" ? (
                              <>
                                {key + 1 === 1 ? (
                                  <>
                                    {item.Major_MAJOR_ID === "1202" ||
                                      item.Major_MAJOR_ID === "1207" ||
                                      item.Major_MAJOR_ID === "1208" ||
                                      item.Major_MAJOR_ID === "1301" ||
                                      item.Major_MAJOR_ID === "1110" ||
                                      item.Major_MAJOR_ID === "1304" ||
                                      item.Major_MAJOR_ID === "1310" ? (
                                      <>
                                        <Pane
                                          display="flex"
                                          hidden={key === 1}
                                          flexDirection={"column"}
                                        >
                                          <div className="d-flex">
                                            <Text fontWeight={600}>วันเวลา :&nbsp; &nbsp;</Text>
                                            <div> {item.Major_MAJOR_CLASSROOM}</div>
                                          </div>
                                          <div className="d-flex">
                                            <Text fontWeight={600}>สถานที่ :&nbsp; &nbsp;</Text>
                                            <div> {item.Major_MAJOR_CLASSROOM2} </div>
                                          </div>
                                        </Pane>
                                      </>
                                    ) : (
                                      <>
                                        <Text
                                          marginTop={10}
                                          marginLeft={15}
                                          className="text-success"
                                        >
                                          รอประกาศรายชื่อผู้ผ่านการคัดเลือก ในวันที่ 27 ธันวาคม 2567
                                          เวลา 18:00 น. เป็นต้นไป
                                        </Text>
                                      </>
                                    )}
                                  </>
                                ) : (
                                  <>
                                    {item.Major_MAJOR_ID === "1202" ||
                                      item.Major_MAJOR_ID === "1207" ||
                                      item.Major_MAJOR_ID === "1208" ||
                                      item.Major_MAJOR_ID === "1301" ||
                                      item.Major_MAJOR_ID === "1110" ||
                                      item.Major_MAJOR_ID === "1304" ||
                                      item.Major_MAJOR_ID === "1310" ? (
                                      <>
                                        <Pane display="flex" flexDirection={"column"}>
                                          <div className="d-flex">
                                            <Text fontWeight={600}>วันเวลา :&nbsp; &nbsp;</Text>
                                            <div> {item.Major_MAJOR_CLASSROOM3}</div>
                                          </div>
                                          <div className="d-flex">
                                            <Text fontWeight={600}>สถานที่ :&nbsp; &nbsp;</Text>
                                            <div> {item.Major_MAJOR_CLASSROOM2} </div>
                                          </div>
                                        </Pane>
                                      </>
                                    ) : (
                                      <>ไม่ต้องเข้ารับการสอบสัมภาษณ์</>
                                    )}
                                  </>
                                )}
                              </>
                            ) : DataRegister[0].REGISTER_STATUS === "2" ? (
                              <>
                                <Text fontWeight={600} className="text-danger">
                                  {DataRegister[0].REGISTER_STATUS === "2"
                                    ? "หมายเหตุ : รอประกาศรายชื่อผู้ผ่านการคัดเลือก ภายในวันที่ 27 ธันวาคม 2567 เวลา 18:00 น. เป็นต้นไป"
                                    : DataRegister[0].REGISTER_STATUS === "1"
                                      ? "หมายเหตุ : ให้ผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์    ศึกษารายละเอียดในประกาศรายชื่อผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์ฯ"
                                      : ""}
                                </Text>
                              </>
                            ) : (
                              <></>
                            )}
                          </Pane>
                        </>
                      ))}
                    </Pane>
                    <Text
                      hidden={
                        DataRegister[0].Major1_MAJOR_ID === "1202" ||
                          DataRegister[0].Major1_MAJOR_ID === "1207" ||
                          DataRegister[0].Major1_MAJOR_ID === "1208" ||
                          DataRegister[0].Major1_MAJOR_ID === "1301" ||
                          DataRegister[0].Major1_MAJOR_ID === "1110" ||
                          DataRegister[0].Major1_MAJOR_ID === "1304" ||
                          DataRegister[0].Major1_MAJOR_ID === "1310"
                          ? false
                          : true
                      }
                      fontWeight={600}
                      className="text-danger"
                    >
                      {DataRegister[0].REGISTER_STATUS === "2"
                        ? "หมายเหตุ : รอประกาศรายชื่อผู้ผ่านการคัดเลือก ภายในวันที่ 27 ธันวาคม 2567 "
                        : DataRegister[0].REGISTER_STATUS === "1"
                          ? "หมายเหตุ : ให้ผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์    ศึกษารายละเอียดในประกาศรายชื่อผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์ฯ"
                          : ""}
                    </Text>
                  </Pane>
                </>
              ) : (
                <>
                  {DataRegister[0].REGISTER_STATUS === "11" ||
                    DataRegister[0].REGISTER_STATUS === "5" ? (
                    <Pane marginTop={20} display="flex" flexDirection="column">
                      <Text color="red">หมายเหตุ*</Text>
                      <Text fontSize={"12px"}>
                        1. เปิดรับสมัครเรียนภาคปกติ รอบ 2 วันที่ 15 มกราคม 2568 - 7 กุมภาพันธ์ 2568
                      </Text>
                    </Pane>
                  ) : DataRegister[0].REGISTER_STATUS === "4" ? (
                    <></>
                    // <Pane display="flex" flexDirection="column">
                    //   <Text color="red">หมายเหตุ*</Text>
                    //   <Text fontSize={"12px"}>
                    //     1. ผู้ผ่านการคัดเลือก (ตัวจริง) สามารถยืนยันสิทธิ์
                    //     และชำระค่าธรรมเนียมการศึกษาได้ตั้งแต่วันที่ 7-9 มกราคม 2568
                    //   </Text>
                    //   {/* <Text fontSize={"12px"}>
                    //     1. ผู้ผ่านการคัดเลือก (ตัวจริง) สามารถยืนยันสิทธิ์
                    //     และชำระค่าธรรมเนียมการศึกษาได้ตั้งแต่วันที่ 27 ธันวาคม 2567 - 5 มกราคม 2568{" "}
                    //   </Text> */}
                    //   {/* <Text
                    //     fontSize={"12px"}
                    //     hidden={DataRegister[0].REGISTER_ORDER_NUMBER === null}
                    //   >
                    //     2. ประกาศผลการคัดเลือก (ตัวสำรอง) ในวันที่ 7 มกราคม 2568 เวลา 10.00 น.
                    //   </Text> */}
                    // </Pane>
                  ) : DataRegister[0].REGISTER_STATUS === "6" ||
                    DataRegister[0].REGISTER_STATUS === "9" ? (
                    <Pane display="flex" flexDirection="column">
                      <Text color="red">หมายเหตุ*</Text>
                      <Text fontSize={"12px"}>
                        1. ชำระเงินค่าธรรมเนียมการศึกษา ครั้งที่ 2 ตั้งแต่วันที่ 27-31 มกราคม 2568
                        (สำหรับผู้ที่ชำระเงินแบบแบ่งจ่าย 2 ครั้ง)
                      </Text>
                      <Text fontSize={"12px"}>
                        2. กรอกข้อมูลทะเบียนประวัติ และอัปโหลดเอกสารรายงานตัว ตั้งแต่วันที่ 1 - 30
                        เมษายน 2568
                      </Text>
                    </Pane>
                  ) : (
                    <></>
                  )}
                </>
              )}

              {/* ////// ไม่แสดงลำดับรายวิชาที่สมัคร */}
            </>
          ) : DataRegister[0].ROB_ID === "154" ? (
            <>
              {DataRegister[0].REGISTER_STATUS === "4" ||
                DataRegister[0].REGISTER_STATUS === "6" ? (
                <>
                  {/* <Pane display="flex" flexDirection="column">
                    <Text color="red">หมายเหตุ*</Text>
                    <Text fontSize={"12px"}>
                      1. ชำระเงินค่าธรรมเนียมการศึกษา วันที่ 19 พฤษภาคม 2568 - วันที่ 23 พฤษภาคม
                      2568
                    </Text>
                    <Text fontSize={"12px"}>
                      2. กรอกข้อมูลทะเบียนประวัติและอัปโหลดเอกสารการรายงานตัว ตั้งแต่วันที่ 19
                      พฤษภาคม 2568 - วันที่ 30 พฤษภาคม 2568
                    </Text>
                  </Pane> */}
                </>
              ) : (
                <>
                  <Pane marginTop={10} padding={5} borderRadius={6} backgroundColor="white">
                    <Text
                      fontWeight={600}
                      fontFamily=""
                      fontSize={14}
                      paddingTop={5}
                      marginBottom={10}
                    >
                      รายละเอียดที่สมัคร
                    </Text>
                    <Pane gap={10} flexDirection={"column"}>
                      {ListMajor.map((item, key) => (
                        <>
                          <Pane marginBottom={10} padding={10} borderRadius={8} key={key}>
                            <Pane fontWeight={600}>
                              <Text fontWeight={700} style={{ color: "#fe7f2d" }}>
                                ลำดับที่ {key + 1}
                              </Text>
                              &nbsp; หลักสูตร
                              {item.Major_LEVEL_OPEN_NAME +
                                " " +
                                item.Major_course_year +
                                " ปี " +
                                item.Major_MAJOR_ID +
                                " : สาขาวิชา" +
                                item.Major_MAJOR_NAME}
                              &nbsp;
                            </Pane>
                            {DataRegister[0].REGISTER_STATUS === "0" ? (
                              <>
                                {key + 1 === 1 && (
                                  <Text marginTop={10} marginLeft={15} className="text-warning">
                                    รอการชำระเงินค่าสมัคร
                                  </Text>
                                )}
                              </>
                            ) : DataRegister[0].REGISTER_STATUS === "1" ? (
                              <>
                                {key + 1 === 1 ? (
                                  <>
                                    <>
                                      <Pane
                                        display="flex"
                                        hidden={key === 1}
                                        flexDirection={"column"}
                                      >
                                        <div className="d-flex">
                                          <Text fontWeight={600}>วันเวลา :&nbsp; &nbsp;</Text>
                                          <div> {item.Major_MAJOR_CLASSROOM}</div>
                                        </div>
                                        <div className="d-flex">
                                          <Text fontWeight={600}>สถานที่ :&nbsp; &nbsp;</Text>
                                          <div> {item.Major_MAJOR_CLASSROOM2} </div>
                                        </div>
                                      </Pane>
                                    </>
                                  </>
                                ) : (
                                  <></>
                                )}
                              </>
                            ) : (
                              <>รอประมวลผล..</>
                            )}
                          </Pane>
                        </>
                      ))}
                    </Pane>
                  </Pane>
                </>
              )}
            </>
          ) : DataRegister[0].ROB_ID === "156" ? (
            <Pane marginTop={10} padding={5} borderRadius={6} backgroundColor="white">
              {/* <Text fontWeight={600} fontFamily="" fontSize={14} paddingTop={5} marginBottom={10}>
                รายละเอียดที่สมัคร
              </Text> */}
              {/* <Pane gap={10} flexDirection={"column"}>
                {ListMajor.map((item, key) => (
                  <>
                    <Pane marginBottom={10} padding={10} borderRadius={8} key={key}>
                      <Pane fontWeight={600}>
                        <Text fontWeight={700} style={{ color: "#fe7f2d" }}>
                          ลำดับที่ {key + 1}
                        </Text>
                        &nbsp; หลักสูตร
                        {item.Major_LEVEL_OPEN_NAME +
                          " " +
                          item.Major_course_year +
                          " ปี  " +
                          item.Major_MAJOR_ID +
                          " : สาขาวิชา" +
                          item.Major_MAJOR_NAME}
                      </Pane>
                      {DataRegister[0].REGISTER_STATUS === "0" ? (
                        <>
                          {key + 1 === 1 && (
                            <Text marginTop={10} marginLeft={15} className="text-warning">
                              รอการชำระเงินค่าสมัคร
                            </Text>
                          )}
                        </>
                      ) : DataRegister[0].REGISTER_STATUS === "1" ? (
                        <>
                          {key + 1 === 1 ? (
                            <>
                             
                              <Pane display="flex" hidden={key === 1} flexDirection={"column"}>
                                <div className="d-flex">
                                  <Text fontWeight={600}>วันเวลา :&nbsp; &nbsp;</Text>
                                  <div> {item.Major_MAJOR_CLASSROOM}</div>
                                </div>
                                <div className="d-flex">
                                  <Text fontWeight={600}>สถานที่ :&nbsp; &nbsp;</Text>
                                  <div> {item.Major_MAJOR_CLASSROOM2} </div>
                                </div>
                              </Pane>
                            </>
                          ) : key + 1 === 2 ? (
                            <>
                              <br />
                              {item.Major_MAJOR_ID === "1304" || item.Major_MAJOR_ID === "1310" ? (
                                <>
                                  <Pane display="flex" flexDirection={"column"}>
                                    <div className="d-flex">
                                      <Text fontWeight={600}>วันเวลา :&nbsp; &nbsp;</Text>
                                      <div> {item.Major_MAJOR_CLASSROOM3}</div>
                                    </div>
                                    <div className="d-flex">
                                      <Text fontWeight={600}>สถานที่ :&nbsp; &nbsp;</Text>
                                      <div> {item.Major_MAJOR_CLASSROOM2} </div>
                                    </div>
                                  </Pane>
                                </>
                              ) : (
                                <>
                                  <Pane display="flex" flexDirection={"column"}>
                                    <div className="d-flex">
                                      <Text fontWeight={400} color="red">
                                        &nbsp; &nbsp; &nbsp; - สาขาลำดับที่ 2
                                        ไม่ต้องเข้ารับการสอบสัมภาษณ์
                                      </Text>
                                    </div>
                                  </Pane>
                                </>
                              )}
                            </>
                          ) : (
                            <></>
                          )}
                        </>
                      ) : (
                        <></>
                      )}
                    </Pane>
                    <Pane hidden={DataRegister[0].REGISTER_STATUS !== "2"}></Pane>
                  </>
                ))}
              </Pane> */}
              {/* //หมายเหตุ */}
              {DataRegister[0].REGISTER_STATUS === "0" ? (
                <>
                  <Pane display="flex" flexDirection="column">
                    <Text color="red">หมายเหตุ*</Text>
                    <Text fontSize={"12px"}>
                      1. ชำระเงินค่าสมัครตั้งแต่วันที่ 15 มกราคม 2568 - 7 กุมภาพันธ์ 2568
                    </Text>
                  </Pane>
                </>
              ) : DataRegister[0].REGISTER_STATUS === "4" ? (
                <></>
                // <Pane display="flex" flexDirection="column">
                //   <Text color="red">หมายเหตุ*</Text>
                //   <Text fontSize={"12px"}>
                //     1. ผู้ผ่านการคัดเลือก (ตัวจริง) สามารถยืนยันสิทธิ์
                //     และชำระค่าธรรมเนียมการศึกษาได้ตั้งแต่วันที่ 6-8 มีนาคม 2568
                //   </Text>
                //   <Text fontSize={"12px"}>
                //     หากไม่ชำระค่าธรรมเนียมการศึกษาภายในเวลาที่กำหนด จะถือว่าสละสิทธิ์
                //   </Text>
                //   {/* {DataRegister[0].REGISTER_ORDER !== null && (
                //     <Text fontSize={"12px"}>
                //       2. ผู้ที่ได้รับการคัดเลือกเป็นตัวสำรอง มหาวิทยาลัยฯ จะประกาศผลการคัดเลือก
                //       เข้าศึกษาต่อเพิ่มเติมสำหรับทะเบียนสำรอง (ตัวสำรอง) ในวันพฤหัสบดีที่ 6 มีนาคม
                //       2568
                //     </Text>
                //   )} */}
                // </Pane>
              ) : DataRegister[0].REGISTER_STATUS === "6" ||
                DataRegister[0].REGISTER_STATUS === "9" ? (
                <Pane display="flex" flexDirection="column">
                  <Text color="red">หมายเหตุ*</Text>
                  <Text fontSize={"12px"}>
                    1. ผู้ผ่านการคัดเลือก (ตัวจริง) เฉพาะผู้ที่เลือกวิธีการชำระเงิน แบบแบ่งจ่าย 2
                    งวด ชำระค่าธรรมเนียมการศึกษา งวดที่ 2 ได้ตั้งแต่วันที่ 31 มีนาคม - 4 เมษายน 2568
                  </Text>
                  <Text fontSize={"12px"}>
                    2. กรอกข้อมูลทะเบียนประวัติได้ตั้งแต่วันที่ 1 เมษายน - 30 เมษายน 2568
                  </Text>
                </Pane>
              ) : DataRegister[0].REGISTER_STATUS === "11" ? (
                <Pane display="flex" flexDirection="column">
                  <Text color="red">หมายเหตุ*</Text>
                  <Text fontSize={"12px"}>
                    1. ผู้ที่ได้รับการคัดเลือกเป็นตัวสำรอง มหาวิทยาลัยฯ จะประกาศผลการคัดเลือก
                    เข้าศึกษาต่อเพิ่มเติมสำหรับทะเบียนสำรอง (ตัวสำรอง) ในวันพฤหัสบดีที่ 6 มีนาคม
                    2568
                  </Text>
                </Pane>
              ) : (
                <></>
              )}
            </Pane>
          ) : DataRegister[0].ROB_ID === "159" ? (
            <>
              {ListMajor.map((item, key) => (
                <>
                  <Pane hidden marginBottom={10} padding={10} borderRadius={8} key={key}>
                    <Pane fontWeight={600}>
                      <Text fontWeight={700} style={{ color: "#fe7f2d" }}>
                        ลำดับที่ {key + 1}
                      </Text>
                      &nbsp; หลักสูตร
                      {item.Major_LEVEL_OPEN_NAME +
                        " " +
                        item.Major_course_year +
                        " ปี  " +
                        item.Major_MAJOR_ID +
                        " : สาขาวิชา" +
                        item.Major_MAJOR_NAME}
                    </Pane>
                  </Pane>
                </>
              ))}
              <>
                {DataRegister[0].REGISTER_STATUS === "4" ? (
                  <>
                    {DataRegister[0].Major1_MAJOR_ID === "9902" && !AllowPayNurse("") ? (
                      <>
                        {/* <Pane display="flex" flexDirection="column">
                          <Text color="red">หมายเหตุ*</Text>
                          <Text fontSize={"12px"}>
                            1. ผู้ผ่านการคัดเลือก (ตัวจริง)
                            ส่งผลการตรวจร่างกายตามแบบฟอร์มที่มหาวิทยาลัยฯ กำหนด ตั้งแต่วันนี้
                            ถึงวันที่ 26 มีนาคม 2568
                          </Text>
                          <Text fontSize={"12px"}>
                            ณ อาคารคณะพยาบาลศาสตร์ มหาวิทยาลัยราชภัฏกำแพงเพชร
                          </Text>
                          <Text fontSize={"12px"}>
                            2. ประกาศรายชื่อผู้มีสิทธิ์เข้าศึกษาภาคปกติ คณะพยาบาลศาสตร์ วันที่ 28
                            มีนาคม 2568
                          </Text>
                          <Text fontSize={"12px"}>
                            3. ชำระเงินค่าธรรมเนียมการศึกษาได้ตั้งแต่วันที่ 28 มีนาคม - วันที่ 31
                            มีนาคม 2568
                          </Text>
                          <Text color="red">
                            หากไม่ชำระค่าธรรมเนียมการศึกษาภายในเวลาที่กำหนด จะถือว่าสละสิทธิ์
                          </Text>
                          { <Text fontSize={"12px"}>
                            1. ผู้มีสิทธิ์เข้าศึกษายืนยันสิทธิ์และชำระเงินค่าธรรมเนียมทางการศึกษาได้ตั้งแต่วันที่ 14 มีนาคม 2568 - 19 มีนาคม 2568 
                          </Text>
                          <Text color="red">หากไม่ชำระค่าธรรมเนียมการศึกษาภายในเวลาที่กำหนด จะถือว่าสละสิทธิ์</Text>
                          <Text fontSize={"12px"}>
                            2. สำหรับผู้ที่เลือกชำระเงินค่าธรรมเนียมการศึกษาแบบแบ่งจ่าย 2 งวด ให้ชำระเงิน ค่าธรรมเนียมการศึกษางวดที่ 2 วันที่ 1 พฤษภาคม 2568 - วันที่ 6 พฤษภาคม 2568
                          </Text> }
                      </Pane> */}
                      </>
                    ) : (
                      <>
                        <Pane display="flex" flexDirection="column">
                          <Text color="red">หมายเหตุ*</Text>
                          <Text fontSize={"12px"}>
                            1.
                            ผู้มีสิทธิ์เข้าศึกษายืนยันสิทธิ์และชำระเงินค่าธรรมเนียมทางการศึกษาได้ตั้งแต่วันที่
                            28 มีนาคม 2568 - 31 มีนาคม 2568
                          </Text>
                          <Text fontSize={"12px"}>
                            2. สำหรับผู้ที่เลือกชำระเงินค่าธรรมเนียมการศึกษาแบบแบ่งจ่าย 2 งวด
                            ให้ชำระเงิน ค่าธรรมเนียมการศึกษางวดที่ 2 วันที่ 1 พฤษภาคม 2568 - วันที่
                            6 พฤษภาคม 2568
                          </Text>
                          <Text color="red">
                            หากไม่ชำระค่าธรรมเนียมการศึกษาภายในเวลาที่กำหนด จะถือว่าสละสิทธิ์
                          </Text>
                        </Pane>
                      </>
                    )}
                  </>
                ) : DataRegister[0].REGISTER_STATUS === "6" ||
                  DataRegister[0].REGISTER_STATUS === "9" ? (
                  <>
                    <Pane display="flex" flexDirection="column">
                      <Text color="red">หมายเหตุ*</Text>

                      <Text fontSize={"12px"}>
                        1.สำหรับผู้ที่เลือกชำระเงินค่าธรรมเนียมการศึกษาแบบแบ่งจ่าย 2 งวด ให้ชำระเงิน
                        ค่าธรรมเนียมการศึกษางวดที่ 2 วันที่ 1 พฤษภาคม 2568 - วันที่ 6 พฤษภาคม 2568
                      </Text>
                      <Text fontSize={"12px"}>
                        2. กรอกข้อมูลทะเบียนประวัติ และอัปโหลดเอกสารรายงานตัว ตั้งแต่ 1 - 14 พฤษภาคม
                        2568 (สำหรับผู้ที่ชำระเงินแบบเต็มจำนวนและแบ่งจ่าย งวด 2 เรียบร้อยแล้ว )
                      </Text>
                      <Text color="red">
                        หากไม่ชำระค่าธรรมเนียมการศึกษาภายในเวลาที่กำหนด จะถือว่าสละสิทธิ์
                      </Text>
                    </Pane>
                  </>
                ) : (
                  <></>
                )}
              </>
            </>
          ) : DataRegister[0].ROB_ID === "157" || DataRegister[0].ROB_ID === "158" ? (
            <Pane marginTop={10} padding={5} borderRadius={6} backgroundColor="white">
              <Text fontWeight={600} fontFamily="" fontSize={14} paddingTop={5} marginBottom={10}>
                รายละเอียดที่สมัคร
              </Text>
              <Pane gap={10} flexDirection={"column"}>
                {ListMajor.map((item, key) => (
                  <>
                    <Pane marginBottom={10} padding={10} borderRadius={8} key={key}>
                      <Pane fontWeight={600}>
                        <Text fontWeight={700} style={{ color: "#fe7f2d" }}>
                          ลำดับที่ {key + 1}
                        </Text>
                        &nbsp; หลักสูตร
                        {item.Major_LEVEL_OPEN_NAME +
                          " " +
                          item.Major_course_year +
                          " ปี  " +
                          item.Major_MAJOR_ID +
                          " : สาขาวิชา" +
                          item.Major_MAJOR_NAME}
                      </Pane>
                      {DataRegister[0].REGISTER_STATUS === "0" ? (
                        <>
                          {key + 1 === 1 && (
                            <Text marginTop={10} marginLeft={15} className="text-warning">
                              รอการชำระเงินค่าสมัคร
                            </Text>
                          )}
                        </>
                      ) : DataRegister[0].REGISTER_STATUS === "1" ? (
                        <>
                          {key + 1 === 1 ? (
                            <>
                              <Text marginTop={10} marginLeft={15} className="text-success">
                                {DataRegister[0].Major1_MAJOR_ID === "1202" ||
                                  DataRegister[0].Major1_MAJOR_ID === "1207" ||
                                  DataRegister[0].Major1_MAJOR_ID === "1208" ||
                                  DataRegister[0].Major1_MAJOR_ID === "1110" ? (
                                  // ? "รอประกาศรายชื่อผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์ และพิมพ์ใบสมัคร ในวันที่ 14 กุมภาพันธ์ 2568 เวลา 18.00 น. เป็นต้นไป"
                                  <>
                                    <Pane
                                      display="flex"
                                      hidden={key === 1}
                                      flexDirection={"column"}
                                    >
                                      <div className="d-flex">
                                        <Text fontWeight={600}>วันเวลา :&nbsp; &nbsp;</Text>
                                        <div> {item.Major_MAJOR_CLASSROOM}</div>
                                      </div>
                                      <div className="d-flex">
                                        <Text fontWeight={600}>สถานที่ :&nbsp; &nbsp;</Text>
                                        <div> {item.Major_MAJOR_CLASSROOM2} </div>
                                      </div>
                                    </Pane>
                                  </>
                                ) : (
                                  "รอประกาศรายชื่อผู้ผ่านการคัดเลือก ในวันที่ 28 กุมภาพันธ์ 2568 เวลา 18.00 น. เป็นต้นไป"
                                )}
                              </Text>
                            </>
                          ) : (
                            <></>
                          )}
                        </>
                      ) : (
                        <></>
                      )}
                    </Pane>
                  </>
                ))}
              </Pane>
              {/* //หมายเหตุ */}
              {DataRegister[0].REGISTER_STATUS === "0" ? (
                <>
                  <Pane display="flex" flexDirection="column">
                    <Text color="red">หมายเหตุ*</Text>
                    <Text fontSize={"12px"}>
                      1. ชำระเงินค่าสมัครตั้งแต่วันที่ 15 มกราคม 2568 - 7 กุมภาพันธ์ 2568
                    </Text>
                  </Pane>
                </>
              ) : DataRegister[0].REGISTER_STATUS === "4" ? (
                <>
                </>
                // <Pane display="flex" flexDirection="column">
                //   <Text color="red">หมายเหตุ*</Text>
                //   <Text fontSize={"12px"}>
                //     1. ผู้ผ่านการคัดเลือก (ตัวจริง) สามารถยืนยันสิทธิ์
                //     และชำระค่าธรรมเนียมการศึกษาได้ตั้งแต่วันที่ 28 กุมภาพันธ์ - 4 มีนาคม 2568
                //   </Text>
                //   <Text fontSize={"12px"}>
                //     หากไม่ชำระค่าธรรมเนียมการศึกษาภายในเวลาที่กำหนด จะถือว่าสละสิทธิ์
                //   </Text>
                // </Pane>
              ) : DataRegister[0].REGISTER_STATUS === "6" ||
                DataRegister[0].REGISTER_STATUS === "9" ? (
                <Pane display="flex" flexDirection="column">
                  <Text color="red">หมายเหตุ*</Text>
                  <Text fontSize={"12px"}>
                    1. ผู้ผ่านการคัดเลือก (ตัวจริง) เฉพาะผู้ที่เลือกวิธีการชำระเงิน แบบแบ่งจ่าย 2
                    งวด ชำระค่าธรรมเนียมการศึกษา งวดที่ 2 ได้ตั้งแต่วันที่ 31 มีนาคม - 4 เมษายน 2568
                  </Text>
                  <Text fontSize={"12px"}>
                    2. กรอกข้อมูลทะเบียนประวัติได้ตั้งแต่วันที่ 1 เมษายน - 30 เมษายน 2568
                  </Text>
                </Pane>
              ) : (
                <></>
              )}
            </Pane>
          ) : DataRegister[0].ROB_ID === "160" ? (
            <Pane marginTop={10} padding={5} borderRadius={6} backgroundColor="white">
              <Text
                hidden={
                  DataRegister[0].REGISTER_STATUS === "4" || DataRegister[0].REGISTER_STATUS === "6"
                }
                fontWeight={600}
                fontFamily=""
                fontSize={14}
                paddingTop={5}
                marginBottom={10}
              >
                รายละเอียดที่สมัคร
              </Text>
              <Pane
                hidden={
                  DataRegister[0].REGISTER_STATUS === "4" || DataRegister[0].REGISTER_STATUS === "6"
                }
                gap={10}
                flexDirection={"column"}
              >
                {ListMajor.map((item, key) => (
                  <>
                    <Pane marginBottom={10} padding={10} borderRadius={8} key={key}>
                      <Pane fontWeight={600}>
                        <Text fontWeight={700} style={{ color: "#fe7f2d" }}>
                          ลำดับที่ {key + 1}
                        </Text>
                        &nbsp; หลักสูตร
                        {item.Major_LEVEL_OPEN_NAME +
                          " " +
                          item.Major_course_year +
                          " ปี  " +
                          item.Major_MAJOR_ID +
                          " : สาขาวิชา" +
                          item.Major_MAJOR_NAME}
                      </Pane>
                      {DataRegister[0].REGISTER_STATUS === "0" ? (
                        <>
                          {key + 1 === 1 && (
                            <Text marginTop={10} marginLeft={15} className="text-warning">
                              รอการชำระเงินค่าสมัคร
                            </Text>
                          )}
                        </>
                      ) : DataRegister[0].REGISTER_STATUS === "1" ? (
                        <>
                          {key + 1 === 1 ? (
                            <>
                              <>
                                <Pane display="flex" hidden={key === 1} flexDirection={"column"}>
                                  <div className="d-flex">
                                    <Text fontWeight={600}>วันเวลา :&nbsp; &nbsp;</Text>
                                    <div> {item.Major_MAJOR_CLASSROOM}</div>
                                  </div>
                                  <div className="d-flex">
                                    <Text fontWeight={600}>สถานที่ :&nbsp; &nbsp;</Text>
                                    <div> {item.Major_MAJOR_CLASSROOM2} </div>
                                  </div>
                                </Pane>
                              </>
                            </>
                          ) : (
                            <></>
                          )}
                        </>
                      ) : (
                        <></>
                      )}
                    </Pane>
                  </>
                ))}
              </Pane>
              {/* //หมายเหตุ */}
              {DataRegister[0].REGISTER_STATUS === "0" ? (
                <>
                  <Pane display="flex" flexDirection="column">
                    <Text color="red">หมายเหตุ*</Text>
                    <Text fontSize={"12px"}>
                      1. ชำระเงินค่าสมัครตั้งแต่วันที่ 15 มกราคม 2568 - 18 เมษายน 2568
                    </Text>
                  </Pane>
                </>
              ) : DataRegister[0].REGISTER_STATUS === "1" ? (
                <>
                  <Pane display="flex" flexDirection="column">
                    <Text color="red">หมายเหตุ*</Text>
                    <Text fontSize={"12px"}>
                      1. ประกาศรายชื่อผู้มีสิทธิ์สอบวัดความรู้ /ห้องสอบสัมภาษณ์/พิมพ์ใบสมัคร วันที่
                      21 เมษายน 2568
                    </Text>
                  </Pane>
                </>
              ) : DataRegister[0].REGISTER_STATUS === "2" ? (
                <>
                  <Pane display="flex" flexDirection="column">
                    <Text color="red">หมายเหตุ*</Text>
                    <Text fontSize={"12px"}>
                      1. ประกาศรายชื่อผู้ผ่านการคัดเลือก (ตัวจริงและตัวสำรอง) วันที่ 28 เมษายน 2568
                    </Text>
                  </Pane>
                </>
              ) : DataRegister[0].REGISTER_STATUS === "4" ? (
                <>
                  {/* {DataRegister[0].Major1_MAJOR_ID === "9903" && !AllowPayNurse("") ? (
                    <>
                      <Pane display="flex" flexDirection="column">
                        <Text color="red">หมายเหตุ*</Text>
                        <Text fontSize={"12px"}>
                          1. ผู้ผ่านการคัดเลือก (ตัวจริง)
                          ส่งผลการตรวจร่างกายตามแบบฟอร์มที่มหาวิทยาลัยฯ กำหนด ตั้งแต่วันนี้
                          ถึงวันที่ 2 พฤษภาคม 2568
                        </Text>
                        <Text fontSize={"12px"}>
                          ณ อาคารคณะพยาบาลศาสตร์ มหาวิทยาลัยราชภัฏกำแพงเพชร
                        </Text>
                        <Text fontSize={"12px"}>
                          2. ประกาศรายชื่อผู้มีสิทธิ์เข้าศึกษาภาคปกติ คณะพยาบาลศาสตร์ วันที่ 6
                          พฤษภาคม 2568
                        </Text>
                        <Text fontSize={"12px"}>
                          3. ชำระเงินค่าธรรมเนียมการศึกษาได้ตั้งแต่วันที่ 6 พฤษภาคม 2568 - 8 พฤษภาคม
                          2568
                        </Text>
                        <Text color="red">
                          หากไม่ชำระค่าธรรมเนียมการศึกษาภายในเวลาที่กำหนด จะถือว่าสละสิทธิ์
                        </Text>
                      </Pane> */}
                </>
              ) : (
                <>
                  {/* <Pane display="flex" flexDirection="column">
                        <Text color="red">หมายเหตุ*</Text>
                        <Text fontSize={"12px"}>
                          1.
                          ผู้มีสิทธิ์เข้าศึกษายืนยันสิทธิ์และชำระเงินค่าธรรมเนียมทางการศึกษาได้ตั้งแต่วันที่
                          6 พฤษภาคม 2568 - 8 พฤษภาคม 2568
                        </Text>
                        <Text color="red">
                          หากไม่ชำระค่าธรรมเนียมการศึกษาภายในเวลาที่กำหนด จะถือว่าสละสิทธิ์
                        </Text>
                      </Pane> */}
                </>
              )}
              {/* </> */}
              ) : DataRegister[0].REGISTER_STATUS === "6" ||
              DataRegister[0].REGISTER_STATUS === "9" ? (
              <Pane display="flex" flexDirection="column">
                <Text color="red">หมายเหตุ*</Text>
                <Text fontSize={"12px"}>
                  1. กรอกข้อมูลทะเบียนประวัติ และอัปโหลดเอกสารรายงานตัว ตั้งแต่วันที่ 6 พฤษภาคม
                  2568 - 8 พฤษภาคม 2568
                </Text>
              </Pane>
              ) : (
              <></>
          )}
            </Pane>
          ) : DataRegister[0].ROB_ID === "161" ? (
            <>
              {(DataRegister[0].REGISTER_STATUS === "0" ||
                DataRegister[0].REGISTER_STATUS === "1" ||
                // DataRegister[0].REGISTER_STATUS === "4" ||
                DataRegister[0].REGISTER_STATUS === "2") && (
                  <>
                    <Pane marginTop={10} padding={5} borderRadius={6} backgroundColor="white">
                      <Text
                        fontWeight={600}
                        fontFamily=""
                        fontSize={14}
                        paddingTop={5}
                        marginBottom={10}
                      >
                        รายละเอียดที่สมัคร
                      </Text>
                      <Pane gap={10} flexDirection={"column"}>
                        {ListMajor.map((item, key) => (
                          <>
                            <Pane marginBottom={10} padding={10} borderRadius={8} key={key}>
                              <Pane fontWeight={600}>
                                <Text fontWeight={700} style={{ color: "#fe7f2d" }}>
                                  ลำดับที่ {key + 1}
                                </Text>
                                &nbsp; หลักสูตร
                                {item.Major_LEVEL_OPEN_NAME +
                                  " " +
                                  item.Major_course_year +
                                  " ปี  " +
                                  item.Major_MAJOR_ID +
                                  " : สาขาวิชา" +
                                  item.Major_MAJOR_NAME}
                              </Pane>
                              {DataRegister[0].REGISTER_STATUS === "0" ? (
                                <>
                                  {key + 1 === 1 && (
                                    <Text marginTop={10} marginLeft={15} className="text-warning">
                                      รอการชำระเงินค่าสมัคร
                                    </Text>
                                  )}
                                </>
                              ) : DataRegister[0].REGISTER_STATUS === "1" ? (
                                <>
                                  {key + 1 === 1 ? (
                                    <>
                                      <Pane
                                        display="flex"
                                        hidden={key === 1}
                                        flexDirection={"column"}
                                      >
                                        <div className="d-flex">
                                          <Text fontWeight={600}>วันเวลา :&nbsp; &nbsp;</Text>
                                          <div> {item.Major_MAJOR_CLASSROOM}</div>
                                        </div>
                                        <div className="d-flex">
                                          <Text fontWeight={600}>สถานที่ :&nbsp; &nbsp;</Text>
                                          <div> {item.Major_MAJOR_CLASSROOM2} </div>
                                        </div>
                                      </Pane>
                                    </>
                                  ) : (
                                    <>
                                      {item.Major_MAJOR_ID === "1304" ||
                                        item.Major_MAJOR_ID === "1310" ? (
                                        <>
                                          <Pane display="flex" flexDirection={"column"}>
                                            <div className="d-flex">
                                              <Text fontWeight={600}>วันเวลา :&nbsp; &nbsp;</Text>
                                              <div> {item.Major_MAJOR_CLASSROOM3}</div>
                                            </div>
                                            <div className="d-flex">
                                              <Text fontWeight={600}>สถานที่ :&nbsp; &nbsp;</Text>
                                              <div> {item.Major_MAJOR_CLASSROOM2} </div>
                                            </div>
                                          </Pane>
                                        </>
                                      ) : (
                                        <>ไม่ต้องเข้ารับการสอบสัมภาษณ์</>
                                      )}
                                    </>
                                  )}

                                  <Text
                                    hidden={ListMajor.length !== key + 1}
                                    fontWeight={600}
                                    className="text-danger"
                                  >
                                    {" "}
                                    <br />
                                    หมายเหตุ : ให้ผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์
                                    ศึกษารายละเอียดในประกาศรายชื่อผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์ฯ
                                  </Text>
                                </>
                              ) : DataRegister[0].REGISTER_STATUS === "4" ? (
                                <>
                                  {/* <Pane display="flex" flexDirection="column">
                                <Text color="red">หมายเหตุ*</Text>
                                <Text fontSize={"12px"}>
                                  1.ผู้มีสิทธิ์เข้าศึกษาสามารถยืนยันสิทธิ์
                                  และชำระค่าธรรมเนียมการศึกษาได้ตั้งแต่วันที่ 2 - 7 พฤษภาคม 2568
                                </Text>
                                <Text fontSize={"12px"}>
                                  2.ผู้ที่ได้รับการคัดเลือกเป็นตัวสำรอง มหาวิทยาลัยฯ
                                  จะประกาศผลการคัดเลือก เข้าศึกษาต่อเพิ่มเติมสำหรับทะเบียนสำรอง
                                  (ตัวสำรอง) ในวันพฤหัสบดีที่ 8 พฤษภาคม 2568
                                </Text>
                                <Text color="red">
                                  หากไม่ชำระค่าธรรมเนียมการศึกษาภายในเวลาที่กำหนด
                                  จะถือว่าสละสิทธิ์
                                </Text>
                              </Pane> */}
                                </>
                              ) : (
                                <></>
                              )}
                            </Pane>
                          </>
                        ))}
                      </Pane>
                    </Pane>
                  </>
                )}
            </>
          ) : DataRegister[0].ROB_ID === "162" || DataRegister[0].ROB_ID === "163" ? (
            <>
              {(DataRegister[0].REGISTER_STATUS === "0" ||
                DataRegister[0].REGISTER_STATUS === "1" ||
                DataRegister[0].REGISTER_STATUS === "2") && (
                  <>
                    <Pane marginTop={10} padding={5} borderRadius={6} backgroundColor="white">
                      <Text
                        fontWeight={600}
                        fontFamily=""
                        fontSize={14}
                        paddingTop={5}
                        marginBottom={10}
                      >
                        รายละเอียดที่สมัคร
                      </Text>
                      <Pane gap={10} flexDirection={"column"}>
                        {ListMajor.map((item, key) => (
                          <>
                            <Pane marginBottom={10} padding={10} borderRadius={8} key={key}>
                              <Pane fontWeight={600}>
                                <Text fontWeight={700} style={{ color: "#fe7f2d" }}>
                                  ลำดับที่ {key + 1}
                                </Text>
                                &nbsp; หลักสูตร
                                {item.Major_LEVEL_OPEN_NAME +
                                  " " +
                                  item.Major_course_year +
                                  " ปี  " +
                                  item.Major_MAJOR_ID +
                                  " : สาขาวิชา" +
                                  item.Major_MAJOR_NAME}
                              </Pane>
                              {DataRegister[0].REGISTER_STATUS === "0" ? (
                                <>
                                  {key + 1 === 1 && (
                                    <Text marginTop={10} marginLeft={15} className="text-warning">
                                      รอการชำระเงินค่าสมัคร
                                    </Text>
                                  )}
                                </>
                              ) : DataRegister[0].REGISTER_STATUS === "1" ? (
                                <>
                                  <Text marginTop={10} marginLeft={15} className="text-success">
                                    รอประกาศราชื่อผู้ผ่านการคัดเลือก ในวันที่ 2 พฤษภาคม 2568 เวลา
                                    18.00 น. เป็นต้นไป
                                  </Text>
                                </>
                              ) : (
                                <></>
                              )}
                            </Pane>
                          </>
                        ))}
                      </Pane>
                    </Pane>
                  </>
                )}
              {DataRegister[0].REGISTER_STATUS === "4" && (
                <>
                  {/* <Pane display="flex" flexDirection="column">
                <Text color="red">หมายเหตุ*</Text>

                <Text fontSize={"12px"}>
                  1.ผู้มีสิทธิ์เข้าศึกษาสามารถยืนยันสิทธิ์
                  และชำระค่าธรรมเนียมการศึกษาได้ตั้งแต่วันที่ 2 - 7 พฤษภาคม 2568
                </Text>
                <Text color="red">
                  หากไม่ชำระค่าธรรมเนียมการศึกษาภายในเวลาที่กำหนด จะถือว่าสละสิทธิ์
                </Text>
              </Pane> */}
                </>
              )}
              {(DataRegister[0].REGISTER_STATUS === "6" ||
                DataRegister[0].REGISTER_STATUS === "9") && (
                  <Pane display="flex" flexDirection="column">
                    <Text color="red">หมายเหตุ*</Text>

                    <Text fontSize={"12px"}>
                      1. กรอกข้อมูลทะเบียนประวัติได้ตั้งแต่วันที่ 1 เมษายน - 30 เมษายน 2568
                    </Text>
                  </Pane>
                )}
            </>
          ) : DataRegister[0].ROB_ID === "164" ? (
            <>
              {(DataRegister[0].REGISTER_STATUS === "0" ||
                DataRegister[0].REGISTER_STATUS === "1") && (
                  <>
                    <Pane marginTop={10} padding={5} borderRadius={6} backgroundColor="white">
                      <Text
                        fontWeight={600}
                        fontFamily=""
                        fontSize={14}
                        paddingTop={5}
                        marginBottom={10}
                      >
                        รายละเอียดที่สมัคร
                      </Text>
                      <Pane gap={10} flexDirection={"column"}>
                        {ListMajor.map((item, key) => (
                          <>
                            <Pane marginBottom={10} padding={10} borderRadius={8} key={key}>
                              <Pane fontWeight={600}>
                                <Text fontWeight={700} style={{ color: "#fe7f2d" }}>
                                  ลำดับที่ {key + 1}
                                </Text>
                                &nbsp; หลักสูตร
                                {item.Major_LEVEL_OPEN_NAME +
                                  " " +
                                  item.Major_course_year +
                                  " ปี  " +
                                  item.Major_MAJOR_ID +
                                  " : สาขาวิชา" +
                                  item.Major_MAJOR_NAME}
                              </Pane>
                              {DataRegister[0].REGISTER_STATUS === "0" ? (
                                <>
                                  {key + 1 === 1 && (
                                    <Text marginTop={10} marginLeft={15} className="text-warning">
                                      รอการชำระเงินค่าสมัคร
                                    </Text>
                                  )}
                                </>
                              ) : DataRegister[0].REGISTER_STATUS === "1" ? (
                                <>
                                  {key + 1 === 1 ? (
                                    <>
                                      <Pane
                                        display="flex"
                                        hidden={key === 1}
                                        flexDirection={"column"}
                                      >
                                        <div className="d-flex">
                                          <Text fontWeight={600}>วันเวลา :&nbsp; &nbsp;</Text>
                                          <div> {item.Major_MAJOR_CLASSROOM}</div>
                                        </div>
                                        <div className="d-flex">
                                          <Text fontWeight={600}>สถานที่ :&nbsp; &nbsp;</Text>
                                          <div> {item.Major_MAJOR_CLASSROOM2} </div>
                                        </div>
                                      </Pane>
                                    </>
                                  ) : (
                                    <>
                                      {item.Major_MAJOR_ID === "1304" ||
                                        item.Major_MAJOR_ID === "1310" ? (
                                        <>
                                          <Pane display="flex" flexDirection={"column"}>
                                            <div className="d-flex">
                                              <Text fontWeight={600}>วันเวลา :&nbsp; &nbsp;</Text>
                                              <div> {item.Major_MAJOR_CLASSROOM3}</div>
                                            </div>
                                            <div className="d-flex">
                                              <Text fontWeight={600}>สถานที่ :&nbsp; &nbsp;</Text>
                                              <div> {item.Major_MAJOR_CLASSROOM2} </div>
                                            </div>
                                          </Pane>
                                        </>
                                      ) : (
                                        <>ไม่ต้องเข้ารับการสอบสัมภาษณ์</>
                                      )}
                                    </>
                                  )}

                                  <Text
                                    hidden={ListMajor.length !== key + 1}
                                    fontWeight={600}
                                    className="text-danger"
                                  >
                                    {" "}
                                    <br />
                                    หมายเหตุ : ให้ผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์
                                    ศึกษารายละเอียดในประกาศรายชื่อผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์ฯ
                                  </Text>
                                </>
                              ) : (
                                <></>
                              )}
                            </Pane>
                          </>
                        ))}
                      </Pane>
                    </Pane>
                  </>
                )}
            </>
          ) : DataRegister[0].ROB_ID === "166" ? (
            <>
              <Pane marginTop={10} padding={5} borderRadius={6} backgroundColor="white">
                <Text fontWeight={600} fontFamily="" fontSize={14} paddingTop={5} marginBottom={10}>
                  รายละเอียดที่สมัคร
                </Text>
                <Pane gap={10} flexDirection={"column"}>
                  {ListMajor.map((item, key) => (
                    <>
                      <Pane marginBottom={10} padding={10} borderRadius={8} key={key}>
                        <Pane fontWeight={600}>
                          <Text fontWeight={700} style={{ color: "#fe7f2d" }}>
                            ลำดับที่ {key + 1}
                          </Text>
                          &nbsp; หลักสูตร
                          {item.Major_LEVEL_OPEN_NAME +
                            " " +
                            item.Major_course_year +
                            " ปี  " +
                            item.Major_MAJOR_ID +
                            " : สาขาวิชา" +
                            item.Major_MAJOR_NAME}
                        </Pane>
                        {DataRegister[0].REGISTER_STATUS === "0" ? (
                          <>
                            {key + 1 === 1 && (
                              <Text marginTop={10} marginLeft={15} className="text-warning">
                                รอการชำระเงินค่าสมัคร
                              </Text>
                            )}
                          </>
                        ) : DataRegister[0].REGISTER_STATUS === "1" ? (
                          <>
                            {key + 1 === 1 ? (
                              <>
                                <Pane display="flex" hidden={key === 1} flexDirection={"column"}>
                                  <Text fontWeight={600}>
                                    รอประกาศรายยชื่อผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์ :&nbsp; &nbsp;
                                  </Text>
                                </Pane>
                              </>
                            ) : (
                              <>
                                {item.Major_MAJOR_ID === "1304" ||
                                  item.Major_MAJOR_ID === "1310" ? (
                                  <>
                                    <Pane display="flex" flexDirection={"column"}>
                                      <div className="d-flex">
                                        <Text fontWeight={600}>วันเวลา :&nbsp; &nbsp;</Text>
                                        <div> {item.Major_MAJOR_CLASSROOM3}</div>
                                      </div>
                                      <div className="d-flex">
                                        <Text fontWeight={600}>สถานที่ :&nbsp; &nbsp;</Text>
                                        <div> {item.Major_MAJOR_CLASSROOM2} </div>
                                      </div>
                                    </Pane>
                                  </>
                                ) : (
                                  <>ไม่ต้องเข้ารับการสอบสัมภาษณ์</>
                                )}
                              </>
                            )}

                            <Text
                              hidden={ListMajor.length !== key + 1}
                              fontWeight={600}
                              className="text-danger"
                            >
                              {" "}
                              <br />
                              หมายเหตุ : ให้ผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์
                              ศึกษารายละเอียดในประกาศรายชื่อผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์ฯ
                            </Text>
                          </>
                        ) : (
                          <></>
                        )}
                      </Pane>
                    </>
                  ))}
                </Pane>
              </Pane>
            </>
          ) : DataRegister[0].ROB_ID === "167" ? (
            <>
              <Pane marginTop={10} padding={5} borderRadius={6} backgroundColor="white">
                <Text fontWeight={600} fontFamily="" fontSize={14} paddingTop={5} marginBottom={10}>
                  รายละเอียดที่สมัคร
                </Text>
                <Pane gap={10} flexDirection={"column"}>
                  {ListMajor.map((item, key) => (
                    <>
                      <Pane marginBottom={10} padding={10} borderRadius={8} key={key}>
                        <Pane fontWeight={600}>
                          <Text fontWeight={700} style={{ color: "#fe7f2d" }}>
                            ลำดับที่ {key + 1}
                          </Text>
                          &nbsp; หลักสูตร
                          {item.Major_LEVEL_OPEN_NAME +
                            " " +
                            item.Major_course_year +
                            " ปี  " +
                            item.Major_MAJOR_ID +
                            " : สาขาวิชา" +
                            item.Major_MAJOR_NAME}
                        </Pane>
                        {DataRegister[0].REGISTER_STATUS === "0" ? (
                          <>
                            {key + 1 === 1 && (
                              <Text marginTop={10} marginLeft={15} className="text-warning">
                                รอการชำระเงินค่าสมัคร
                              </Text>
                            )}
                          </>
                        ) : DataRegister[0].REGISTER_STATUS === "1" ? (
                          <>
                            {key + 1 === 1 ? (
                              <>
                                <Pane display="flex" hidden={key === 1} flexDirection={"column"}>
                                  <Text fontWeight={600}>
                                    รอประกาศรายยชื่อผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์ :&nbsp; &nbsp;
                                  </Text>
                                </Pane>
                              </>
                            ) : (
                              <></>
                            )}

                            <Text
                              hidden={ListMajor.length !== key + 1}
                              fontWeight={600}
                              className="text-danger"
                            >
                              {" "}
                              <br />
                              หมายเหตุ : ให้ผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์
                              ศึกษารายละเอียดในประกาศรายชื่อผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์ฯ
                            </Text>
                          </>
                        ) : DataRegister[0].REGISTER_STATUS === "4" ? (
                          <>
                            {" "}
                            {/* <Text
                          hidden={ListMajor.length !== key + 1}
                          fontWeight={600}
                        // className="text-danger"
                        >
                          {" "}
                          <br />
                          หมายเหตุ : ให้ผู้ที่ผ่านการคัดเลือกศึกษารายละเอียดในประกาศ
                        </Text> */}
                          </>
                        ) : DataRegister[0].REGISTER_STATUS === "6" ? (
                          <>
                            กรอกข้อมูลทะเบียนประวัติ และอัปโหลดเอกสารรายงานตัว ที่เมนู
                            รายงานตัวออนไลน์
                          </>
                        ) : (
                          <></>
                        )}
                      </Pane>
                    </>
                  ))}
                </Pane>
              </Pane>
            </>
          ) : DataRegister[0].ROB_ID === "165" ? (
            <>
              <Pane marginTop={10} padding={5} borderRadius={6} backgroundColor="white">
                <Text fontWeight={600} fontFamily="" fontSize={14} paddingTop={5} marginBottom={10}>
                  รายละเอียดที่สมัคร
                </Text>
                <Pane gap={10} flexDirection={"column"}>
                  {ListMajor.map((item, key) => (
                    <>
                      <Pane marginBottom={10} padding={10} borderRadius={8} key={key}>
                        <Pane fontWeight={600}>
                          <Text fontWeight={700} style={{ color: "#fe7f2d" }}>
                            ลำดับที่ {key + 1}
                          </Text>
                          &nbsp; หลักสูตร
                          {item.Major_LEVEL_OPEN_NAME +
                            " " +
                            item.Major_course_year +
                            " ปี  " +
                            item.Major_MAJOR_ID +
                            " : สาขาวิชา" +
                            item.Major_MAJOR_NAME}
                        </Pane>
                        {DataRegister[0].REGISTER_STATUS === "0" ? (
                          <>
                            {key + 1 === 1 && (
                              <Text marginTop={10} marginLeft={15} className="text-warning">
                                รอการชำระเงินค่าสมัคร
                              </Text>
                            )}
                          </>
                        ) : DataRegister[0].REGISTER_STATUS === "1" ? (
                          <>
                            {key + 1 === 1 ? (
                              <>
                                <Pane display="flex" hidden={key === 1} flexDirection={"column"}>
                                  <Text fontWeight={600}>
                                    รอประกาศรายยชื่อผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์ :&nbsp; &nbsp;
                                  </Text>
                                </Pane>
                              </>
                            ) : (
                              <>
                                {item.Major_MAJOR_ID === "1304" ||
                                  item.Major_MAJOR_ID === "1310" ? (
                                  <>
                                    <Pane display="flex" flexDirection={"column"}>
                                      <div className="d-flex">
                                        <Text fontWeight={600}>วันเวลา :&nbsp; &nbsp;</Text>
                                        <div> {item.Major_MAJOR_CLASSROOM3}</div>
                                      </div>
                                      <div className="d-flex">
                                        <Text fontWeight={600}>สถานที่ :&nbsp; &nbsp;</Text>
                                        <div> {item.Major_MAJOR_CLASSROOM2} </div>
                                      </div>
                                    </Pane>
                                  </>
                                ) : (
                                  <>ไม่ต้องเข้ารับการสอบสัมภาษณ์</>
                                )}
                              </>
                            )}

                            <Text
                              hidden={ListMajor.length !== key + 1}
                              fontWeight={600}
                              className="text-danger"
                            >
                              {" "}
                              <br />
                              หมายเหตุ : ให้ผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์
                              ศึกษารายละเอียดในประกาศรายชื่อผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์ฯ
                            </Text>
                          </>
                        ) : (
                          <></>
                        )}
                      </Pane>
                    </>
                  ))}
                </Pane>
              </Pane>
            </>
          ) : DataRegister[0].ROB_ID === "168" ? (
            <>
              <Pane marginTop={10} padding={5} borderRadius={6} backgroundColor="white">
                <Text fontWeight={600} fontFamily="" fontSize={14} paddingTop={5} marginBottom={10}>
                  รายละเอียดที่สมัคร
                </Text>
                <Pane gap={10} flexDirection={"column"}>
                  {ListMajor.map((item, key) => (
                    <>
                      <Pane marginBottom={10} padding={10} borderRadius={8} key={key}>
                        <Pane fontWeight={600}>
                          <Text fontWeight={700} style={{ color: "#fe7f2d" }}>
                            ลำดับที่ {key + 1}
                          </Text>
                          &nbsp; หลักสูตร
                          {item.Major_LEVEL_OPEN_NAME +
                            " " +
                            item.Major_course_year +
                            " ปี  " +
                            item.Major_MAJOR_ID +
                            " : สาขาวิชา" +
                            item.Major_MAJOR_NAME}
                        </Pane>
                        {DataRegister[0].REGISTER_STATUS === "0" ? (
                          <>
                            {key + 1 === 1 && (
                              <Text marginTop={10} marginLeft={15} className="text-warning">
                                รอการชำระเงินค่าสมัคร
                              </Text>
                            )}
                          </>
                        ) : DataRegister[0].REGISTER_STATUS === "1" ? (
                          <>
                            {key + 1 === 1 ? (
                              <>
                                <Pane display="flex" hidden={key === 1} flexDirection={"column"}>
                                  {/* <div className="d-flex">
                                        <Text fontWeight={600}>วันเวลา :&nbsp; &nbsp;</Text>
                                        <div> {item.Major_MAJOR_CLASSROOM}</div>
                                      </div>
                                      <div className="d-flex">
                                        <Text fontWeight={600}>สถานที่ :&nbsp; &nbsp;</Text>
                                        <div> {item.Major_MAJOR_CLASSROOM2} </div>
                                      </div> */}
                                  <Text fontWeight={600}>
                                    รอประกาศรายยชื่อผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์ :&nbsp; &nbsp;
                                  </Text>
                                </Pane>
                              </>
                            ) : (
                              <>
                                {item.Major_MAJOR_ID === "1304" ||
                                  item.Major_MAJOR_ID === "1310" ? (
                                  <>
                                    <Pane display="flex" flexDirection={"column"}>
                                      <div className="d-flex">
                                        <Text fontWeight={600}>วันเวลา :&nbsp; &nbsp;</Text>
                                        <div> {item.Major_MAJOR_CLASSROOM3}</div>
                                      </div>
                                      <div className="d-flex">
                                        <Text fontWeight={600}>สถานที่ :&nbsp; &nbsp;</Text>
                                        <div> {item.Major_MAJOR_CLASSROOM2} </div>
                                      </div>
                                    </Pane>
                                  </>
                                ) : (
                                  <>ไม่ต้องเข้ารับการสอบสัมภาษณ์</>
                                )}
                              </>
                            )}

                            <Text
                              hidden={ListMajor.length !== key + 1}
                              fontWeight={600}
                              className="text-danger"
                            >
                              {" "}
                              <br />
                              หมายเหตุ : ให้ผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์
                              ศึกษารายละเอียดในประกาศรายชื่อผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์ฯ
                            </Text>
                          </>
                        ) : (
                          <></>
                        )}
                      </Pane>
                    </>
                  ))}
                </Pane>
              </Pane>
            </>
          ) : (
            <></>
          )}
        </Pane>
      </div >
    ))
  );
}

export default StatusDisplay;
